import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { MatTabGroup } from '@angular/material';
import { Router } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';
import { TravelerComponent } from '../traveler/traveler.component';
import { EMLINK } from 'constants';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-special-program',
  templateUrl: './special-program.component.html',
  styleUrls: ['./special-program.component.css']
})
export class SpecialProgramComponent implements OnInit {

  showTravelerTable = true;
  mainTraveler = '';
  no = '';
  toDelete = [];
  selectedTab = 0;

  //Tables & Data:
  private add_depend_list = [];
  // private add_bus_list = [];
  private add_visa_list = [];
  private add_hotel_list = [];
  private detail = [];
  private flight_price = [];

  dependDataSource = new MatTableDataSource(this.add_depend_list);
  // busDataSource = new MatTableDataSource(this.add_bus_list);
  visaDataSource = new MatTableDataSource(this.add_visa_list);
  hotelDataSource = new MatTableDataSource(this.add_hotel_list);
  detailDataSource = new MatTableDataSource(this.detail);
  flightDataSource = new MatTableDataSource(this.flight_price);
  @ViewChild(MatSort) sort: MatSort;

  dependDisplayedColumns = ['acct_number', 'customer_name', 'national_id', 'mobile', 'passport_no',
    'traveler_type', 'relative_relation', 'comment', 'del'];
  // busDisplayedColumns = ['bus_no', 'male_seat_count', 'depart_date', 'from_city_name', 'to_city_name',
  //   'seat_price', 'bus_total', 'edit', 'del'];

  flightDisplayedColumns = ['type', 'count', 'price_w_tax', 'taxable_price', 'price', 'cost', 'discount', 
    'tax', 'total'];
  visaDisplayedColumns = ['country_name', 'visa_count', 'visa_price', 'visa_total', 'discount', 'tax',
    'total_amount', 'edit', 'del'];
  hotelDisplayedColumns = ['city_name', 'hotel_name', 'room_type', 'room_count', 'room_price',
    'hotel_total', 'discount', 'tax', 'total_amount', 'edit', 'del'];
  detailDisplayedColumns = ['type', 'count', 'price', 'discount', 'tax', 'total', 'comment'];

  addDialogRef: MatDialogRef<TravelerComponent>;

  //Models:   , 'bus_return_date': new Date()

  model = {
    'chx_addDepend': '0', 'depend_no': '', 'comment': '', 'depend_count': '',
    'trans_type': 'flight', 'ticket_type': 'return', 'departure_date': new Date(), 'arrival_date': new Date(),
    'to_airport': '', 'airline_id': '', 'tax_no': '', 'bus_dep_date': new Date(), 'bus_return_date': new Date(),
    'total_amount': '', 'no_tax_total': '', 'total_discount': '', 'total_taxable': '', 'total_tax': '', 
    'total_w_tax': '', 'no_tax': '', 'pass_count': '', 'checkin_date': new Date(), 
    'checkout_date': new Date(), 'has_cash_receipt': 0, 'old_total_amount': 0, 'total_visa_tax': '0', 
    'final_visa_total': '0', 'total_hotel_tax': '0', 'final_hotel_total': '0', 'invoice_date': new Date()        
  };

  ticket_model = {
    'table_name': 'reg_on_ticket', 'reg_ticket_id': '0', 'ticket_type': 'return', 'invoice_no': '0', 
    'depart_date': '', 'return_date': '', 'flag': 'new', 'key': 'reg_ticket_id', 'from_airport': '0', 
    'to_airport': '0', 'airline_id': '0', 'comment': '', 'adult_count': '', 'child_count': '', 
    'infant_count': '', 'adult_price': '0', 'child_price': '0', 'infant_price': '0', 'adult_cost': '0', 
    'child_cost': '0', 'infant_cost': '0', 'adult_discount': '0', 'child_discount': '0', 
    'infant_discount': '0', 'tax_type': 'all_price', 'tax_no': '',
    'adult_tax_amount': '0', 'child_tax_amount': '0', 'infant_tax_amount': '0', 'infant_part_price': '0',
    'adult_part_price': '0', 'child_part_price': '0', 'infant_price_w_tax': '0', 'adult_price_w_tax': '0',
    'child_price_w_tax': '0', 'adult_total_price': '0', 'child_total_price': '0', 'infant_total_price': '0',
    'adult_comment': '', 'child_comment': '', 'infant_comment': ''
  }

  bus_model = {
    'table_name': 'reg_on_bus', 'reg_bus_id': '0', 'trip_bus_id': '0', 'bus_id': '0', 'depart_date': '',
    'return_date': '', 'flag': 'new', 'key': 'reg_bus_id', 'from_city': '0', 'to_city': '0', 'invoice_no': '',
    'comment': '', 'male_seat_count': '0', 'female_seat_count': '0', 'addition_count': '0', 'price_w_tax': '0',
    'seat_price': '', 'seat_cost': '0', 'discount':'0', 'bus_total': '', 'tax_type': 'all_price', 'tax_no': '',
    'taxable_price': '0', 'tax': '0', 'total_amount': '', 'seat_tax_amount': '', 'taxable_with_tax': '0'
  }

  visa_model = {
    'table_name': 'reg_on_visa', 'reg_visa_id': '0', 'invoice_no': '', 'visa_tax_amount': '0',
    'country_id': '', 'country_name': '', 'visa_count': '0', 'visa_price': '', 'visa_cost': '0', 
    'discount':'0', 'visa_total': '', 'tax_no': '', 'tax_type': 'all_price', 'taxable_price': '0', 
    'tax': '0', 'total_amount': '', 'flag': 'new', 'key': 'reg_visa_id', 'comment': '', 'index': '0',
    'price_w_tax': '0', 'taxable_with_tax': '0'
  }

  hotel_model = {
    'table_name': 'reg_on_hotel', 'reg_id': '0', 'invoice_no': '', 'room_type_id': '', 
    'flag': 'new', 'key': 'reg_id', 'comment': '', 'city_id': '0', 'hotel_id': '', 'room_count': '0',
    'room_price': '0', 'room_cost': '0', 'discount':'0', 'hotel_total': '', 'package': '', 'city_name': '', 
    'room_type': '', 'hotel_name': '', 'room_tax_amount': '0', 'tax_no': '', 'tax_type': 'all_price', 
    'taxable_price': '0', 'tax': '0', 'total_amount': '', 'checkin_date': '', 'checkout_date': '', 
    'index': '0', 'price_w_tax': '0', 'taxable_with_tax': '0'
  }

  invoice_model = {
    'table_name': 'invoice', 'invoice_id': '0', 'invoice_no': '', 'invoice_date': '0000-00-00',
    'customer_no': '', 'customer_name': '', 'calc_tax': '0', 'print_tax': '1', 'total': '', 'tax': '0',
    'discount': '0', 'rep_emp_no': '0', 'deliver_date': '0000-00-00', 'payment_date': '0000-00-00',
    'invoice_type': 'special_prog', 'cond_list_id': '0', 'transport_fee': '0', 'received_by': '',
    'is_paid': '0', 'status': '1', 'cost_center': '0', 'sales_acct': '0', 'acct_number': '0', 'flag': 'new',
    'key': 'invoice_id', 'qutation_no': '', 'tax_acct': '0', 'trans_acct': '0', 'payment_method': '',
    'comment': '', 'meter_reading': '', 'worker': '', 'group_number': '', 'trip_id': '0', 'pnr': '',
    'pass_count': '', 'bed_count': '0', 'seat_count': '0', 'agent_acct_number': '0', 'year': '', 'total_no_tax': '0',
    'branch_id': this.applicationConstants.user_branch_info.user_branch_id, 'no': '0',
    'store_id': '0', 'invoice_uuid': ''
  };

  invoice_item_model = { 
    'table_name': 'invoice_item', 'invoice_no': '', 'invoice_date': '0000-00-00',
    'sub_item_number': '0', 'sub_item_name': '', 'price': '0', 'unit_id': '0', 'count': '',
    'total_price': '0', 'tax_no': '', 'invoice_item_id': '0', 'tax_amount': '0', 'type': 'p',
    'flag': 'new', 'key': 'invoice_item_id', 'discount': '0', 'cost': '0', 'stock_no': '0', 'store_id': '0',
    'primary_sub_item_number': '', 'primary_quantity': '0', 'comment': '', 'revenue_acct_no': '0'
  }

  inv_payment_model = {
    'table_name': 'inv_payment_method', 'invoice_no': '', 'inv_payment_method_id': '0', 'flag': 'new',
    'key': 'inv_payment_method_id', 'payment_type_id': '2', 'acct_number': '', 'amount': ''
  }

  group_model = {
    'table_name': 'trip_group', 'group_id': '0', 'invoice_no': '', 'head_id': '', 'member_id': '',
    'member_head_relation': '', 'is_active': '1', 'group_type': '', 'trip_arrival_date': '', 'trip_depart_date': '',
    'eticket': '', 'ticket_status': '0', 'ticket_count': '0', 'bed_count': '0', 'price': '0', 'room_type_id': '',
    'flag': 'new', 'key': 'group_id', 'comment': ''
  };

  ext_model = {
    'ext_amount': '', 'amount_comment': '', 'discount': '0', 'tax_no': '', 'tax_type': 'all_price', 
    'ext_w_tax': '0', 'tax_amount': '0', 'cost': '0'
  }

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, private route: ActivatedRoute, private router: Router,
    public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  //Search Objects:
  search_traveler = {
    'placeholder': 'رقم المسافر/ اسم المسافر/ رقم الجوال', 'class_name': 'longField',
    'table_list': [{
      'table_name': '`customer`', 'selected_no': 'acct_number',
      'field_list': ['acct_number', 'customer_name', 'customer_name_en', 'mobile'],
      'join_table': '`traveler_info`',
      'join_condition': " AND (`customer`.`branch_id` = '" + this.invoice_model['branch_id'] +
      "' OR `customer`.`branch_id` = '0') AND `customer`.`agent_acct_number` = '' AND `customer`.`acct_number` = `traveler_info`.`acct_number`"
    }]
  };

  search_airport = {
    'placeholder': 'اسم المطار', 'class_name': 'tdSearchField',
    'table_list': [{
      'table_name': 'airport', 'selected_no': 'airport_id',
      'field_list': ['airport_name', 'airport_name_en', 'airport_code']
    }]
  };

  search_airline = {
    'placeholder': 'اسم الشركة', 'class_name': 'tdSearchField',
    'table_list': [{
      'table_name': 'airline', 'selected_no': 'airline_id',
      'field_list': ['airline_name', 'airline_name_en']
    }]
  };

  search_tax = {
    'placeholder': 'رقم الضريبة/ اسم الضريبة', 'class_name': 'longField',
    'table_list': [{
      'table_name': '`tax`', 'selected_no': 'acct_number',
      'field_list': ['acct_number', 'tax_name_ar', 'tax_name_en']
    }]
  };

  search_city = {
    'placeholder': 'اسم المدينة', 'class_name': 'tdSearchField',
    'table_list': [{
      'table_name': '`city`', 'selected_no': 'city_id',
      'field_list': ['city_name', 'city_name_en']
    }]
  };

  search_cc = {
    'placeholder': 'مركز التكلفة (الرئيسي)', 'class_name': 'longSearchField',
    'table_list': [{
      'table_name': '`cost_center`', 'selected_no': 'cc_id',
      'field_list': ['cc_name', 'cc_name_en']
    }]
  };

  //Select Lists:
  // airport_list = [];
  firstVisit = true;
  invCondList = [];
  bus_list = [];
  country_list = [];
  city = [];
  all_hotel = [];
  hotel_list = [];
  room_list = [];

  main_trav_info = { 'customer_name': '' };
  traveler_list = [];
  from_airport_detail = '';
  to_airport_detail = '';
  airline_detail = '';
  bus_tax_detail = '';
  ticket_tax_detail = '';
  ext_tax_detail = '';
  visa_tax_detail = '';
  room_tax_detail = '';
  cc_detail = '';

  adult_count = 0;
  child_count = 0;
  infant_count = 0;

  adult_taxable = 0;
  child_taxable = 0;
  infant_taxable = 0;

  revenue_acct_no = '0';
  ticket_tax = {};
  bus_tax = {};
  visa_tax = {};
  hotel_tax = {};
  ext_tax = {};

  cityDetail = '';
  from_ctity_detail = '';
  to_ctity_detail = '';
  cond_list_id = '0';

  showVisaTax = true;
  showRoomTax = true;
  saveClicked = false;

  //Translate:
  Traveler_Placeholder; Airport_Name; Airline_Name;
  Tax_Placeholder; City_Name;
  Depend_Msg; Bus_Msg; Country_Msg; City_Msg;
  Success_Msg; Error_Msg; Inv_No_Msg; Main_Traveler_Msg;
  Depend_Num_Msg; From_Airport_Msg; To_Airport_Msg;
  Dep_Date_Msg; Ret_Date_Msg; From_City_Msg;
  To_City_Msg; Seat_Count_Msg; Without; Tax_Msg;
  Transportation; Visas; Residence; Ext_Amount;
  Ticket_Sub_Item; Adult; Child; Infant; Bus_Sub_Item; Additional_Amount;
  CC_Placeholder;

  getMessages(translate) {

    translate.get('Traveler_Placeholder').subscribe((res: string) => {
      this.Traveler_Placeholder = res;
    });
    this.search_traveler['placeholder'] = this.Traveler_Placeholder;

    translate.get('Airport_Name').subscribe((res: string) => {
      this.Airport_Name = res;
    });
    this.search_airport['placeholder'] = this.Airport_Name;

    translate.get('Airline_Name').subscribe((res: string) => {
      this.Airline_Name = res;
    });
    this.search_airline['placeholder'] = this.Airline_Name;

    translate.get('Tax_Placeholder').subscribe((res: string) => {
      this.Tax_Placeholder = res;
    });
    this.search_tax['placeholder'] = this.Tax_Placeholder;

    translate.get('City_Name').subscribe((res: string) => {
      this.City_Name = res;
    });
    this.search_city['placeholder'] = this.City_Name;

    translate.get('Depend_Msg').subscribe((res: string) => {
      this.Depend_Msg = res;
    });

    translate.get('Bus_Msg').subscribe((res: string) => {
      this.Bus_Msg = res;
    });

    translate.get('Country_Msg').subscribe((res: string) => {
      this.Country_Msg = res;
    });

    translate.get('City_Msg').subscribe((res: string) => {
      this.City_Msg = res;
    });

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Inv_No_Msg').subscribe((res: string) => {
      this.Inv_No_Msg = res;
    });

    translate.get('Main_Traveler_Msg').subscribe((res: string) => {
      this.Main_Traveler_Msg = res;
    });

    translate.get('Depend_Num_Msg').subscribe((res: string) => {
      this.Depend_Num_Msg = res;
    });

    translate.get('From_Airport_Msg').subscribe((res: string) => {
      this.From_Airport_Msg = res;
    });

    translate.get('To_Airport_Msg').subscribe((res: string) => {
      this.To_Airport_Msg = res;
    });

    translate.get('Dep_Date_Msg').subscribe((res: string) => {
      this.Dep_Date_Msg = res;
    });

    translate.get('Ret_Date_Msg').subscribe((res: string) => {
      this.Ret_Date_Msg = res;
    });

    translate.get('From_City_Msg').subscribe((res: string) => {
      this.From_City_Msg = res;
    });

    translate.get('To_City_Msg').subscribe((res: string) => {
      this.To_City_Msg = res;
    });

    translate.get('Seat_Count_Msg').subscribe((res: string) => {
      this.Seat_Count_Msg = res;
    });

    translate.get('Without').subscribe((res: string) => {
      this.Without = res;
    });

    translate.get('Tax_Msg').subscribe((res: string) => {
      this.Tax_Msg = res;
    });

    translate.get('Transportation').subscribe((res: string) => {
      this.Transportation = res;
    });

    translate.get('Visas').subscribe((res: string) => {
      this.Visas = res;
    });

    translate.get('Residence').subscribe((res: string) => {
      this.Residence = res;
    });

    translate.get('Ext_Amount').subscribe((res: string) => {
      this.Ext_Amount = res;
    });

    translate.get('Ticket_Sub_Item').subscribe((res: string) => {
      this.Ticket_Sub_Item = res;
    });

    translate.get('Adult').subscribe((res: string) => {
      this.Adult = res;
    });

    translate.get('Child').subscribe((res: string) => {
      this.Child = res;
    });

    translate.get('Infant').subscribe((res: string) => {
      this.Infant = res;
    });
    
    translate.get('Bus_Sub_Item').subscribe((res: string) => {
      this.Bus_Sub_Item = res;
    });
    
    translate.get('Additional_Amount').subscribe((res: string) => {
      this.Additional_Amount = res;
    });

    translate.get('CC_Placeholder').subscribe((res: string) => {
      this.CC_Placeholder = res;
    });
    this.search_cc['placeholder'] = this.CC_Placeholder;

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

  }

  ngOnInit() {

    let obj;
    let parent_acct = this.applicationConstants.main_acct_config['income_acct'];
    obj = { cmd: 'getAccountList', parent_acct: parent_acct, add_leaf: true, only_leaf: true };
    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        console.log(data.data['list']);
        if (data.data['list'].length > 0)
          this.revenue_acct_no = data.data['list'][0]['acct_number'];
      });

    //------------------------ Get All Select lists ------------------------//
    let query;

    query = this.queryList.all_invCondList + " AND (`branch_id` = '0' OR `branch_id` = '" + 
      this.applicationConstants.user_branch_info.user_branch_id + "')";
    obj = { cmd: 'getList', query: query };
    
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.invCondList = data.data['list'];

        let selObj = { 'cond_list_id': '0', 'list_name': 'اختر', 'list_name_en': 'Select' };
        this.invCondList.unshift(selObj);

        query = "SELECT `cond_list_id` FROM `def_inv_cond_list` WHERE `branch_id` = '" + 
          this.invoice_model['branch_id'] + "' AND `invoice_type_key` = 'normal_credit_invoice'"; // + condition;
        obj = { cmd: 'getList', query: query };
        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();

            if (data.data['list'].length > 0) {
              this.cond_list_id = data.data['list'][0]['cond_list_id'];
              this.invoice_model['cond_list_id'] = this.cond_list_id;
            }
          });
      });

    

    // query = "SELECT * FROM `airport` WHERE `status` = '1'";
    // obj = { cmd: 'getList', query: query };
    // this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //   .subscribe(data => {
    //     this.applicationConstants.appComp.hideBusyCursor();
    //     this.airport_list = data.data['list'];
    //   });

    query = "SELECT * FROM `bus` WHERE `status` = '1'";
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.bus_list = data.data['list'];
      });

    query = this.queryList.all_country;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.country_list = data.data['list'];
      });

    query = this.queryList.all_city;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.city = data.data['list'];
      });

    query = "SELECT * FROM `hotel` WHERE `status` = '1'";
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.all_hotel = data.data['list'];
        // this.getHotel();
      });

    query = "SELECT * FROM `room_type` WHERE `status` = '1'";
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.room_list = data.data['list'];
        this.room_list.unshift({ 'room_type_id': '0', 'room_type': 'بدون' });
      });

    this.route.params.subscribe(params => {
      //------------------------ Edit Mode ------------------------//

      if (params['no'] != undefined) {
        this.no = params['no'];
        this.getSpecProg();
      }
      else {
        let user_id = this.applicationConstants.user_info['user_id'];

        //get store list:
        let query = "SELECT `store`.* FROM `store`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
          " `store`.`branch_id` AND `store`.`status` = '1' AND `branch_auth`.`status` = '1' AND" +
          " `branch_auth`.`branch_id` = '" + this.applicationConstants.user_branch_info.user_branch_id +
          "' AND `branch_auth`.`user_id` = '" + user_id + "' AND `branch_auth`.`store_id` = `store`.`store_id`";

        let obj = { cmd: 'getList', query: query };
        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();

            let store_list = [];
            store_list = data.data['list'];
            this.invoice_model['store_id'] = store_list['0']['store_id'];
          });
      }
    });

  }

  //-------********************** EDIT **********************-------//

  getSpecProg() {
    let query, obj;
    obj = { cmd: 'getContractDetail', invoice_no: this.no };

    this.utils.invokeHttp(this.applicationConstants.tourismFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        if (data.status['type'] == 'error') 
          alert(this.applicationConstants.user_lang == 'ar' ? data.status['msg'][0]['msg_ar'] : data.status['msg'][0]['msg_en']);

        else if (data.status['type'] == 'success') {
          let result = data.status['msg'][0];

          //------------------------ Invoice ------------------------//
          let invoice_info = result['invoice_info'];

          this.invoice_model = {
            'table_name': 'invoice', 'invoice_id': invoice_info['invoice_id'],
            'invoice_no': invoice_info['invoice_no'], 'invoice_date': invoice_info['invoice_date'],
            'customer_no': invoice_info['customer_no'], 'customer_name': invoice_info['customer_name'],
            'calc_tax': invoice_info['calc_tax'], 'print_tax': invoice_info['print_tax'],
            'total': invoice_info['total'], 'tax': invoice_info['tax'],
            'discount': invoice_info['discount'], 'rep_emp_no': invoice_info['rep_emp_no'],
            'deliver_date': invoice_info['deliver_date'], 'payment_date': invoice_info['payment_date'],
            'invoice_type': invoice_info['invoice_type'], 'cond_list_id': invoice_info['cond_list_id'],
            'transport_fee': invoice_info['transport_fee'], 'received_by': invoice_info['received_by'],
            'is_paid': invoice_info['is_paid'], 'status': '1',
            'cost_center': invoice_info['cost_center'], 'sales_acct': invoice_info['sales_acct'],
            'acct_number': invoice_info['acct_number'], 'flag': 'update', 'key': 'invoice_id',
            'qutation_no': invoice_info['qutation_no'], 'tax_acct': invoice_info['tax_acct'],
            'trans_acct': invoice_info['trans_acct'], 'payment_method': invoice_info['payment_method'],
            'comment': invoice_info['comment'], 'meter_reading': invoice_info['meter_reading'],
            'worker': invoice_info['worker'], 'group_number': invoice_info['group_number'],
            'trip_id': invoice_info['trip_id'], 'pnr': invoice_info['pnr'],
            'pass_count': invoice_info['pass_count'], 'bed_count': invoice_info['bed_count'],
            'seat_count': invoice_info['seat_count'], 'agent_acct_number': invoice_info['agent_acct_number'],
            'branch_id': invoice_info['branch_id'], 'store_id': invoice_info['store_id'],
            'no': invoice_info['no'], 'year': invoice_info['year'],
            'total_no_tax': invoice_info['total_no_tax'], 'invoice_uuid': invoice_info['invoice_uuid']
          };

          if (invoice_info['cond_list_id'] == '0' && this.cond_list_id != '0') 
            this.invoice_model['cond_list_id'] = this.cond_list_id;

          this.model['invoice_date'] = new Date(invoice_info['invoice_date']);
          if (invoice_info['cost_center'] != '0')
            this.cc_detail = invoice_info['cc_name'] + " - " + invoice_info['cc_name_en'];
  
          this.model['total_w_tax'] = ((Number(this.invoice_model['total']) -
            Number(this.invoice_model['discount'])) + Number(this.invoice_model['tax'])).toFixed(2);
  
          this.model['old_total_amount'] = Number(((Number(this.invoice_model['total']) -
            Number(this.invoice_model['discount'])) + Number(this.invoice_model['tax'])).toFixed(2));
  
          this.model['depend_count'] = String(Number(invoice_info['pass_count']) - 1);

          //------------------------ Invoice Item ------------------------//
          let invoice_item = result['invoice_item'];
          invoice_item.forEach(element => {
            element.flag = 'delete';
            element.table_name = 'invoice_item';
            this.toDelete.push(element);

            if (element.type == 'sa') {
              this.ext_model['ext_amount'] = element.price;
              this.ext_model['discount'] = element.discount;
              this.ext_model['tax_amount'] = element.tax_amount; 
              this.ext_model['amount_comment'] = element.sub_item_name;
              this.ext_model['cost'] = element.cost;

              if (element.tax_no != '' && element.tax_no != '0') {
                this.ext_model['tax'] = element.tax_amount;
                this.ext_model['tax_no'] = element.tax_no;
                this.ext_model['ext_w_tax'] = (Number(element.price) + Number(element.tax_amount)).toFixed(2);
              }
              else
                this.ext_model['tax_type'] = 'no_tax';

              if (this.ext_model['tax_no'] != '' && this.ext_model['tax_no'] != '0') {
                query = "SELECT `tax`.* FROM `tax` WHERE `tax`.`acct_number` = '" + this.ext_model['tax_no'] +
                  "' AND `tax`.`status` = '1'";
                obj = { cmd: 'getList', query: query };

                this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                  .subscribe(data => {
                    this.applicationConstants.appComp.hideBusyCursor();

                    if (data.data['list'].length > 0) {
                      this.ext_tax = data.data['list'][0];
                      this.ext_tax_detail = this.ext_tax['acct_number'] + ' - ' + this.ext_tax['tax_name_ar'] +
                        ' - ' + this.ext_tax['tax_name_en'];
                    }
                  });
              }
            }
          });


          //------------------------ Payment Method ------------------------//
          if (result['payment_method'].length > 0) {
            let inv_payment_method = result['payment_method'][0];
            this.inv_payment_model['inv_payment_method_id'] = inv_payment_method['inv_payment_method_id'];
            this.inv_payment_model['flag'] = 'update';
          }

          //------------------------ Trip Group ------------------------//
          let trip_group = result['trip_group'];
          if (trip_group.length > 1) {
            this.model['chx_addDepend'] = '1';
            (document.getElementById('chx_addDepend') as HTMLInputElement).checked = true;
            this.model['depend_count'] = String(trip_group.length - 1);
          }

          let birthdate, timeDiff, age;

          trip_group.forEach(element => {

            if (element.member_age != -1) 
              age = Number(element.member_age);
            else {
              birthdate = new Date(element['date_of_birth']);
              timeDiff = Math.abs(Date.now() - birthdate.getTime());
              age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365.25);
            }
            
            if (age >= 12)
              this.adult_count += 1;
            else if (age < 12 && age > 2)
              this.child_count += 1;
            else if (age <= 2)
              this.infant_count += 1;

            if (element.head_id == element.member_id) {
              this.main_trav_info = element;
              this.mainTraveler = element['acct_number'] + '-' + element['customer_name'] + '-' +
                element['customer_name_en'] + '-' + element['mobile'];

              (document.getElementById('search_value_1') as HTMLInputElement).disabled = true;

              this.traveler_list.unshift({
                'acct_number': element['acct_number'], 'customer_name': element['customer_name'],
                'customer_name_en': element['customer_name_en'] + " " + element['customer_last_name'],
                'national_id': element['national_id'], 'mobile': element['mobile'],
                'passport_no': element['passport_no'], 'traveler_type': 'رئيسي', 'comment': element.group_comment,
                'type': 'main', 'age': age, 'relative_relation': element.member_head_relation,
                'index': this.traveler_list.length, 'departure_date': element.trip_depart_date,
                'arrival_date': element.trip_arrival_date, 'room_type_id': element.room_type_id,
                'price': element.price, 'group_id': element.group_id, 'flag': 'update', 'key': 'group_id',
                'invoice_no': this.no, 'table_name': 'trip_group', 'bed_count': element.bed_count,
                'ticket_count': element.ticket_count
              });
            }
            else {
              this.add_depend_list.push({
                'acct_number': element['acct_number'], 'customer_name': element['customer_name'],
                'customer_name_en': element['customer_name_en'] + " " + element['customer_last_name'],
                'national_id': element['national_id'], 'mobile': element['mobile'],
                'passport_no': element['passport_no'], 'traveler_type': 'تابع', 'comment': element.group_comment,
                'type': 'depend', 'age': age, 'relative_relation': element.member_head_relation,
                'index': this.add_depend_list.length, 'departure_date': element.trip_depart_date,
                'arrival_date': element.trip_arrival_date, 'room_type_id': element.room_type_id,
                'price': element.price, 'group_id': element.group_id, 'invoice_no': this.no,
                'table_name': 'trip_group'
              });

              this.traveler_list.push({
                'acct_number': element['acct_number'], 'customer_name': element['customer_name'],
                'national_id': element['national_id'], 'mobile': element['mobile'],
                'passport_no': element['passport_no'], 'traveler_type': 'تابع',
                'comment': element.group_comment, 'flag': 'update', 'key': 'group_id',
                'type': 'depend', 'age': age, 'relative_relation': element.member_head_relation,
                'index': this.traveler_list.length, 'departure_date': element.trip_depart_date,
                'arrival_date': element.trip_arrival_date, 'room_type_id': element.room_type_id,
                'price': element.price, 'group_id': element.group_id, 'invoice_no': this.no,
                'bed_count': element.bed_count, 'ticket_count': element.ticket_count
              });
            }
          });
          this.dependDataSource = new MatTableDataSource(this.add_depend_list);
          this.dependDataSource.sort = this.sort;


          //------------------------ Reg on Ticket ------------------------//
          if (result['reg_on_ticket'].length > 0) {
            this.model['trans_type'] = 'flight';
            let reg_on_ticket = result['reg_on_ticket'][0];

            this.model['departure_date'] = new Date(reg_on_ticket['depart_date']);
            this.ticket_model['ticket_type'] = reg_on_ticket['ticket_type'];
            if (reg_on_ticket['ticket_type'] != 'one_way')
              this.model['arrival_date'] = new Date(reg_on_ticket['return_date']);

            this.ticket_model = {
              'table_name': 'reg_on_ticket', 'reg_ticket_id': reg_on_ticket['reg_ticket_id'],
              'ticket_type': reg_on_ticket['ticket_type'], 'invoice_no': reg_on_ticket['invoice_no'],
              'depart_date': reg_on_ticket['depart_date'], 'flag': 'update', 'key': 'reg_ticket_id',
              'from_airport': reg_on_ticket['from_airport'], 'to_airport': reg_on_ticket['to_airport'],
              'airline_id': reg_on_ticket['airline_id'], 'comment': reg_on_ticket['comment'],
              'adult_count': reg_on_ticket['adult_count'], 'child_count': reg_on_ticket['child_count'],
              'infant_count': reg_on_ticket['infant_count'], 'adult_price': reg_on_ticket['adult_price'],
              'child_price': reg_on_ticket['child_price'], 'infant_price': reg_on_ticket['infant_price'],
              'adult_cost': reg_on_ticket['adult_cost'], 'child_cost': reg_on_ticket['child_cost'],
              'infant_cost': reg_on_ticket['infant_cost'], 
              'adult_discount': Number(reg_on_ticket['adult_discount']).toFixed(2), 
              'child_discount': Number(reg_on_ticket['child_discount']).toFixed(2), 
              'infant_discount': Number(reg_on_ticket['infant_discount']).toFixed(2), 'tax_type': reg_on_ticket['tax_type'],
              'tax_no': reg_on_ticket['tax_no'], 'adult_tax_amount': reg_on_ticket['adult_tax_amount'],
              'child_tax_amount': reg_on_ticket['child_tax_amount'], 'infant_tax_amount': reg_on_ticket['infant_tax_amount'],
              'return_date': reg_on_ticket['return_date'], 'adult_part_price': reg_on_ticket['adult_part_price'],
              'child_part_price': reg_on_ticket['child_part_price'], 'infant_part_price': reg_on_ticket['infant_part_price'],
              'infant_price_w_tax': (reg_on_ticket['tax_type'] != 'no_tax' ? (Number(reg_on_ticket['infant_price']) + (Number(reg_on_ticket['infant_count']) > 1 ? (Number(reg_on_ticket['infant_tax_amount']) / Number(reg_on_ticket['infant_count'])) : Number(reg_on_ticket['infant_tax_amount']))).toFixed(2) : '0'), 
              'adult_price_w_tax': (reg_on_ticket['tax_type'] != 'no_tax' ? (Number(reg_on_ticket['adult_price']) + (Number(reg_on_ticket['adult_count']) > 1 ? (Number(reg_on_ticket['adult_tax_amount']) / Number(reg_on_ticket['adult_count'])) : Number(reg_on_ticket['adult_tax_amount']))).toFixed(2) : '0'), 
              'child_price_w_tax': (reg_on_ticket['tax_type'] != 'no_tax' ? (Number(reg_on_ticket['child_price']) + (Number(reg_on_ticket['child_count']) > 1 ? (Number(reg_on_ticket['child_tax_amount']) / Number(reg_on_ticket['child_count'])) : Number(reg_on_ticket['child_tax_amount']))).toFixed(2) : '0'), 
              'adult_total_price': ((Number(reg_on_ticket['adult_price']) * Number(reg_on_ticket['adult_count'])) - Number(reg_on_ticket['adult_discount']) + Number(reg_on_ticket['adult_tax_amount'])).toFixed(2), 
              'child_total_price': ((Number(reg_on_ticket['child_price']) * Number(reg_on_ticket['child_count'])) - Number(reg_on_ticket['child_discount']) + Number(reg_on_ticket['child_tax_amount'])).toFixed(2), 
              'infant_total_price': ((Number(reg_on_ticket['infant_price']) * Number(reg_on_ticket['infant_count'])) - Number(reg_on_ticket['infant_discount']) + Number(reg_on_ticket['infant_tax_amount'])).toFixed(2), 
              'adult_comment': reg_on_ticket['adult_comment'], 'child_comment': reg_on_ticket['child_comment'], 
              'infant_comment': reg_on_ticket['infant_comment']
            }
            this.adult_count = Number(this.ticket_model['adult_count']);
            this.child_count = Number(this.ticket_model['child_count']);
            this.infant_count = Number(this.ticket_model['infant_count']);

            this.from_airport_detail = reg_on_ticket['from_airport_name'] +
              (reg_on_ticket['from_airport_name_en'] != '' ? " - " + reg_on_ticket['from_airport_name_en'] : '');

            this.to_airport_detail = reg_on_ticket['to_airport_name'] +
              (reg_on_ticket['to_airport_name_en'] != '' ? " - " + reg_on_ticket['to_airport_name_en'] : '');

            this.airline_detail = reg_on_ticket['airline_name'] +
              (reg_on_ticket['airline_name_en'] != '' ? " - " + reg_on_ticket['airline_name_en'] : "");

            if (this.ticket_model['tax_no'] != '' && this.ticket_model['tax_no'] != '0') {
              query = "SELECT * FROM `tax` WHERE `acct_number` = '" + this.ticket_model['tax_no'] + "'";
              obj = { cmd: 'getList', query: query };

              this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                .subscribe(data => {
                  this.applicationConstants.appComp.hideBusyCursor();

                  if (data.data['list'].length > 0) {
                    this.ticket_tax = data.data['list'][0];
                    this.ticket_tax_detail = this.ticket_tax['acct_number'] + ' - ' + this.ticket_tax['tax_name_ar'] +
                      ' - ' + this.ticket_tax['tax_name_en'];
                  }
                });
            }
          }
          //------------------------ Reg on bus ------------------------//
          else if (result['reg_on_bus'].length > 0) {
            this.model['trans_type'] = 'bus';
            let reg_on_bus = result['reg_on_bus'][0];

            this.model['bus_dep_date'] = new Date(reg_on_bus['depart_date']);
            this.model['bus_return_date'] = new Date(reg_on_bus['return_date']);

            this.bus_model = {
              'table_name': 'reg_on_bus', 'reg_bus_id': reg_on_bus['reg_bus_id'], 'trip_bus_id': reg_on_bus['trip_bus_id'],
              'bus_id': reg_on_bus['bus_id'], 'depart_date': reg_on_bus['depart_date'], 'return_date': reg_on_bus['return_date'],
              'flag': 'update', 'key': 'reg_bus_id', 'from_city': reg_on_bus['from_city'], 'to_city': reg_on_bus['to_city'],
              'invoice_no': reg_on_bus['invoice_no'], 'comment': reg_on_bus['comment'], 
              'male_seat_count': reg_on_bus['male_seat_count'], 'female_seat_count': reg_on_bus['female_seat_count'], 
              'addition_count': reg_on_bus['addition_count'], 'seat_price': reg_on_bus['seat_price'],
              'seat_cost': reg_on_bus['seat_cost'], 'discount': reg_on_bus['discount'],
              'bus_total': (Number(reg_on_bus['seat_price']) * (Number(reg_on_bus['male_seat_count']) + Number(reg_on_bus['female_seat_count']))).toFixed(2),
              'tax_type': reg_on_bus['tax_type'], 'tax_no': reg_on_bus['tax_no'], 
              'taxable_price': reg_on_bus['seat_part_price'], 'tax': reg_on_bus['seat_tax_amount'],
              'total_amount': ((Number(reg_on_bus['seat_price']) * (Number(reg_on_bus['male_seat_count']) + Number(reg_on_bus['female_seat_count']))) - Number(reg_on_bus['discount']) + Number(reg_on_bus['seat_tax_amount'])).toFixed(2),
              'seat_tax_amount': reg_on_bus['seat_tax_amount'], 
              'price_w_tax': (Number(reg_on_bus['seat_price']) + (Number(reg_on_bus['seat_tax_amount']) / (Number(reg_on_bus['male_seat_count']) + Number(reg_on_bus['female_seat_count'])))).toFixed(2), 
              'taxable_with_tax': (Number(reg_on_bus['seat_part_price']) + (Number(reg_on_bus['seat_tax_amount']) / (Number(reg_on_bus['male_seat_count']) + Number(reg_on_bus['female_seat_count'])))).toFixed(2)
            };

            this.from_ctity_detail = reg_on_bus['from_city_name'] + 
              (reg_on_bus['from_city_name_en'] != '' ? " - " + reg_on_bus['from_city_name_en'] : '');

            this.to_ctity_detail = reg_on_bus['to_city_name'] + 
              (reg_on_bus['to_city_name_en'] != '' ? " - " + reg_on_bus['to_city_name_en'] : '');

            if (this.bus_model['tax_no'] != '' && this.bus_model['tax_no'] != '0') {
              query = "SELECT * FROM `tax` WHERE `acct_number` = '" + this.bus_model['tax_no'] +
                "'";
              obj = { cmd: 'getList', query: query };

              this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                .subscribe(data => {
                  this.applicationConstants.appComp.hideBusyCursor();

                  if (data.data['list'].length > 0) {
                    this.bus_tax = data.data['list'][0];
                    this.bus_tax_detail = this.bus_tax['acct_number'] + ' - ' + this.bus_tax['tax_name_ar'] +
                      ' - ' + this.bus_tax['tax_name_en'];
                  }
                });
            }
          }
          else
            this.model['trans_type'] = 'without';

          let tax = 0, total_amount = 0, total_tax = 0, final_total = 0;
          //------------------------ Reg on Visa ------------------------//
          let reg_on_visa = result['reg_on_visa'];

          if (reg_on_visa.length > 0) {
            this.visa_model['tax_type'] = reg_on_visa[0]['tax_type'];
            this.visa_model['tax_no'] = reg_on_visa[0]['tax_no'];
            if (reg_on_visa[0]['tax_type'] == 'part_price')
              this.visa_model['taxable_price'] = reg_on_visa[0]['visa_part_price'];

            if (this.visa_model['tax_no'] != '' && this.visa_model['tax_no'] != '0') {
              query = "SELECT `tax`.* FROM `tax` WHERE `tax`.`acct_number` = '" + this.visa_model['tax_no'] +
                "' AND `tax`.`status` = '1'";
              obj = { cmd: 'getList', query: query };
              this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                .subscribe(data => {
                  this.applicationConstants.appComp.hideBusyCursor();

                  this.visa_tax = data.data['list'][0];
                  this.visa_tax_detail = this.visa_tax['acct_number'] + ' - ' + this.visa_tax['tax_name_ar'] +
                    ' - ' + this.visa_tax['tax_name_en'];
                });
            }

            reg_on_visa.forEach(element => {
              tax = Number(element.visa_tax_amount); // * Number(element.visa_count);
              total_amount = (Number(element.visa_price) * Number(element.visa_count)) - Number(element.discount) + Number(element.visa_tax_amount);

              this.add_visa_list.push({
                'table_name': 'reg_on_visa', 'reg_visa_id': element.reg_visa_id,
                'country_id': element.country_id, 'country_name': element.country_name,
                'visa_count': element.visa_count, 'visa_price': element.visa_price,
                'visa_cost': element.visa_cost, 'discount': element.discount, 'flag': 'update', 
                'key': 'reg_visa_id', 'tax_no': element.tax_no, 'tax_type': element.tax_type, 
                'visa_total': (Number(element.visa_price) * Number(element.visa_count)).toFixed(2),
                'visa_tax_amount': element.visa_tax_amount, 'total_amount': total_amount.toFixed(2),
                'invoice_no': element.invoice_no, 'taxable_price': element.visa_part_price,
                'tax': tax.toFixed(2), 'comment': element.comment, 'index': (this.add_visa_list.length + 1).toString(),
                'price_w_tax': (Number(element.visa_price) + (Number(element.visa_tax_amount) / Number(element.visa_count))).toFixed(2),
                'taxable_with_tax': (Number(element.visa_part_price) + (Number(element.visa_tax_amount) / Number(element.visa_count))).toFixed(2)
              });

              total_tax += tax;
              final_total += total_amount;
            });
            if (reg_on_visa[0]['tax_type'] == 'part_price')
              this.visa_model['taxable_with_tax'] = this.add_visa_list[0]['taxable_with_tax'];
            this.model['total_visa_tax'] = total_tax.toFixed(2);
            this.model['final_visa_total'] = final_total.toFixed(2);

            this.visaDataSource = new MatTableDataSource(this.add_visa_list);
            this.visaDataSource.sort = this.sort;
          }
          

          //------------------------ Reg on Hotel ------------------------//
          let reg_on_hotel = result['reg_on_hotel'];

          if (reg_on_hotel.length > 0) {
            this.hotel_model['tax_type'] = reg_on_hotel[0]['tax_type'];
            this.hotel_model['tax_no'] = reg_on_hotel[0]['tax_no'];
            if (reg_on_hotel[0]['tax_type'] == 'part_price')
              this.hotel_model['taxable_price'] = reg_on_hotel[0]['room_part_price'];

            if (this.hotel_model['tax_no'] != '' && this.hotel_model['tax_no'] != '0') {
              query = "SELECT `tax`.* FROM `tax` WHERE `tax`.`acct_number` = '" + this.hotel_model['tax_no'] +
                "' AND `tax`.`status` = '1'";
              obj = { cmd: 'getList', query: query };

              this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                .subscribe(data => {
                  this.applicationConstants.appComp.hideBusyCursor();

                  this.hotel_tax = data.data['list'][0];
                  this.room_tax_detail = this.hotel_tax['acct_number'] + ' - ' + this.hotel_tax['tax_name_ar'] +
                    ' - ' + this.hotel_tax['tax_name_en'];
                });
            }

            tax = 0, total_amount = 0, total_tax = 0, final_total = 0;
            reg_on_hotel.forEach(element => {
              tax = Number(element.room_tax_amount); // * Number(element.count);
              total_amount = (Number(element.room_price) * Number(element.count)) - Number(element.discount) + Number(element.room_tax_amount);

              this.add_hotel_list.push({
                'table_name': 'reg_on_hotel', 'city_id': element.city_id, 'hotel_id': element.hotel_id,
                'room_type_id': element.room_type_id, 'city_name': element.city_name,
                'hotel_name': element.hotel_name, 'room_type': element.room_type,
                'room_count': element.count, 'room_price': element.room_price,
                'room_cost': element.room_cost, 'discount': element.discount, 'flag': 'update', 'key': 'reg_id',
                'hotel_total': (Number(element.room_price) * Number(element.count)).toFixed(2),
                'comment': element.comment, 'package': element.package, 'room_tax_amount': element.room_tax_amount,
                'total_amount': total_amount.toFixed(2), 'reg_id': element.reg_id, 'tax_no': element.tax_no, 
                'invoice_no': element.invoice_no, 
                'tax_type': element.tax_type, 'tax': tax.toFixed(2), 'taxable_price': element.room_part_price,
                'checkin_date': element.checkin_date, 'checkout_date': element.checkout_date, 
                'index': (this.add_hotel_list.length + 1).toString(), 
                'price_w_tax': (Number(element.room_price) + (Number(element.room_tax_amount) / Number(element.count))).toFixed(2),
                'taxable_with_tax': (Number(element.room_part_price) + (Number(element.room_tax_amount) / Number(element.count))).toFixed(2)
              });

              total_tax += tax;
              final_total += total_amount;
            });
            if (reg_on_hotel[0]['tax_type'] == 'part_price')
              this.hotel_model['taxable_with_tax'] = this.add_hotel_list[0]['taxable_with_tax'];
            this.model['total_hotel_tax'] = total_tax.toFixed(2);
            this.model['final_hotel_total'] = final_total.toFixed(2);

            this.hotelDataSource = new MatTableDataSource(this.add_hotel_list);
            this.hotelDataSource.sort = this.sort;
          }

          // check if there is cash receipt for this invoice
          this.model['has_cash_receipt'] = result['has_cash_receipt'];
        }
      });

    
    //           if (this.ticket_model['tax_no'] != '' && this.ticket_model['tax_no'] != '0') {
    //             query = "SELECT * FROM `tax` WHERE `acct_number` = '" + this.ticket_model['tax_no'] + "'";
    //             obj = { cmd: 'getList', query: query };
    //             this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //               .subscribe(data => {
    //                 this.applicationConstants.appComp.hideBusyCursor();

    //                 if (data.data['list'].length > 0) {
    //                   this.ticket_tax = data.data['list'][0];
    //                   this.ticket_tax_detail = this.ticket_tax['acct_number'] + ' - ' + this.ticket_tax['tax_name_ar'] +
    //                     ' - ' + this.ticket_tax['tax_name_en'];

    //                   // this.calculate_ticket_total();  
    //                 }
    //               });
    //           }
    //           // else 
    //           //   this.calculate_ticket_total();

    //           // this.flight_price.forEach(element => {
    //           //   this.calculate_ticket_total(element);
    //           // });
    //         }

    //         else {
    //           //------------------------ Reg on Bus ------------------------//
    //           query = "SELECT * FROM `reg_on_bus` WHERE `invoice_no` = '" + this.no +
    //             "' AND `status` = '1'";
    //           obj = { cmd: 'getList', query: query };

    //           this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //             .subscribe(data => {
    //               this.applicationConstants.appComp.hideBusyCursor();

    //               if (data.data['list'].length > 0) {
    //                 this.model['trans_type'] = 'bus';
    //                 let reg_on_bus = data.data['list'][0];

    //                 this.model['bus_dep_date'] = new Date(reg_on_bus['depart_date']);
    //                 this.model['bus_return_date'] = new Date(reg_on_bus['return_date']);

    //                 this.bus_model = {
    //                   'table_name': 'reg_on_bus', 'reg_bus_id': reg_on_bus['reg_bus_id'], 'trip_bus_id': reg_on_bus['trip_bus_id'],
    //                   'bus_id': reg_on_bus['bus_id'], 'depart_date': reg_on_bus['depart_date'], 'return_date': reg_on_bus['return_date'],
    //                   'flag': 'update', 'key': 'reg_bus_id', 'from_city': reg_on_bus['from_city'], 'to_city': reg_on_bus['to_city'],
    //                   'invoice_no': reg_on_bus['invoice_no'], 'comment': reg_on_bus['comment'], 'male_seat_count': reg_on_bus['male_seat_count'],
    //                   'female_seat_count': reg_on_bus['female_seat_count'], 'addition_count': reg_on_bus['addition_count'], 'seat_price': reg_on_bus['seat_price'],
    //                   'seat_cost': reg_on_bus['seat_cost'],
    //                   'bus_total': (Number(reg_on_bus['seat_price']) * (Number(reg_on_bus['male_seat_count']) + Number(reg_on_bus['female_seat_count'])) + Number(reg_on_bus['seat_tax_amount'])).toFixed(2),
    //                   'tax_type': reg_on_bus['tax_type'],
    //                   'tax_no': reg_on_bus['tax_no'], 'taxable_price': reg_on_bus['seat_part_price'], 'tax': reg_on_bus['seat_tax_amount'],
    //                   'total_amount': (Number(reg_on_bus['seat_price']) * (Number(reg_on_bus['male_seat_count']) + Number(reg_on_bus['female_seat_count'])) + Number(reg_on_bus['seat_tax_amount'])).toFixed(2),
    //                   'seat_part_price': reg_on_bus['seat_part_price'],
    //                   'seat_tax_amount': reg_on_bus['seat_tax_amount'], 'price_w_tax': '0'
    //                 };

    //                 if (this.bus_model['from_city'] != '0') {
    //                   query = "SELECT * FROM `city` WHERE `city_id` = '" + this.bus_model['from_city'] + "'";
    //                   obj = { cmd: 'getList', query: query };

    //                   this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //                     .subscribe(data => {
    //                       this.applicationConstants.appComp.hideBusyCursor();

    //                       let city = data.data['list'][0];
    //                       this.from_ctity_detail = city['city_name'] + (city['city_name_en'] != '' ? " - " + city['city_name_en'] : '');
    //                     });
    //                 }

    //                 if (this.bus_model['to_city'] != '0') {
    //                   query = "SELECT * FROM `city` WHERE `city_id` = '" + this.bus_model['to_city'] + "'";
    //                   obj = { cmd: 'getList', query: query };

    //                   this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //                     .subscribe(data => {
    //                       this.applicationConstants.appComp.hideBusyCursor();

    //                       let city = data.data['list'][0];
    //                       this.to_ctity_detail = city['city_name'] + (city['city_name_en'] != '' ? " - " + city['city_name_en'] : '');
    //                     });
    //                 }

    //                 if (this.bus_model['tax_no'] != '' && this.bus_model['tax_no'] != '0') {
    //                   query = "SELECT * FROM `tax` WHERE `acct_number` = '" + this.bus_model['tax_no'] +
    //                     "'";
    //                   obj = { cmd: 'getList', query: query };

    //                   this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //                     .subscribe(data => {
    //                       this.applicationConstants.appComp.hideBusyCursor();

    //                       if (data.data['list'].length > 0) {
    //                         this.bus_tax = data.data['list'][0];
    //                         this.bus_tax_detail = this.bus_tax['acct_number'] + ' - ' + this.bus_tax['tax_name_ar'] +
    //                           ' - ' + this.bus_tax['tax_name_en'];

    //                         // this.calculate_bus_total();
    //                       }
    //                     });
    //                 }
    //                 // else 
    //                 //   this.calculate_bus_total();
    //               }
    //               else
    //                 this.model['trans_type'] = 'without';
    //             });
    //         }

    //       });

    //     let total_tax = 0, total_amount = 0;
    //     //------------------------ Reg on Visa ------------------------//

    //     query = "SELECT * FROM `reg_on_visa` WHERE `reg_on_visa`.`invoice_no` = '" + this.no + "' " +
    //       "AND `reg_on_visa`.`status` = '1'";
    //     obj = { cmd: 'getList', query: query };

    //     this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //       .subscribe(data => {
    //         this.applicationConstants.appComp.hideBusyCursor();
    //         let reg_on_visa = data.data['list'];

    //         if (reg_on_visa.length > 0) {
    //           this.visa_model['tax_type'] = reg_on_visa[0]['tax_type'];
    //           this.visa_model['tax_no'] = reg_on_visa[0]['tax_no'];
    //           this.visa_model['taxable_price'] = reg_on_visa[0]['visa_part_price'];
    //           this.visa_model['visa_part_price'] = reg_on_visa[0]['visa_part_price'];

    //           if (this.visa_model['tax_no'] != '' && this.visa_model['tax_no'] != '0') {
    //             query = "SELECT `tax`.* FROM `tax` WHERE `tax`.`acct_number` = '" + this.visa_model['tax_no'] +
    //               "' AND `tax`.`status` = '1'";
    //             obj = { cmd: 'getList', query: query };
    //             this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //               .subscribe(data => {
    //                 this.applicationConstants.appComp.hideBusyCursor();

    //                 this.visa_tax = data.data['list'][0];
    //                 this.visa_tax_detail = this.visa_tax['acct_number'] + ' - ' + this.visa_tax['tax_name_ar'] +
    //                   ' - ' + this.visa_tax['tax_name_en'];
    //               });
    //           }

    //           total_tax = 0, total_amount = 0;
    //           reg_on_visa.forEach(element => {
    //             this.country_list.forEach(country => {
    //               if (country.country_id == element.country_id)
    //                 element.country_name = country.country_name;
    //             });

    //             this.add_visa_list.push({
    //               'table_name': 'reg_on_visa', 'reg_visa_id': element.reg_visa_id,
    //               'country_id': element.country_id, 'country_name': element.country_name,
    //               'visa_count': element.visa_count, 'visa_price': element.visa_price,
    //               'visa_cost': element.visa_cost, 'flag': 'update', 'key': 'reg_visa_id',
    //               'tax_no': this.visa_model['tax_no'],
    //               'visa_total': (Number(element.visa_price) * Number(element.visa_count)).toFixed(2),
    //               'visa_tax': element.visa_tax_amount,
    //               'final_total': ((Number(element.visa_price) * Number(element.visa_count)) + Number(element.visa_tax_amount)).toFixed(2),
    //               'invoice_no': this.visa_model['invoice_no'], 'visa_tax_amount': element.visa_tax_amount,
    //               'tax_type': this.visa_model['tax_type'], 'taxable_price': this.visa_model['taxable_price'],
    //               'tax': element.visa_tax_amount, 'total_amount': this.visa_model['total_amount'],
    //               'comment': this.visa_model['comment']
    //             });

    //             total_tax += Number(element.visa_tax_amount);
    //             total_amount += (Number(element.visa_price) * Number(element.visa_count)) + Number(element.visa_tax_amount);
    //           });
    //           this.visa_model['tax'] = total_tax.toFixed(2);
    //           this.visa_model['total_amount'] = total_amount.toFixed(2);

    //           // this.calculate_tax('visa');
    //           this.visaDataSource = new MatTableDataSource(this.add_visa_list);
    //           this.visaDataSource.sort = this.sort;
    //         }
    //       });


    //     //------------------------ Reg on Hotel ------------------------//

    //     query = "SELECT `reg_on_hotel`.* FROM `reg_on_hotel` WHERE `reg_on_hotel`.`status` = '1' " +
    //       "AND `reg_on_hotel`.`invoice_no` = '" + this.no + "'";
    //     obj = { cmd: 'getList', query: query };

    //     this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //       .subscribe(data => {
    //         this.applicationConstants.appComp.hideBusyCursor();
    //         let reg_on_hotel = data.data['list'];
    //         if (reg_on_hotel.length > 0) {
    //           this.hotel_model['tax_type'] = reg_on_hotel[0]['tax_type'];
    //           this.hotel_model['tax_no'] = reg_on_hotel[0]['tax_no'];
    //           this.hotel_model['taxable_price'] = reg_on_hotel[0]['room_part_price'];
    //           this.hotel_model['room_part_price'] = reg_on_hotel[0]['room_part_price'];

    //           if (this.hotel_model['tax_no'] != '' && this.hotel_model['tax_no'] != '0') {
    //             query = "SELECT `tax`.* FROM `tax` WHERE `tax`.`acct_number` = '" + this.hotel_model['tax_no'] +
    //               "' AND `tax`.`status` = '1'";
    //             obj = { cmd: 'getList', query: query };

    //             this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //               .subscribe(data => {
    //                 this.applicationConstants.appComp.hideBusyCursor();

    //                 this.hotel_tax = data.data['list'][0];
    //                 this.room_tax_detail = this.hotel_tax['acct_number'] + ' - ' + this.hotel_tax['tax_name_ar'] +
    //                   ' - ' + this.hotel_tax['tax_name_en'];
    //               });
    //           }

    //           total_tax = 0, total_amount = 0;
    //           reg_on_hotel.forEach(element => {

    //             this.city.forEach(city => {
    //               if (element.city_id == city.city_id)
    //                 element.city_name = city.city_name + "-" + city.city_name_en;
    //             });

    //             if (element.hotel_id == '0')
    //               element.hotel_name = this.Without;
    //             else {
    //               this.all_hotel.forEach(hotel => {
    //                 if (element.hotel_id == hotel.hotel_id) {
    //                   element.hotel_name = hotel.hotel_name;
    //                 }
    //               });
    //             }

    //             this.room_list.forEach(room => {
    //               if (room.room_type_id == element.room_type_id)
    //                 element.room_type = room.room_type;
    //             });


    //             this.add_hotel_list.push({
    //               'table_name': 'reg_on_hotel', 'city_id': element.city_id, 'hotel_id': element.hotel_id,
    //               'room_type_id': element.room_type_id, 'city_name': element.city_name,
    //               'hotel_name': element.hotel_name, 'room_type': element.room_type,
    //               'room_count': element.count, 'room_price': element.room_price,
    //               'room_cost': element.room_cost, 'flag': 'update', 'key': 'reg_id',
    //               'hotel_total': (Number(element.room_price) * Number(element.count)).toFixed(2),
    //               'comment': element.comment, 'package': element.package, 'room_tax': element.room_tax_amount,
    //               'final_total': ((Number(element.room_price) * Number(element.count)) + Number(element.room_tax_amount)).toFixed(2),
    //               'reg_id': element.reg_id, 'tax_no': this.hotel_model['tax_no'],
    //               'invoice_no': this.hotel_model['invoice_no'], 'count': element.count,
    //               'tax_type': this.hotel_model['tax_type'], 'tax': element.room_tax_amount,
    //               'taxable_price': this.hotel_model['taxable_price'],
    //               'total_amount': this.hotel_model['total_amount'], 'checkin_date': element.checkin_date,
    //               'checkout_date': element.checkout_date, 'index': this.add_hotel_list.length + 1
    //             });

    //             total_tax += Number(element.room_tax_amount);
    //             total_amount += (Number(element.room_price) * Number(element.count)) + Number(element.room_tax_amount);
    //           });
    //           this.hotel_model['tax'] = total_tax.toFixed(2);
    //           this.hotel_model['total_amount'] = total_amount.toFixed(2);

    //           // this.calculate_tax('hotel');
    //           this.hotelDataSource = new MatTableDataSource(this.add_hotel_list);
    //           this.hotelDataSource.sort = this.sort;
    //         }
    //       });


    //     // check if there is cash receipt for this invoice
    //     query = "SELECT `cash_receipt`.`cash_receipt_no`, `cash_receipt`.`paid` FROM " +
    //       "`cash_receipt`, `cash_receipt_invoice` WHERE `cash_receipt_invoice`.`invoice_no` = '" +
    //       this.no + "' AND `cash_receipt_invoice`.`status` != '0' AND " +
    //       "`cash_receipt_invoice`.`cash_receipt_no` = `cash_receipt`.`cash_receipt_no`";

    //     obj = { cmd: 'getList', query: query };

    //     this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //       .subscribe(data => {
    //         this.applicationConstants.appComp.hideBusyCursor();
    //         this.model['has_cash_receipt'] = (data.data['list'].length > 0 ? 1 : 0);
    //       });

    //   });
  }

  change_trans() {
    if (this.no != '') {
      if (this.model['trans_type'] == 'bus') {
        if (this.ticket_model['reg_ticket_id'] != '0') {
          this.ticket_model['flag'] = 'delete';
          this.toDelete.push(this.ticket_model);
        }
      }

      else if (this.model['trans_type'] == 'flight') {
        if (this.bus_model['reg_bus_id'] != '0') {
          this.bus_model['flag'] = 'delete';
          this.toDelete.push(this.bus_model);
        }
      }

      else if (this.model['trans_type'] == 'without') {
        if (this.ticket_model['reg_ticket_id'] != '0') {
          this.ticket_model['flag'] = 'delete';
          this.toDelete.push(this.ticket_model);
        }

        else if (this.bus_model['reg_bus_id'] != '0') {
          this.bus_model['flag'] = 'delete';
          this.toDelete.push(this.bus_model);
        }

      }
    }
  }

  //-------********************** END EDIT **********************-------//


  next(event) {
    let btnId = event.srcElement.id;

    if (btnId == "btn_next1")
      this.selectedTab = 1;
    else if (btnId == "btn_next2")
      this.selectedTab = 2;
    else if (btnId == "btn_next3")
      this.selectedTab = 3;
    else if (btnId == "btn_next4")
      this.selectedTab = 4;
    else if (btnId == "btn_next5")
      this.selectedTab = 5;

    this.changeTab(null);
  }

  back(event) {
    let btnId = event.srcElement.id;

    if (btnId == "btn_back0")
      this.selectedTab = 0;
    else if (btnId == "btn_back1")
      this.selectedTab = 1;
    else if (btnId == "btn_back2")
      this.selectedTab = 2;
    else if (btnId == "btn_back3")
      this.selectedTab = 3;
    else if (btnId == "btn_back4")
      this.selectedTab = 4;

    this.changeTab(null);
  }

  getHotel() {
    this.hotel_list = [];
    this.all_hotel.forEach(element => {
      if (element.city_id == this.hotel_model['city_id'])
        this.hotel_list.push(element);
    });
    this.hotel_list.unshift({ 'hotel_id': '0', 'hotel_name': 'بدون', 'hotel_name_en': 'Without' });
    // this.hotel_model['hotel_id'] = '0';
  }

  changeTab(event) {

    if ((event != null && event.index == 1) || (event == null && this.selectedTab == 1)) {

      this.flight_price = [];
      this.flight_price.push({
        'type': 'بالغ', 'count': this.adult_count, 'price': this.ticket_model['adult_price'], 
        'cost': this.ticket_model['adult_cost'], 'taxable_price': this.ticket_model['adult_part_price'], 
        'tax': this.ticket_model['adult_tax_amount'], 'price_w_tax': this.ticket_model['adult_price_w_tax'],
        'discount': this.ticket_model['adult_discount'], 'total': this.ticket_model['adult_total_price'], 
        'index': 'adult'
      });

      this.flight_price.push({
        'type': 'طفل', 'count': this.child_count, 'price': this.ticket_model['child_price'], 
        'cost': this.ticket_model['child_cost'], 'taxable_price': this.ticket_model['child_part_price'], 
        'tax': this.ticket_model['child_tax_amount'], 'price_w_tax': this.ticket_model['child_price_w_tax'],
        'discount': this.ticket_model['child_discount'], 'total': this.ticket_model['child_total_price'], 
        'index': 'child'
      });

      this.flight_price.push({
        'type': 'رضيع', 'count': this.infant_count, 'price': this.ticket_model['infant_price'], 
        'cost': this.ticket_model['infant_cost'], 'taxable_price': this.ticket_model['infant_part_price'], 
        'tax': this.ticket_model['infant_tax_amount'], 'price_w_tax': this.ticket_model['infant_price_w_tax'],
        'discount': this.ticket_model['infant_discount'], 'total': this.ticket_model['infant_total_price'], 
        'index': 'infant'
      });

      this.flightDataSource = new MatTableDataSource(this.flight_price);
      this.flightDataSource.sort = this.sort;
    }

    else if ((event != null && event.index == 5) || (event == null && this.selectedTab == 5)) {
      this.detail = [];
      this.model['total_amount'] = '0';
      this.model['no_tax_total'] = '0';
      this.model['total_discount'] = '0';
      this.model['total_taxable'] = '0';
      this.model['total_tax'] = '0';
      this.model['total_w_tax'] = '0';

      let total_amount = 0, total_taxable = 0, no_tax_total = 0, total_discount = 0, total_tax = 0, 
        total_w_tax = 0;
      // let price, total;

      if (this.model['trans_type'] == 'flight') {
        // let adult_total = Number(this.ticket_model['adult_price']) * this.adult_count;
        // let child_total = Number(this.ticket_model['child_price']) * this.child_count;
        // let infant_total = Number(this.ticket_model['infant_price']) * this.infant_count;

        if (this.adult_count > 0) {
          this.detail.push({
            'type': this.Ticket_Sub_Item + " (" + this.Adult + ")", 'count': this.ticket_model['adult_count'],
            'price': this.ticket_model['adult_price'], 
            'tax': Number(this.ticket_model['adult_tax_amount']).toFixed(2),
            'discount': Number(this.ticket_model['adult_discount']),
            'total': this.ticket_model['adult_total_price'], 'tax_no': this.ticket_model['tax_no'],
            'tax_type': this.ticket_model['tax_type'], 'comment': '', 'item_type': 's', 
            'taxable_price': this.ticket_model['adult_part_price'], 'cost': this.ticket_model['adult_cost']
          });

          this.ticket_model['adult_comment'] = this.Ticket_Sub_Item + " (" + this.Adult + ")";
        }

        if (this.child_count > 0) {
          this.detail.push({
            'type': this.Ticket_Sub_Item + " (" + this.Child + ")", 'count': this.ticket_model['child_count'],
            'price': this.ticket_model['child_price'], 
            'tax': Number(this.ticket_model['child_tax_amount']).toFixed(2),
            'discount': Number(this.ticket_model['child_discount']),
            'total': this.ticket_model['child_total_price'], 'tax_no': this.ticket_model['tax_no'],
            'tax_type': this.ticket_model['tax_type'], 'comment': '', 'item_type': 's', 
            'taxable_price': this.ticket_model['child_part_price'], 'cost': this.ticket_model['child_cost']
          });

          this.ticket_model['child_comment'] = this.Ticket_Sub_Item + " (" + this.Child + ")";
        }

        if (this.infant_count > 0) {
          this.detail.push({
            'type': this.Ticket_Sub_Item + " (" + this.Infant + ")", 'count': this.ticket_model['infant_count'],
            'price': this.ticket_model['infant_price'], 
            'tax': Number(this.ticket_model['infant_tax_amount']).toFixed(2),
            'discount': Number(this.ticket_model['infant_discount']),
            'total': this.ticket_model['infant_total_price'], 'tax_no': this.ticket_model['tax_no'],
            'tax_type': this.ticket_model['tax_type'], 'comment': '', 'item_type': 's', 
            'taxable_price': this.ticket_model['infant_part_price'], 'cost': this.ticket_model['infant_cost']
          });

          this.ticket_model['infant_comment'] = this.Ticket_Sub_Item + " (" + this.Infant + ")";
        }

        
        if (this.ticket_model['tax_type'] == 'no_tax') {
          no_tax_total += Number(this.ticket_model['adult_total_price']) + 
            Number(this.ticket_model['child_total_price']) + Number(this.ticket_model['infant_total_price']);
        }

        else if (this.ticket_model['tax_type'] == 'all_price') {
          total_taxable += (Number(this.ticket_model['adult_price']) * this.adult_count) + 
            (Number(this.ticket_model['child_price']) * this.child_count) + 
            (Number(this.ticket_model['infant_price']) * this.infant_count);
        }

        else {
          total_taxable += (Number(this.ticket_model['adult_part_price']) * this.adult_count) + 
            (Number(this.ticket_model['child_part_price']) * this.child_count) + 
            (Number(this.ticket_model['infant_part_price']) * this.infant_count);

          no_tax_total += ((Number(this.ticket_model['adult_price']) - 
            Number(this.ticket_model['adult_part_price'])) * this.adult_count);

          no_tax_total += ((Number(this.ticket_model['child_price']) - 
            Number(this.ticket_model['child_part_price'])) * this.child_count);

          no_tax_total += ((Number(this.ticket_model['infant_price']) -
            Number(this.ticket_model['infant_part_price'])) * this.infant_count);
        }

        total_amount += (Number(this.ticket_model['adult_price']) * this.adult_count) + 
          (Number(this.ticket_model['child_price']) * this.child_count) + 
          (Number(this.ticket_model['infant_price']) * this.infant_count);

        total_discount += Number(this.ticket_model['adult_discount']) + 
          Number(this.ticket_model['child_discount']) + 
          Number(this.ticket_model['infant_discount']);

        total_tax += Number(this.ticket_model['adult_tax_amount']) + 
          Number(this.ticket_model['child_tax_amount']) + 
          Number(this.ticket_model['infant_tax_amount']);

        total_w_tax += Number(this.ticket_model['adult_total_price']) + 
          Number(this.ticket_model['child_total_price']) + Number(this.ticket_model['infant_total_price']);

        // console.log('flight: ' + total_tax);
        // console.log('flight discount: ' + total_discount);
        // console.log('flight total_taxable: ' + total_taxable);
        // console.log('flight no_tax_total: ' + no_tax_total);
        // else if (this.ticket_model['tax_type'] == 'income_price') {
        //   let adult_profit = adult_total - Number(this.ticket_model['adult_cost']) * this.adult_count;
        //   let child_profit = child_total - Number(this.ticket_model['child_cost']) * this.child_count;
        //   let infant_profit = infant_total - Number(this.ticket_model['infant_cost']) * this.infant_count;
          
        //   this.model['total_taxable'] = (Number(this.model['total_taxable']) + adult_profit + child_profit +
        //     infant_profit).toFixed(2);
        //   this.model['no_tax_total'] = (Number(this.model['no_tax_total']) + adult_total + child_total +
        //     infant_total - (adult_profit + child_profit + infant_profit)).toFixed(2);
        // }

      }

      else if (this.model['trans_type'] == 'bus') {

        if (Number(this.bus_model['male_seat_count']) > 0 || Number(this.bus_model['female_seat_count']) > 0) {
          this.detail.push({
            'type': this.Bus_Sub_Item, 'count': Number(this.bus_model['male_seat_count']) + Number(this.bus_model['female_seat_count']),
            'price': this.bus_model['seat_price'], 'tax': this.bus_model['tax'],
            'discount': this.bus_model['discount'], 'total': this.bus_model['total_amount'], 
            'tax_no': this.bus_model['tax_no'], 'tax_type': this.bus_model['tax_type'], 'comment': '', 
            'item_type': 's', 'taxable_price': this.bus_model['taxable_price'], 'cost': this.bus_model['seat_cost']
          });

          this.bus_model['comment'] = this.Bus_Sub_Item;
        }

        // let total = Number(this.bus_model['seat_price']) * (Number(this.bus_model['male_seat_count']) + Number(this.bus_model['female_seat_count']));
        if (this.bus_model['tax_type'] == 'all_price') 
          total_taxable += Number(this.bus_model['bus_total']);
         
        else if (this.bus_model['tax_type'] == 'no_tax') 
          no_tax_total += Number(this.bus_model['bus_total']);

        else {
          total_taxable += Number(this.bus_model['taxable_price']) * (Number(this.bus_model['male_seat_count']) + Number(this.bus_model['female_seat_count']));
          no_tax_total += (Number(this.bus_model['seat_price']) - Number(this.bus_model['taxable_price'])) * (Number(this.bus_model['male_seat_count']) + Number(this.bus_model['female_seat_count']));
        } 

        total_amount += Number(this.bus_model['bus_total']);
        total_discount += Number(this.bus_model['discount']);
        total_tax += Number(this.bus_model['tax']);
        total_w_tax += Number(this.bus_model['total_amount']);

        // console.log('bus: ' + total_tax);
        // console.log('bus discount: ' + total_discount);
        // console.log('bus total_taxable: ' + total_taxable);
        // console.log('bus no_tax_total: ' + no_tax_total);

        // if (this.bus_model['tax_type'] == 'part_price') {
        //   this.model['total_taxable'] = (Number(this.model['total_taxable']) + (Number(this.bus_model['taxable_price']) * (Number(this.bus_model['male_seat_count']) + Number(this.bus_model['female_seat_count'])))).toFixed(2);
        //   this.model['no_tax_total'] = (Number(this.model['no_tax_total']) + Number(this.bus_model['bus_total']) - Number(this.bus_model['taxable_price'])).toFixed(2);
        // }

        // else if (this.bus_model['tax_type'] == 'income_price') {
        //   let profit = Number(this.bus_model['bus_total']) - (Number(this.bus_model['seat_cost']) * (Number(this.bus_model['male_seat_count']) + Number(this.bus_model['female_seat_count'])));
        //   this.model['total_taxable'] = (Number(this.model['total_taxable']) + profit).toFixed(2);
        //   this.model['no_tax_total'] = (Number(this.model['no_tax_total']) + Number(this.bus_model['bus_total']) - Number(profit)).toFixed(2);
        // }
      }

      this.add_visa_list.forEach(element => {
        if (Number(element.visa_count) > 0) {
          this.detail.push({
            'type': 'التأشيرات (' + element.country_name + ')', 'count': element.visa_count,
            'price': element.visa_price, 'tax': element.tax, 'total': element.total_amount, 
            'discount': element.discount, 'tax_no': element.tax_no, 'tax_type': element.tax_type, 
            'comment': '', 'item_type': 's', 'taxable_price': element.taxable_price, 
            'cost': element.visa_cost
          });

          element.comment = 'التأشيرات (' + element.country_name + ')';
        }

        // let total = Number(element.visa_price) * Number(element.visa_count);
        if (element.tax_type == 'all_price') 
          total_taxable += Number(element.visa_total);

        else if (element.tax_type == 'no_tax')
          no_tax_total += Number(element.visa_total);

        else {
          total_taxable += Number(element.taxable_price) * Number(element.visa_count);
          no_tax_total += (Number(element.visa_price) - Number(element.taxable_price)) * Number(element.visa_count);
        } 
        
        total_amount += Number(element.visa_total);
        total_discount += Number(element.discount);
        total_tax += Number(element.tax);
        total_w_tax += Number(element.total_amount);

        // if (this.visa_model['tax_type'] == 'part_price') {
        //   this.model['total_taxable'] = (Number(this.model['total_taxable']) + (Number(this.visa_model['taxable_price']) * element.visa_count)).toFixed(2);
        //   this.model['no_tax_total'] = (Number(this.model['no_tax_total']) + total - (Number(this.visa_model['taxable_price']) * Number(element.visa_count))).toFixed(2);
        // }

        // else if (this.visa_model['tax_type'] == 'income_price') {
        //   let profit = total - (Number(element.visa_cost) * Number(element.visa_count));
        //   this.model['total_taxable'] = (Number(this.model['total_taxable']) + profit).toFixed(2);
        //   this.model['no_tax_total'] = (Number(this.model['no_tax_total']) + total - profit).toFixed(2);
        // }

        // else if (this.visa_model['tax_type'] == 'no_tax') {
        //   this.model['no_tax_total'] = (Number(this.model['no_tax_total']) + total).toFixed(2);
        // }
      });
      // console.log('visa: ' + total_tax);
      // console.log('visa discount: ' + total_discount);
      // console.log('visa total_taxable: ' + total_taxable);
      // console.log('visa no_tax_total: ' + no_tax_total);

      this.add_hotel_list.forEach(element => {
        if (Number(element.room_count) > 0) {
          this.detail.push({
            'type': 'السكن (' + element.city_name + ' - ' + element.hotel_name + ' - ' + element.room_type + ')',
            'count': element.room_count, 'price': element.room_price, 'tax': element.tax,
            'total': element.total_amount, 'tax_no': element.tax_no, 'discount': element.discount,
            'comment': element.package, 'tax_type': element.tax_type, 'item_type': 's', 
            'taxable_price': element.taxable_price, 'cost': element.room_cost
          });

          element.comment = 'السكن (' + element.city_name + ' - ' + element.hotel_name + ' - ' + element.room_type + ')';
        }

        // let total = Number(element.room_price) * Number(element.room_count);
        if (element.tax_type == 'all_price') 
          total_taxable += Number(element.hotel_total);

        else if (element.tax_type == 'no_tax')
          no_tax_total += Number(element.hotel_total);

        else {
          total_taxable += Number(element.taxable_price) * Number(element.room_count);
          no_tax_total += (Number(element.room_price) - Number(element.taxable_price)) * Number(element.room_count);
        }
        
        total_amount += Number(element.hotel_total);
        total_discount += Number(element.discount);
        total_tax += Number(element.tax);
        total_w_tax += Number(element.total_amount);

        // else if (this.hotel_model['tax_type'] == 'part_price') {
        //   this.model['total_taxable'] = (Number(this.model['total_taxable']) + Number(this.hotel_model['taxable_price'])).toFixed(2);
        //   this.model['no_tax_total'] = (Number(this.model['no_tax_total']) + total - (Number(this.hotel_model['taxable_price']) * Number(element.room_count))).toFixed(2);
        // }

        // else if (this.hotel_model['tax_type'] == 'income_price') {
        //   let profit = total - (Number(element.room_cost) * Number(element.room_count));
        //   this.model['total_taxable'] = (Number(this.model['total_taxable']) + profit).toFixed(2);
        //   this.model['no_tax_total'] = (Number(this.model['no_tax_total']) + total - profit).toFixed(2);
        // }

        // else if (this.hotel_model['tax_type'] == 'no_tax') {
        //   this.model['no_tax_total'] = (Number(this.model['no_tax_total']) + total).toFixed(2);
        // }
      });
      // console.log('hotel: ' + total_tax);
      // console.log('hotel discount: ' + total_discount);
      // console.log('hotel total_taxable: ' + total_taxable);
      // console.log('hotel no_tax_total: ' + no_tax_total);

      if (this.ext_model['ext_amount'] != '') {
        this.detail.push({
          'type': (this.ext_model['amount_comment'] == '' ? this.Additional_Amount : this.ext_model['amount_comment']), 
          'count': '1', 'price': this.ext_model['ext_amount'], 'discount': this.ext_model['discount'], 
          'tax': this.ext_model['tax_amount'], 
          'total': (Number(this.ext_model['ext_w_tax']) > 0 ? this.ext_model['ext_w_tax'] : this.ext_model['ext_amount']), 
          'tax_no':this.ext_model['tax_no'], 'comment': '', 'item_type': 'sa', 
          'tax_type': this.ext_model['tax_type'], 'cost': this.ext_model['cost']
        });

        if (this.ext_model['tax_type'] == 'all_price')
          total_taxable += Number(this.ext_model['ext_amount']);

        else if (this.ext_model['tax_type'] == 'no_tax')
          no_tax_total += Number(this.ext_model['ext_amount']);

        total_amount += Number(this.ext_model['ext_amount']);
        total_tax += Number(this.ext_model['tax_amount']);
        total_w_tax += (Number(this.ext_model['ext_w_tax']) > 0 ? Number(this.ext_model['ext_w_tax']) : Number(this.ext_model['ext_amount']));
        
        // console.log('ext: ' + total_tax);
        // console.log('ext total_taxable: ' + total_taxable);
        // console.log('ext no_tax_total: ' + no_tax_total);
      }

      this.detailDataSource = new MatTableDataSource(this.detail);
      this.detailDataSource.sort = this.sort;

      this.model['total_taxable'] = total_taxable.toFixed(2);
      this.model['no_tax_total'] = no_tax_total.toFixed(2);
      this.model['total_discount'] = total_discount.toFixed(2);
      this.model['total_amount'] = total_amount.toFixed(2);
      this.model['total_tax'] = total_tax.toFixed(2);
      this.model['total_w_tax'] = total_w_tax.toFixed(2);

      // this.detail.forEach(element => {
      //   this.model['total_amount'] = (Number(this.model['total_amount']) + Number(element.price)).toFixed(2);
      //   this.model['total_tax'] = (Number(this.model['total_tax']) + Number(element.tax)).toFixed(2);
      // });
      // this.model['total_w_tax'] = (Number(this.model['total_amount']) + Number(this.model['total_tax'])).toFixed(2);
    }
  }

  newTraveler() {
    this.addDialogRef = this.dialog.open(TravelerComponent, {
      hasBackdrop: false,
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        // if (result != null && result['op_type'] == 'success')
        //   this.utils.getCustList(this.applicationConstants.user_branch_info.user_branch_id);
      });
  }


  //------------------------ Check Boxes Change ------------------------//

  changeAddDepent() {
    this.model['chx_addDepend'] = ((document.getElementById('chx_addDepend') as HTMLInputElement).checked ? '1' : '0');
    this.showTravelerTable = (Number(this.model['depend_count']) == 0 || (Number(this.model['depend_count']) > 0 && this.model['chx_addDepend'] == '1'));
    // this.showRoomTable = (Number(this.model['depend_count']) > 0 && this.model['chx_addDepend'] == '0');
    this.add_depend_list = [];
  }

  //-------********************** DEPENDENT FUNCTIONS **********************-------//

  addDepend() {
    if (this.model['depend_no'] == '' || this.model['depend_no'] == '0') {
      alert(this.Depend_Msg);
      return;
    }

    let query = "SELECT `customer`.*, `traveler_info`.* FROM `customer`," +
      " `traveler_info` WHERE `customer`.`status` = '1' AND `customer`.`acct_number` = `traveler_info`.`acct_number`" +
      " AND `customer`.`acct_number` = '" + this.model['depend_no'] + "'";

    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        let depend_info = data.data['list'][0];

        let birthdate = new Date(depend_info['date_of_birth']);
        let timeDiff = Math.abs(Date.now() - birthdate.getTime());
        let age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365.25);

        if (age >= 12)
          this.adult_count += 1;
        else if (age < 12 && age > 2)
          this.child_count += 1;
        else if (age <= 2)
          this.infant_count += 1;

        this.add_depend_list.push({
          'acct_number': depend_info['acct_number'], 'customer_name': depend_info['customer_name'],
          'national_id': depend_info['national_id'], 'mobile': depend_info['mobile'],
          'passport_no': depend_info['passport_no'], 'traveler_type': 'تابع', 'comment': this.group_model['comment'],
          'type': 'depend', 'age': age, 'relative_relation': '', 'index': this.add_depend_list.length,
          'departure_date': '', 'arrival_date': '', 'room_type_id': '', 'price': ''
        });

        this.dependDataSource = new MatTableDataSource(this.add_depend_list);
        this.dependDataSource.sort = this.sort;

        this.traveler_list.push({
          'table_name': 'trip_group', 'acct_number': depend_info['acct_number'],
          'customer_name': depend_info['customer_name'], 'national_id': depend_info['national_id'],
          'mobile': depend_info['mobile'], 'passport_no': depend_info['passport_no'], 'traveler_type': 'تابع',
          'comment': this.group_model['comment'], 'flag': 'new', 'key': 'group_id',
          'type': 'depend', 'age': age, 'relative_relation': '', 'index': this.traveler_list.length,
          'departure_date': '', 'arrival_date': '',
          'room_type_id': '', 'price': '0', 'invoice_no': this.invoice_model['invoice_no'],
          'group_id': '0', 'bed_count': '1', 'ticket_count': '1'
        });

        // this.travelerDataSource = new MatTableDataSource(this.traveler_list);
        // this.travelerDataSource.sort = this.sort;

        (document.getElementById('search_value_2') as HTMLInputElement).value = '';
        this.group_model['comment'] = '';

        // reset total field
        //this.resetTotal();
      });
  }

  changeRelation(event, acct_number) {
    let value = event.srcElement.value;
    let dependIndex = this.utils.getDPIndex(this.add_depend_list, 'acct_number', acct_number);
    let travelIndex = this.utils.getDPIndex(this.traveler_list, 'acct_number', acct_number);

    this.add_depend_list[dependIndex].relative_relation = value;
    this.traveler_list[travelIndex].relative_relation = value;

    //console.log(this.add_depend_list);
    //console.log(this.traveler_list);
  }

  deleteDepend(row) {
    let dependIndex = this.utils.getDPIndex(this.add_depend_list, 'acct_number', row.acct_number);
    let travelIndex = this.utils.getDPIndex(this.traveler_list, 'acct_number', row.acct_number);

    if (row.group_id != '0') {
      row.flag = 'delete';
      this.toDelete.push(row);
    }

    if (row.age >= 12)
      this.adult_count -= 1;
    else if (row.age < 12 && row.age > 2)
      this.child_count -= 1;
    else if (row.age <= 2)
      this.infant_count -= 1;

    this.add_depend_list.splice(dependIndex, 1);
    this.dependDataSource = new MatTableDataSource(this.add_depend_list);
    this.dependDataSource.sort = this.sort;

    this.traveler_list.splice(travelIndex, 1);
    // this.travelerDataSource = new MatTableDataSource(this.traveler_list);
    // this.travelerDataSource.sort = this.sort;

    // console.log(this.toDelete);

    // change total field
    // this.calculsteTotalAmount();
  }

  //-------********************** BUS FUNCTIONS **********************-------//

  // calculate_bus_total() {
  //   if (this.bus_model['seat_price'] != '' && (this.bus_model['male_seat_count'] != '' || this.bus_model['female_seat_count'] != '')) {
  //     this.bus_model['bus_total'] = (Number(this.bus_model['seat_price']) * (Number(this.bus_model['male_seat_count']) + Number(this.bus_model['female_seat_count']))).toFixed(2);

  //     if (this.bus_model['tax_type'] == 'all_price' && this.bus_model['tax_no'] != '')
  //       this.bus_model['price_w_tax'] = (Number(this.bus_model['seat_price']) + (Number(this.bus_model['seat_price']) * (Number(this.bus_tax['tax_perc']) / 100))).toFixed(2);

  //     this.calculate_tax('bus');
  //   }
  // }

  // saveBus() {
  //   if (this.bus_model['bus_id'] == '0') {
  //     alert(this.Bus_Msg);
  //     return;
  //   }
  //   this.bus_list.forEach(element => {
  //     if (element.bus_id == this.bus_model['bus_id'])
  //       this.bus_model['bus_no'] = element.bus_no;
  //   });

  //   this.city.forEach(element => {
  //     if (element.city_id == this.bus_model['from_city'])
  //       this.bus_model['from_city_name'] = element.city_name;
  //   });

  //   this.city.forEach(element => {
  //     if (element.city_id == this.bus_model['to_city'])
  //       this.bus_model['to_city_name'] = element.city_name;
  //   });

  //   this.bus_model['depart_date'] = (this.model['bus_dep_date'].getFullYear() + '-' +
  //     (this.model['bus_dep_date'].getMonth() + 1) + '-' + this.model['bus_dep_date'].getDate());


  //   if (this.bus_model['reg_bus_id'] == '0') {
  //     let bus_existed = false;
  //     this.add_bus_list.forEach(element => {
  //       if (element.bus_id == this.bus_model['bus_id']) {
  //         element = this.bus_model;
  //         bus_existed = true;
  //       }
  //     });

  //     if (!bus_existed) {
  //       this.bus_model['index'] = this.add_bus_list.length;
  //       this.add_bus_list.push(this.bus_model);
  //     }
  //   }
  //   else {
  //     this.add_bus_list.forEach(element => {
  //       if (element.trip_bus_id == this.bus_model['trip_bus_id']) {
  //         element = this.bus_model;
  //       }
  //     });
  //   }

  //   this.busDataSource = new MatTableDataSource(this.add_bus_list);
  //   this.busDataSource.sort = this.sort;

  //   this.bus_model = {
  //     'table_name': 'reg_on_bus', 'reg_bus_id': '0', 'trip_bus_id': '0', 'bus_id': '0', 'depart_date': '',
  //     'flag': 'new', 'key': 'reg_bus_id', 'from_city': '0', 'to_city': '0', 'invoice_no': '', 'comment': '',
  //     'bus_no': '', 'from_city_name': '', 'to_city_name': '', 'male_seat_count': '', 'addition_seat': '',
  //     'seat_price': '', 'seat_cost': '', 'bus_total': '', 'tax_no': ''
  //   };

  //   this.model['bus_dep_date'] = new Date();

  // }

  // editBus(row) {
  //   this.bus_model = row;
  //   this.model['bus_dep_date'] = new Date(this.bus_model['depart_date']);
  // }

  // deleteBus(row) {

  //   let budIndex = this.utils.getDPIndex(this.add_bus_list, 'index', row.index);

  //   // if (row.trip_bus_id != '0') {
  //   //   row.flag = 'delete';
  //   //   this.toDelete.push(row);
  //   // }

  //   this.add_bus_list.splice(budIndex, 1);
  //   this.busDataSource = new MatTableDataSource(this.add_bus_list);
  //   this.busDataSource.sort = this.sort;
  // }


  //-------********************** VISA FUNCTIONS **********************-------//

  // calculate_visa_total() {
  //   if (this.visa_model['visa_price'] != '' && this.visa_model['visa_count'] != '') {
  //     this.visa_model['visa_total'] = (Number(this.visa_model['visa_price']) * Number(this.visa_model['visa_count'])).toFixed(2);
  //     if (this.visa_model['tax_no'] != '')
  //       this.visa_model['price_w_tax'] = (Number(this.visa_model['visa_price']) + Number(this.visa_model['visa_price']) * (Number(this.visa_tax['tax_perc']) / 100)).toFixed(2);
  //     //this.calculate_tax('visa');
  //   }
  // }

  saveVisa() {
    if (this.visa_model['country_id'] == '0') {
      alert(this.Country_Msg);
      return;
    }
    this.country_list.forEach(element => {
      if (element.country_id == this.visa_model['country_id'])
        this.visa_model['country_name'] = element.country_name;
    });

    if (this.visa_model['index'] == '0') {
      this.visa_model['index'] = String(this.add_visa_list.length + 1);
      this.add_visa_list.push(this.visa_model);
    }
    else {
      let visaIndex = this.utils.getDPIndex(this.add_visa_list, 'index', this.visa_model['index']);
      this.add_visa_list[visaIndex] = this.visa_model;
    }

    // if (this.visa_model['reg_visa_id'] == '0') {
    //   let visa_existed = false;
    //   this.add_visa_list.forEach(element => {
    //     if (element.country_id == this.visa_model['country_id']) {
    //       element = this.visa_model;
    //       visa_existed = true;
    //     }
    //   });

    //   if (!visa_existed) {
    //     this.visa_model['index'] = this.add_visa_list.length;
    //     this.add_visa_list.push(this.visa_model);
    //   }
    // }
    // else {
    //   this.add_visa_list.forEach(element => {
    //     if (element.reg_visa_id == this.visa_model['reg_visa_id']) {
    //       element = this.visa_model;
    //     }
    //   });
    // }

    this.visaDataSource = new MatTableDataSource(this.add_visa_list);
    this.visaDataSource.sort = this.sort;

    this.visa_model = {
      'table_name': 'reg_on_visa', 'reg_visa_id': '0', 'invoice_no': '', 'visa_tax_amount': '0',
      'country_id': '', 'country_name': '', 'visa_count': '', 'visa_price': '0', 'visa_cost': '0',
      'visa_total': '', 'tax_no': this.visa_model['tax_no'], 'tax_type': this.visa_model['tax_type'],
      'taxable_price': this.visa_model['taxable_price'], 'discount': '0', 'tax': '0', 'total_amount': '',
      'flag': 'new', 'key': 'reg_visa_id', 'comment': '', 'index': '0',
      'price_w_tax': '0', 'taxable_with_tax': this.visa_model['taxable_with_tax']
    }
    this.calculateVisaTotal();
    // this.calculate_tax('visa');
  }

  editVisa(row) {
    this.visa_model = row;

    if (this.visa_model['tax_type'] != "no_tax" && this.visa_model['tax_no'] != "") {
      // get visa tax detail

      let query = "SELECT * FROM `tax` WHERE `status` = '1' AND `acct_number` = '" + this.visa_model['tax_no'] + "'";
      let obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          if (data.data['list'].length > 0) {
            this.visa_tax = data.data['list'][0];
            this.visa_tax_detail = this.visa_tax['acct_number'] + ' - ' + this.visa_tax['tax_name_ar'] +
              ' - ' + this.visa_tax['tax_name_en'];
          }
        });
    }
  }

  deleteVisa(row) {

    let visaIndex = this.utils.getDPIndex(this.add_visa_list, 'index', row.index);

    if (row.visa_id != '0') {
      row.flag = 'delete';
      this.toDelete.push(row);
    }

    this.add_visa_list.splice(visaIndex, 1);
    // this.calculate_tax('visa');
    this.visaDataSource = new MatTableDataSource(this.add_visa_list);
    this.visaDataSource.sort = this.sort;

    this.calculateVisaTotal();
  }

  //-------********************** HOTEL FUNCTIONS **********************-------//

  calculate_room_total() {
    if (this.hotel_model['room_price'] != '' && this.hotel_model['room_count'] != '') {
      this.hotel_model['hotel_total'] = (Number(this.hotel_model['room_price']) * Number(this.hotel_model['room_count'])).toFixed(2);
      if (this.hotel_model['tax_no'] != '')
        this.hotel_model['price_w_tax'] = (Number(this.hotel_model['room_price']) + Number(this.hotel_model['room_price']) * (Number(this.hotel_tax['tax_perc']) / 100)).toFixed(2);
      //this.calculate_tax('hotel');
    }
  }

  saveRoom() {
    if (this.hotel_model['city_id'] == '0') {
      alert(this.City_Msg);
      return;
    }
    this.hotel_model['city_name'] = (document.getElementById('search_value_11') as HTMLInputElement).value;

    this.hotel_list.forEach(element => {
      if (element.hotel_id == this.hotel_model['hotel_id'])
        this.hotel_model['hotel_name'] = element.hotel_name;
    });

    this.room_list.forEach(element => {
      if (element.room_type_id == this.hotel_model['room_type_id'])
        this.hotel_model['room_type'] = element.room_type;
    });

    this.hotel_model['checkin_date'] = (this.model['checkin_date'].getFullYear() + '-' +
      (this.model['checkin_date'].getMonth() + 1) + '-' + this.model['checkin_date'].getDate());
    this.hotel_model['checkout_date'] = (this.model['checkout_date'].getFullYear() + '-' +
      (this.model['checkout_date'].getMonth() + 1) + '-' + this.model['checkout_date'].getDate());


    if (this.hotel_model['index'] == '0') {
      this.hotel_model['index'] = String(this.add_hotel_list.length + 1);
      this.add_hotel_list.push(this.hotel_model);
    }
    else {
      let roomIndex = this.utils.getDPIndex(this.add_hotel_list, 'index', this.hotel_model['index']);
      console.log(this.hotel_model);
      this.add_hotel_list[roomIndex] = this.hotel_model;
    }

    // if (this.hotel_model['reg_id'] == '0') {
    //   let room_existed = false;
    //   this.add_hotel_list.forEach(element => {
    //     console.log(element.hotel_id);
    //     if (element.hotel_id != '0' && element.hotel_id != '' && element.hotel_id == this.hotel_model['hotel_id']) {
    //       element = this.hotel_model;
    //       room_existed = true;
    //     }
    //   });
    //   console.log(room_existed);
    //   if (!room_existed) {
    //     this.hotel_model['index'] = this.add_hotel_list.length;
    //     this.add_hotel_list.push(this.hotel_model);
    //   }
    // }
    // else {
    //   this.add_hotel_list.forEach(element => {
    //     if (element.reg_id == this.hotel_model['reg_id']) {
    //       element = this.hotel_model;
    //     }
    //   });
    // }

    this.hotelDataSource = new MatTableDataSource(this.add_hotel_list);
    this.hotelDataSource.sort = this.sort;

    this.hotel_model = {
      'table_name': 'reg_on_hotel', 'reg_id': '0', 'invoice_no': '', 'room_type_id': '',
      'flag': 'new', 'key': 'reg_id', 'comment': '', 'city_id': '0', 'hotel_id': '', 'room_count': '',
      'room_price': '0', 'room_cost': '0', 'hotel_total': '', 'package': '', 'city_name': '', 'room_type': '',
      'hotel_name': '', 'room_tax_amount': '0', 'tax_no': this.hotel_model['tax_no'], 
      'tax_type': this.hotel_model['tax_type'], 'taxable_price': this.hotel_model['taxable_price'], 
      'tax': '0','discount': '0', 'total_amount': '', 'checkin_date': '', 'checkout_date': '', 
      'index': '0', 'price_w_tax': '0', 'taxable_with_tax': '0'
    };

    this.cityDetail = '';
    (document.getElementById('search_value_11') as HTMLInputElement).value = this.cityDetail;
    this.hotel_list = [];
    this.model['checkin_date'] = new Date();
    this.model['checkout_date'] = new Date();
    // this.calculate_tax('hotel');
    this.calculateHotelTotal();
  }

  editRoom(row) {
    // let total_tax = this.hotel_model['tax'];
    // let total_amount = this.hotel_model['total_amount'];
    this.hotel_model = row;
    // this.hotel_model['city_id'] = row['city_id'];
    this.cityDetail = row['city_name'];
    (document.getElementById('search_value_11') as HTMLInputElement).value = this.cityDetail;
    this.getHotel();

    // this.hotel_model['tax'] = total_tax;
    // this.hotel_model['total_amount'] = total_amount;

    this.model['checkin_date'] = new Date(row.checkin_date);
    this.model['checkout_date'] = new Date(row.checkout_date);

    if (this.hotel_model['tax_type'] != "no_tax" && this.hotel_model['tax_no'] != "") {
      // get visa tax detail

      let query = "SELECT * FROM `tax` WHERE `status` = '1' AND `acct_number` = '" + this.hotel_model['tax_no'] + "'";
      let obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          if (data.data['list'].length > 0) {
            this.hotel_tax = data.data['list'][0];
            this.room_tax_detail = this.hotel_tax['acct_number'] + ' - ' + this.hotel_tax['tax_name_ar'] +
              ' - ' + this.hotel_tax['tax_name_en'];
          }
        });
    }
  }

  deleteRoom(row) {
    let roomIndex = this.utils.getDPIndex(this.add_hotel_list, 'index', row.index);

    if (row.reg_id != '0') {
      row.flag = 'delete';
      this.toDelete.push(row);
    }

    this.add_hotel_list.splice(roomIndex, 1);
    // this.calculate_tax('hotel');
    this.hotelDataSource = new MatTableDataSource(this.add_hotel_list);
    this.hotelDataSource.sort = this.sort;

    this.calculateHotelTotal();
  }


  //------------------------ On Change Search ------------------------//

  // onChangeMainTraveller = function (acct_number: string) {
  onChangeMainTraveller = function (search_result: object) {
    let old_customer_no = this.invoice_model['customer_no'];
    this.invoice_model['customer_no'] = search_result['no'];
    this.invoice_model['acct_number'] = search_result['no'];
    let travelIndex;
    // this.model['traveler_no'] = (search_result['no'] != '' ? search_result['no'] : '0');

    if (search_result['no'] != '') {
      let query = "SELECT `customer`.*, `traveler_info`.* FROM `customer`, `traveler_info`" +
        " WHERE `customer`.`status` = '1' AND `customer`.`acct_number` = `traveler_info`.`acct_number`" +
        " AND `customer`.`acct_number` = '" + search_result['no'] + "'";

      let obj = { cmd: 'getList', query: query };
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          this.main_trav_info = data.data['list'][0];
          let birthdate = new Date(this.main_trav_info['date_of_birth']);
          let timeDiff = Math.abs(Date.now() - birthdate.getTime());
          let age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365.25);

          if (old_customer_no != '') {
            travelIndex = this.utils.getDPIndex(this.traveler_list, 'acct_number', old_customer_no);

            if (this.traveler_list[travelIndex]['group_id'] != '0') {
              this.traveler_list[travelIndex]['flag'] = 'delete';
              this.traveler_list[travelIndex]['table_name'] = 'trip_group';
              this.toDelete.push(this.traveler_list[travelIndex]);
            }

            this.traveler_list.splice(travelIndex, 1);

            // change total field
            // this.calculsteTotalAmount();
          }

          else
            this.adult_count += 1;

          this.traveler_list.unshift({
            'acct_number': this.main_trav_info['acct_number'], 'customer_name': this.main_trav_info['customer_name'],
            'national_id': this.main_trav_info['national_id'], 'mobile': this.main_trav_info['mobile'],
            'passport_no': this.main_trav_info['passport_no'], 'traveler_type': 'رئيسي', 'comment': '',
            'flag': 'new', 'key': 'group_id', 'departure_date': '',
            'arrival_date': '', 'room_type_id': '', 'type': 'main', 'age': age,
            'relative_relation': 'رئيس المجموعة', 'index': this.traveler_list.length, 'price': '', 'invoice_no': '',
            'group_id': '0', 'bed_count': '1', 'ticket_count': '1'
          });

          // this.travelerDataSource = new MatTableDataSource(this.traveler_list);
          // this.travelerDataSource.sort = this.sort;

          this.invoice_model['pass_count'] = String(Number(this.model['depend_count']) + 1);
        });
    }
    else {
      if (old_customer_no != '') {
        this.main_trav_info = {};
        travelIndex = this.utils.getDPIndex(this.traveler_list, 'acct_number', old_customer_no);

        if (this.traveler_list[travelIndex]['group_id'] != '0') {
          this.traveler_list[travelIndex]['flag'] = 'delete';
          this.traveler_list[travelIndex]['table_name'] = 'trip_group';
          this.toDelete.push(this.traveler_list[travelIndex]);
        }

        this.traveler_list.splice(travelIndex, 1);
        // this.travelerDataSource = new MatTableDataSource(this.traveler_list);
        // this.travelerDataSource.sort = this.sort;

        // change total field
        // this.calculsteTotalAmount();

        this.adult_count -= 1;

        this.invoice_model['pass_count'] = String(Number(this.model['depend_count']) + 1);
      }
    }
  }

  changeDependCount() {
    if (this.invoice_model['customer_no'] != '' && this.invoice_model['customer_no'] != '0')
      this.invoice_model['pass_count'] = String(Number(this.model['depend_count']) + 1);
    else
      this.invoice_model['pass_count'] = String(Number(this.model['depend_count']));

    this.showTravelerTable = (Number(this.model['depend_count']) == 0 || (Number(this.model['depend_count']) > 0 && this.model['chx_addDepend'] == '1'));
    // this.showRoomTable = (Number(this.model['depend_count']) > 0 && this.model['chx_addDepend'] == '0');
  }

  // onChangeDepend = function (acct_number: string) {
  onChangeDepend = function (search_result: object) {
    this.model['depend_no'] = search_result['no'];
  }

  onChangeFromAirport = function (search_result: object) {
    this.ticket_model['from_airport'] = (search_result['no'] != '' ? search_result['no'] : '0');
  }

  onChangeToAirport = function (search_result: object) {
    this.ticket_model['to_airport'] = (search_result['no'] != '' ? search_result['no'] : '0');
  }

  onChangeAirline = function (search_result: object) {
    this.ticket_model['airline_id'] = (search_result['no'] != '' ? search_result['no'] : '0');
  }

  onChangeFromCity = function (search_result: object) {
    this.bus_model['from_city'] = (search_result['no'] != '' ? search_result['no'] : '0');
  }

  onChangeToCity = function (search_result: object) {
    this.bus_model['to_city'] = (search_result['no'] != '' ? search_result['no'] : '0');
  }

  onChangeCity = function (search_result: object) {
    this.hotel_model['city_id'] = (search_result['no'] != '' ? search_result['no'] : '0');
    if (search_result['no'] != '')
      this.getHotel();
  }

  onChangeBusTax = function (search_result: object) {
    this.bus_model['tax_no'] = (search_result['no'] != '' ? search_result['no'] : '');

    if (this.bus_model['tax_no'] != '') { 
      let query = "SELECT * FROM `tax` WHERE `status` = '1' AND `acct_number` = '" + this.bus_model['tax_no'] + "'";
      let obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          if (data.data['list'].length > 0)
            this.bus_tax = data.data['list'][0];

          console.log(this.bus_tax);
          this.getBusPrice();

          // if (this.bus_model['tax_type'] == 'all_price')
          //   this.get_price('bus');
          // else
          //   this.calculate_tax('bus');

          // if (this.bus_model['price_w_tax'] != '0' && this.bus_model['price_w_tax'] != '' && this.bus_model['seat_price'] == '')
          //   this.get_price('bus');
        });
    }
    else
     this.bus_tax = {};
  }

  onChangeTicketTax = function (search_result: object) {
    this.ticket_model['tax_no'] = search_result['no'];

    if (this.ticket_model['tax_no'] != '') {
      let query = "SELECT * FROM `tax` WHERE `status` = '1' AND `acct_number` = '" + this.ticket_model['tax_no'] + "'";
      let obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          if (data.data['list'].length > 0)
            this.ticket_tax = data.data['list'][0];
          console.log(this.ticket_tax);

          this.calculateTicketTotal();
        });
    }

    // this.flight_price.forEach(element => {
    //   this.calculate_ticket_total(element);
    // });
  }

  onChangeVisaTax = function (search_result: object) {
    this.visa_model['tax_no'] = search_result['no'];

    if (this.visa_model['tax_no'] != '') {
      let query = "SELECT * FROM `tax` WHERE `status` = '1' AND `acct_number` = '" + this.visa_model['tax_no'] + "'";
      let obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          if (data.data['list'].length > 0)
            this.visa_tax = data.data['list'][0];
          console.log(this.visa_tax);
          this.getVisaPrice();

          // this.calculate_tax('visa');
          // if (this.visa_model['price_w_tax'] != '0' && this.visa_model['price_w_tax'] != '' && this.visa_model['visa_price'] == '')
          //   this.get_price('visa');
        });
    }
  }

  onChangeHotelTax = function (search_result: object) {
    this.hotel_model['tax_no'] = search_result['no'];

    if (this.hotel_model['tax_no'] != '') {
      let query = "SELECT * FROM `tax` WHERE `status` = '1' AND `acct_number` = '" + this.hotel_model['tax_no'] + "'";
      let obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          if (data.data['list'].length > 0)
            this.hotel_tax = data.data['list'][0];
          console.log(this.hotel_tax);
          this.getHotelPrice();

          // this.calculate_tax('hotel');
          // if (this.hotel_model['price_w_tax'] != '0' && this.hotel_model['price_w_tax'] != '' && this.hotel_model['room_price'] == '')
          //   this.get_price('hotel');
        });
    }
  }


  onChangeExtTax = function (search_result: object) {
    this.ext_model['tax_no'] = search_result['no'];

    if (this.ext_model['tax_no'] != '') {
      let query = "SELECT * FROM `tax` WHERE `status` = '1' AND `acct_number` = '" + this.ext_model['tax_no'] + "'";
      let obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          if (data.data['list'].length > 0)
            this.ext_tax = data.data['list'][0];
          console.log(this.ext_model);

          this.getExtPrice();
        });
    }
  }

  onChangeCcSearch = function (search_result: object) {
  
    if (search_result['no'] != '')
      this.invoice_model['cost_center'] = search_result['no'];
    else
      this.invoice_model['cost_center'] = '0';
  }

  //------------------------ Calculating Tax ------------------------//
  changeTicketTax() {

    // if (this.ticket_model['tax_type'] == 'all_price')
    //   this.flightDisplayedColumns = ['type', 'count', 'price_w_tax', 'price', 'cost', 'tax', 'total'];
    // else if (this.ticket_model['tax_type'] == 'part_price')
    //   this.flightDisplayedColumns = ['type', 'count', 'price_w_tax', 'taxable_price', 'cost', 'price', 
    //     'tax', 'total'];
    // else if (this.ticket_model['tax_type'] == 'income_price')
    //   this.flightDisplayedColumns = ['type', 'count', 'price_w_tax', 'cost', 'price', 'tax', 'total'];
    // else if (this.ticket_model['tax_type'] == 'no_tax')
    //   this.flightDisplayedColumns = ['type', 'count', 'price', 'cost', 'total'];

    this.calculateTicketTotal();
  }

  _calculatePriceTax(tax_perc, taxType, count, taxablePrice, taxablePriceWithTax, price, priceWithTax, cost, discount, calculateField) {
    console.log('taxablePriceWithTax: ' + taxablePriceWithTax);
    let totalToBeTaxed;
    let taxAmount;
    discount = Number(discount); tax_perc = Number(tax_perc); price = Number(price); 
    count = Number(count); priceWithTax = Number(priceWithTax);
    cost = Number(cost); taxablePrice = Number(taxablePrice); taxablePriceWithTax = Number(taxablePriceWithTax);
    // calculate Tax Amount
    switch(taxType) {

      case "all_price": 
        calculateField = (calculateField == '' ? (priceWithTax != 0? 'PWT': 'P') : calculateField);
        if (calculateField == 'PWT') { // calculate price
          taxAmount = (((priceWithTax * count - discount) * tax_perc / 100) / ( 1 + tax_perc / 100)).toFixed(2);
        } else if (calculateField == 'P') { // calculate price_w_tax
          taxAmount = ((price * count - discount) * tax_perc / 100).toFixed(2);
        }
        taxablePriceWithTax = 0;
        break;

      case "part_price": 
        taxablePrice = 0;
        if (calculateField == 'TWT') { // Taxable price with Tax
          taxablePrice = Number((taxablePriceWithTax / ( 1 + tax_perc / 100 )).toFixed(2));
        } else if(calculateField == 'TP') { // Taxable price
          taxablePriceWithTax =  Number((taxablePrice * ( 1 + tax_perc / 100 )).toFixed(2)) ;
        }
        taxAmount = (taxablePriceWithTax * count - (taxablePriceWithTax * count / ( 1 + tax_perc / 100 ))).toFixed(2);
        if (taxablePrice == 0)
          taxablePrice = (taxablePriceWithTax - (count > 1 ? (taxAmount / count) : taxAmount)).toFixed(2);
        break;

      case "income_price": 
        calculateField = (calculateField == '' ? (priceWithTax != 0 ? 'PWT': 'P') : calculateField);
        if (calculateField == 'P') { // calculate price_w_tax
          taxAmount = ((tax_perc / 100) * ((price - cost) * count)).toFixed(2); // ((tax_perc / 100 * ((price - cost) * count)) / (1 + tax_perc / 100)).toFixed(2);
          priceWithTax = (price + (count > 0 ? (taxAmount / count) : 0)).toFixed(2);
        } else if (calculateField == 'PWT') {
          taxAmount = (((priceWithTax - cost) * count) - (((priceWithTax - cost) * count) / (1 + tax_perc / 100))).toFixed(2);
        }
        taxablePriceWithTax = (priceWithTax - cost).toFixed(2);
        taxablePrice = (taxablePriceWithTax - (count > 1 ? (taxAmount / count) : taxAmount)).toFixed(2);
        break;

      case "no_tax": 
        tax_perc = 0;
        taxablePriceWithTax = 0;
        taxAmount = 0;
        break;

      default: console.error(`Invalid tax type: ${taxType}`);
    }
    
    if ((calculateField != 'P' && priceWithTax != 0) || calculateField == 'PWT') { // calculate price
      price = (priceWithTax - (count > 0 ? (taxAmount / count) : 0)).toFixed(2);
    } else if ((calculateField != 'PWT' && price != 0) || calculateField == 'P') { // calculate Price with tax
      priceWithTax = (price + (count > 0 ? (taxAmount / count) : 0)).toFixed(2);
    }
    taxAmount = taxAmount;
    return {totalToBeTaxed: totalToBeTaxed, taxablePrice: taxablePrice, taxablePriceWithTax: taxablePriceWithTax, price: price, priceWithTax: priceWithTax, taxAmount: taxAmount};
    
  }

  _calculateTicketPrice(type, row) {
    console.log(row.index);
    let priceWtaxField, priceField, taxablePriceField, costField,discountField, taxField, totalField;
    
    priceWtaxField    = (document.getElementById('price_w_tax_'   + row.index) as HTMLInputElement);
    taxablePriceField = (document.getElementById('taxable_price_' + row.index) as HTMLInputElement);
    priceField        = (document.getElementById('price_'         + row.index) as HTMLInputElement);
    costField         = (document.getElementById('cost_'          + row.index) as HTMLInputElement);
    taxField          = (document.getElementById('tax_'           + row.index) as HTMLInputElement);
    discountField     = (document.getElementById('discount_'      + row.index) as HTMLInputElement);
    totalField        = (document.getElementById('total_'         + row.index) as HTMLInputElement);   
    
    if (this.ticket_model['tax_type'] == 'no_tax') {
      this.ticket_tax = {};
      this.ticket_model['tax_no'] = '';
    }
    else if (this.ticket_model['tax_no'] == '') 
      return;

    let calculateField = (type == 'price_w_tax' ? 'PWT' : (type == 'price'? 'P' : ''));
    
    let taxObj = this._calculatePriceTax(this.ticket_tax['tax_perc'], this.ticket_model['tax_type'], row.count, 0, taxablePriceField.value, priceField.value, priceWtaxField.value, costField.value, discountField.value, calculateField);
    // console.log(taxObj);
  
    taxablePriceField.value = taxObj.taxablePriceWithTax;
    taxField.value = taxObj.taxAmount;
    priceWtaxField.value = taxObj.priceWithTax;
    priceField.value = taxObj.price;
    // row.count = 1; // TEMP for testing
    totalField.value = ((Number(row.count) * taxObj.priceWithTax) - Number(discountField.value)).toFixed(2);

    this.ticket_model[row.index + '_price_w_tax'] = priceWtaxField.value;
    this.ticket_model[row.index + '_tax_amount' ] = taxField.value;
    this.ticket_model[row.index + '_price'      ] = priceField.value;
    this.ticket_model[row.index + '_cost'       ] = costField.value;
    this.ticket_model[row.index + '_count'      ] = row.count;
    this.ticket_model[row.index + '_total_price'] = totalField.value;
    this.ticket_model[row.index + '_discount'   ] = discountField.value;
    this.ticket_model[row.index + '_part_price' ] = taxablePriceField.value;
  }

  getTicketPrice(type, row) {
    let priceWtaxField, priceField, taxablePriceField, costField,discountField, taxField, totalField;
    let total_price = 0, tax_amount = 0, taxable_price = 0;
    
    priceWtaxField = (document.getElementById('price_w_tax_' + row.index) as HTMLInputElement);
    taxablePriceField = (document.getElementById('taxable_price_' + row.index) as HTMLInputElement);
    priceField = (document.getElementById('price_' + row.index) as HTMLInputElement);
    costField = (document.getElementById('cost_' + row.index) as HTMLInputElement);
    taxField = (document.getElementById('tax_' + row.index) as HTMLInputElement);
    discountField = (document.getElementById('discount_' + row.index) as HTMLInputElement);
    totalField = (document.getElementById('total_' + row.index) as HTMLInputElement);    
/*
    if (this.ticket_model['tax_no'] != '' ) { // tax is selected

      if (type == 'price_w_tax' && Number(priceWtaxField.value) > 0) {

        total_price = Number(priceWtaxField.value) * Number(row.count);
        if (this.ticket_model['tax_type'] == 'all_price') {

          if (this.ticket_tax['tax_perc'] != '0')
            priceField.value = (Number(priceWtaxField.value) / (1 + (Number(this.ticket_tax['tax_perc']) / 100))).toFixed(2);
          else
            priceField.value = (Number(priceWtaxField.value) - Number(this.ticket_tax['tax_amount'])).toFixed(2);

          tax_amount = Number(priceWtaxField.value) - Number(priceField.value);
          taxField.value = tax_amount.toFixed(2);
          totalField.value = total_price.toFixed(2);
          taxablePriceField.value = '0';
          this.ticket_model[row.index + '_part_price'] = '0';
        }
        else if (this.ticket_model['tax_type'] == 'part_price') {

          this.ticket_model[row.index + '_part_price'] = (Number(taxablePriceField.value)).toString();
          if (Number(taxablePriceField.value) > 0) {
            if (this.ticket_tax['tax_perc'] != '0') 
              taxable_price = Number(taxablePriceField.value) / (1 + (Number(this.ticket_tax['tax_perc']) / 100));
            else 
              taxable_price = Number(taxablePriceField.value) - this.ticket_tax['tax_amount'];

            tax_amount = Number(taxablePriceField.value) - taxable_price;

            priceField.value = (Number(priceWtaxField.value) - Number(taxablePriceField.value) + taxable_price).toFixed(2);
            taxField.value = tax_amount.toFixed(2);
            totalField.value = total_price.toFixed(2);
            this.ticket_model[row.index + '_part_price'] = taxable_price.toFixed(2);
          }
          else {
            priceField.value = '0';
            taxField.value = '0';
            totalField.value = '0';
            this.ticket_model[row.index + '_part_price'] = '0';
          }
        }
        else if (this.ticket_model['tax_type'] == 'income_price') {

          if (Number(costField.value) > 0) {
            if (this.ticket_tax['tax_perc'] != '0') 
              taxable_price = (Number(priceWtaxField.value) - Number(costField.value)) / (1 + (Number(this.ticket_tax['tax_perc']) / 100));
            else 
              taxable_price = (Number(priceWtaxField.value) - Number(costField.value)) - this.ticket_tax['tax_amount'];

            tax_amount = Number(priceWtaxField.value) - (Number(costField.value) + taxable_price);

            priceField.value = (Number(costField.value) + taxable_price).toFixed(2);
            taxField.value = tax_amount.toFixed(2);
            totalField.value = total_price.toFixed(2);
            this.ticket_model[row.index + '_part_price'] = taxable_price.toFixed(2);
          }
          else {
            taxablePriceField.value = '0';
            priceField.value = '0';
            taxField.value = '0';
            totalField.value = '0';
            this.ticket_model[row.index + '_part_price'] = '0';
          }
        }
      }
      else if (type == 'taxable_price' && this.ticket_model['tax_type'] == 'part_price') {
        
        total_price = Number(priceWtaxField.value) * Number(row.count);

        if (Number(taxablePriceField.value) > 0 ) {
          if (this.ticket_tax['tax_perc'] != '0') 
            taxable_price = Number(taxablePriceField.value) / (1 + (Number(this.ticket_tax['tax_perc']) / 100));
          else 
            taxable_price = Number(taxablePriceField.value) - this.ticket_tax['tax_amount'];

          tax_amount = Number(taxablePriceField.value) - taxable_price;

          if (Number(priceWtaxField.value) > 0)
            priceField.value = (Number(priceWtaxField.value) - Number(taxablePriceField.value) + taxable_price).toFixed(2);
          else 
            priceField.value = taxable_price.toFixed(2);

          taxField.value = tax_amount.toFixed(2);
          totalField.value = total_price.toFixed(2);
          this.ticket_model[row.index + '_part_price'] = taxable_price.toFixed(2);
        }
        else {
          priceField.value = '0';
          taxField.value = '0';
          totalField.value = '0';
        }
      }
      else if (type == 'cost' && this.ticket_model['tax_type'] == 'income_price' && 
        Number(priceWtaxField.value) > 0 && Number(costField.value) > 0) {
        
        total_price = Number(priceWtaxField.value) * Number(row.count);
        if (this.ticket_tax['tax_perc'] != '0') 
          taxable_price = (Number(priceWtaxField.value) - Number(costField.value)) / (1 + (Number(this.ticket_tax['tax_perc']) / 100));
        else 
          taxable_price = (Number(priceWtaxField.value) - Number(costField.value)) - this.ticket_tax['tax_amount'];

        tax_amount = Number(priceWtaxField.value) - (Number(costField.value) + taxable_price);

        priceField.value = (Number(costField.value) + taxable_price).toFixed(2);
        taxField.value = tax_amount.toFixed(2);
        totalField.value = total_price.toFixed(2);
        this.ticket_model[row.index + '_part_price'] = taxable_price.toFixed(2);
        taxablePriceField.value = (Number(priceWtaxField.value) - Number(costField.value)).toFixed(2);
      }
      else if (type == 'price' && Number(priceField.value) > 0) {
        if (this.ticket_model['tax_type'] == 'all_price') {

          if (this.ticket_tax['tax_perc'] != '0')
            tax_amount = Number(priceField.value) * (Number(this.ticket_tax['tax_perc']) / 100);
          else
            tax_amount = Number(priceField.value) + Number(this.ticket_tax['tax_amount']);

          total_price = (Number(priceField.value) + tax_amount) * Number(row.count);

          priceWtaxField.value = (Number(priceField.value) + tax_amount).toFixed(2);
          taxField.value = tax_amount.toFixed(2);
          totalField.value = total_price.toFixed(2);
          taxablePriceField.value = '0';
          this.ticket_model[row.index + '_part_price'] = '0';
        }
        else if (this.ticket_model['tax_type'] == 'part_price') {
          priceWtaxField.value = (Number(priceField.value) + Number(taxField.value)).toFixed(2);
          total_price = (Number(priceField.value) + Number(taxField.value)) * Number(row.count);
          
          totalField.value = total_price.toFixed(2);
        }
        else if (this.ticket_model['tax_type'] == 'income_price') {
          taxable_price = Number(priceField.value) - Number(costField.value);
          
          if (this.ticket_tax['tax_perc'] != '0')
            tax_amount = taxable_price * (Number(this.ticket_tax['tax_perc']) / 100);
          else
            tax_amount = taxable_price + Number(this.ticket_tax['tax_amount']);

          priceWtaxField.value = (Number(priceField.value) + tax_amount).toFixed(2);
          total_price = (Number(priceField.value) + tax_amount) * Number(row.count);

          taxField.value = tax_amount.toFixed(2);
          totalField.value = total_price.toFixed(2);
          taxablePriceField.value = taxable_price.toFixed(2);
          this.ticket_model[row.index + '_part_price'] = taxable_price.toFixed(2);
        }
      }
      else {
        taxablePriceField.value = '0';
        priceField.value = '0';
        taxField.value = '0';
        totalField.value = '0';
        this.ticket_model[row.index + '_part_price'] = '0';
      }

      // if (this.ticket_model['tax_type'] == 'all_price') {
        // if (row == null) {
        //   this.flight_price.forEach(element => {
        //     priceField = (document.getElementById('price_' + element.index) as HTMLInputElement);
        //     priceWtaxField = (document.getElementById('price_w_tax_' + element.index) as HTMLInputElement);
        //     taxField = (document.getElementById('tax_' + element.index) as HTMLInputElement);
        //     totalField = (document.getElementById('total_' + element.index) as HTMLInputElement);
    
        //     if (priceWtaxField.value != '' && priceWtaxField.value != '0') {
        //       priceField.value = (Number(priceWtaxField.value) / (1 + (Number(this.ticket_tax['tax_perc']) / 100))).toFixed(2);
        //       total_price = Number(priceWtaxField.value) * Number(element.count);
        //       if (this.ticket_tax['tax_perc'] != '0')
        //         tax_amount = (Number(priceField.value) * (Number(this.ticket_tax['tax_perc']) / 100)).toFixed(2);
        //       else 
        //         tax_amount = this.ticket_tax['tax_amount'];

        //       taxField.value = tax_amount;
        //       totalField.value = (total_price + Number(tax_amount)).toFixed(2);
        //     }
        //     else {
        //       priceField.value = '0';
        //       taxField.value = '0';
        //       totalField.value = '0';
        //     }
        //     this.ticket_model[element.index + '_tax_amount'] = taxField.value;
        //     this.ticket_model[element.index + '_price'] = priceField.value;
        //     this.ticket_model[element.index + '_cost'] = (document.getElementById('cost_' + element.index) as HTMLInputElement).value;
        //     this.ticket_model[element.index + '_count'] = element.count;
        //   });
        // }
        // else {
          
        // }
      // }
    }
    else if (this.ticket_model['tax_type'] == 'no_tax' && type == 'price') {
      total_price = Number(priceField.value) * Number(row.count);

      priceWtaxField.value = '0';
      taxablePriceField.value = '0';
      taxField.value = '0';
      totalField.value = total_price.toFixed(2);
      this.ticket_model[row.index + '_part_price'] = '0';
    }
*/
    /* Start of new code */
    // get tax percentage and taxed amount
    // this.ticket_tax['tax_perc']
    this._calculateTicketPrice(type, row);
    /* End of new code */

    // this.ticket_model[row.index + '_price_w_tax'] = priceWtaxField.value;
    // this.ticket_model[row.index + '_tax_amount'] = taxField.value;
    // this.ticket_model[row.index + '_price'] = priceField.value;
    // this.ticket_model[row.index + '_cost'] = costField.value;
    // this.ticket_model[row.index + '_count'] = row.count;
    // this.ticket_model[row.index + '_total_price'] = totalField.value;
  }

  calculateTicketTotal() {

    this.flight_price.forEach(element => {
      this._calculateTicketPrice('', element);
    });
    // let priceWtaxField, taxablePriceField, costField, priceField, taxField, totalField;
    // let total_price, tax_amount, taxable_price;
/*
    if (this.ticket_model['tax_type'] == 'no_tax') {
      this.ticket_model['tax_no'] = '';
      this.ticket_tax = {};
      this.ticket_tax_detail = '';

      this.flight_price.forEach(element => {
        taxablePriceField = (document.getElementById('taxable_price_' + element.index) as HTMLInputElement);
        priceField = (document.getElementById('price_' + element.index) as HTMLInputElement);
        costField = (document.getElementById('cost_' + element.index) as HTMLInputElement);
        totalField = (document.getElementById('total_' + element.index) as HTMLInputElement);

        totalField.value = (Number(priceField.value) * Number(element.count)).toFixed(2);
        taxablePriceField.value = '0';
        costField.value = '0';
       
        this.ticket_model[element.index + '_tax_amount'] = '0';
        this.ticket_model[element.index + '_part_price'] = '0';
        this.ticket_model[element.index + '_price'] = priceField.value;
        this.ticket_model[element.index + '_cost'] = costField.value;
        this.ticket_model[element.index + '_count'] = element.count;
        this.ticket_model[element.index + '_total_price'] = totalField.value;
      });
    }
    else if (this.ticket_model['tax_no'] != '') {

      if (this.ticket_model['tax_type'] == 'all_price') {

        this.flight_price.forEach(element => {
          
          priceWtaxField = (document.getElementById('price_w_tax_' + element.index) as HTMLInputElement);
          taxablePriceField = (document.getElementById('taxable_price_' + element.index) as HTMLInputElement);
          costField = (document.getElementById('cost_' + element.index) as HTMLInputElement);
          priceField = (document.getElementById('price_' + element.index) as HTMLInputElement);
          taxField = (document.getElementById('tax_' + element.index) as HTMLInputElement);
          totalField = (document.getElementById('total_' + element.index) as HTMLInputElement);

          if (Number(priceWtaxField.value) > 0) {
            total_price = Number(priceWtaxField.value) * Number(element.count);
            if (this.ticket_tax['tax_perc'] != '0')
              priceField.value = (Number(priceWtaxField.value) / (1 + (Number(this.ticket_tax['tax_perc']) / 100))).toFixed(2);
            else
              priceField.value = (Number(priceWtaxField.value) - Number(this.ticket_tax['tax_amount'])).toFixed(2);

            tax_amount = Number(priceWtaxField.value) - Number(priceField.value);
            taxField.value = tax_amount.toFixed(2);
            totalField.value = total_price.toFixed(2);
          }
          else {
            priceField.value = '0';
            taxField.value = '0';
            totalField.value = '0';
          }
          taxablePriceField.value = '0';
          this.ticket_model[element.index + '_part_price'] = '0';

          this.ticket_model[element.index + '_price_w_tax'] = priceWtaxField.value;
          this.ticket_model[element.index + '_tax_amount'] = taxField.value;
          this.ticket_model[element.index + '_price'] = priceField.value;
          this.ticket_model[element.index + '_cost'] = costField.value;
          this.ticket_model[element.index + '_count'] = element.count;
          this.ticket_model[element.index + '_total_price'] = totalField.value;
        });
      }
      else if (this.ticket_model['tax_type'] == 'part_price') {
        
        this.flight_price.forEach(element => {
         
          priceWtaxField = (document.getElementById('price_w_tax_' + element.index) as HTMLInputElement);
          costField = (document.getElementById('cost_' + element.index) as HTMLInputElement);
          priceField = (document.getElementById('price_' + element.index) as HTMLInputElement);
          taxField = (document.getElementById('tax_' + element.index) as HTMLInputElement);
          totalField = (document.getElementById('total_' + element.index) as HTMLInputElement);
          taxablePriceField = (document.getElementById('taxable_price_' + element.index) as HTMLInputElement);

          this.ticket_model[element.index + '_part_price'] = (Number(taxablePriceField.value)).toString();
          if (Number(taxablePriceField.value) > 0) {
            total_price = Number(priceWtaxField.value) * Number(element.count);
            if (this.ticket_tax['tax_perc'] != '0') 
              taxable_price = Number(taxablePriceField.value) / (1 + (Number(this.ticket_tax['tax_perc']) / 100));
            else 
              taxable_price = Number(taxablePriceField.value) - this.ticket_tax['tax_amount'];
  
            tax_amount = Number(taxablePriceField.value) - taxable_price;
  
            if (Number(priceWtaxField.value) > 0)
              priceField.value = (Number(priceWtaxField.value) - Number(taxablePriceField.value) + taxable_price).toFixed(2);
            else 
              priceField.value = taxable_price.toFixed(2);
  
            taxField.value = tax_amount.toFixed(2);
            totalField.value = total_price.toFixed(2);
          }
          else {
            priceField.value = '0';
            taxField.value = '0';
            totalField.value = '0';
          }

          this.ticket_model[element.index + '_price_w_tax'] = priceWtaxField.value;
          this.ticket_model[element.index + '_tax_amount'] = taxField.value;
          this.ticket_model[element.index + '_price'] = priceField.value;
          this.ticket_model[element.index + '_cost'] = costField.value;
          this.ticket_model[element.index + '_count'] = element.count;
          this.ticket_model[element.index + '_total_price'] = totalField.value;
        });
      }
      else if (this.ticket_model['tax_type'] == 'income_price') {

        this.flight_price.forEach(element => {
          
          priceWtaxField = (document.getElementById('price_w_tax_' + element.index) as HTMLInputElement);
          taxablePriceField = (document.getElementById('taxable_price_' + element.index) as HTMLInputElement);
          costField = (document.getElementById('cost_' + element.index) as HTMLInputElement);
          priceField = (document.getElementById('price_' + element.index) as HTMLInputElement);
          taxField = (document.getElementById('tax_' + element.index) as HTMLInputElement);
          totalField = (document.getElementById('total_' + element.index) as HTMLInputElement);

          if (Number(priceWtaxField.value) > 0 && Number(costField.value) > 0) {
            total_price = Number(priceWtaxField.value) * Number(element.count);
            if (this.ticket_tax['tax_perc'] != '0') 
              taxable_price = (Number(priceWtaxField.value) - Number(costField.value)) / (1 + (Number(this.ticket_tax['tax_perc']) / 100));
            else 
              taxable_price = (Number(priceWtaxField.value) - Number(costField.value)) - this.ticket_tax['tax_amount'];

            tax_amount = Number(priceWtaxField.value) - (Number(costField.value) + taxable_price);

            priceField.value = (Number(costField.value) + taxable_price).toFixed(2);
            taxField.value = tax_amount.toFixed(2);
            totalField.value = total_price.toFixed(2);
            this.ticket_model[element.index + '_part_price'] = (Number(priceWtaxField.value) - Number(costField.value)).toFixed(2);
            taxablePriceField.value = (Number(priceWtaxField.value) - Number(costField.value)).toFixed(2);
          }
          else {
            taxablePriceField.value = '0';
            priceField.value = '0';
            taxField.value = '0';
            totalField.value = '0';
            this.ticket_model[element.index + '_part_price'] = '0';
          }

          this.ticket_model[element.index + '_price_w_tax'] = priceWtaxField.value;
          this.ticket_model[element.index + '_tax_amount'] = taxField.value;
          this.ticket_model[element.index + '_price'] = priceField.value;
          this.ticket_model[element.index + '_cost'] = costField.value;
          this.ticket_model[element.index + '_count'] = element.count;
          this.ticket_model[element.index + '_total_price'] = totalField.value;
        });
      }
    }
*/
    // if (this.ticket_model['tax_type'] != 'no_tax' && this.ticket_model['tax_no'] != '') {

    //   let price, total_price, tax_amount, taxable_price, cost, profit;

    //   this.flight_price.forEach(element => {
    //     console.log(element);
    //     if (element.count > 0) {
    //       price = (document.getElementById('price_' + element.index) as HTMLInputElement).value;

    //       if (this.ticket_model['tax_type'] == 'all_price') {
    //         let price_w_tax = (document.getElementById('price_w_tax_' + element.index) as HTMLInputElement).value;

    //         // if (price_w_tax != '' && price_w_tax != '0')
    //         //   this.getTicketPrice();
    //         // else 
    //         if (price != '' && price != '0') {
    //           total_price = (Number(price) * Number(element.count)).toFixed(2);
    //           tax_amount = (Number(total_price) * (Number(this.ticket_tax['tax_perc']) / 100)).toFixed(2);
    //           (document.getElementById('tax_' + element.index) as HTMLInputElement).value = tax_amount;
    //           (document.getElementById('total_' + element.index) as HTMLInputElement).value = (Number(total_price) + Number(tax_amount)).toFixed(2);
    //           price_w_tax = (Number(price) + Number(price) * (Number(this.ticket_tax['tax_perc']) / 100)).toFixed(2);

    //         }
    //       }
    //       else if (this.ticket_model['tax_type'] == 'part_price') {

    //         console.log((document.getElementById('taxable_price_' + element.index) as HTMLInputElement));
    //         taxable_price = (document.getElementById('taxable_price_' + element.index) as HTMLInputElement).value;
    //         if (element.index == 'adult')
    //           this.adult_taxable = Number(taxable_price);
    //         else if (element.index == 'child')
    //           this.child_taxable = Number(taxable_price);
    //         else if (element.index == 'infant')
    //           this.infant_taxable = Number(taxable_price);
    //         total_price = '0';
    //         tax_amount = '0';

    //         if (price != '')
    //           total_price = (Number(price) * Number(element.count)).toFixed(2);
    //         if (taxable_price != '') {
    //           if (Number(taxable_price) > Number(total_price))
    //             taxable_price = total_price;
    //           tax_amount = (Number(taxable_price) * (Number(this.ticket_tax['tax_perc']) / 100)).toFixed(2);
    //         }
    //         console.log(price);
    //         console.log(element.count);
    //         console.log(total_price);
    //         console.log(tax_amount);
    //         (document.getElementById('tax_' + element.index) as HTMLInputElement).value = tax_amount;
    //         (document.getElementById('total_' + element.index) as HTMLInputElement).value = (Number(total_price) + Number(tax_amount)).toFixed(2);

    //         this.ticket_model[element.index + '_part_price'] = (document.getElementById('taxable_price_' + element.index) as HTMLInputElement).value;

    //         // this.flight_price.forEach(element => {
    //         //   price = (document.getElementById('price_' + element.index) as HTMLInputElement).value;

    //         //   this.ticket_model[element.index + '_tax_amount'] = (document.getElementById('tax_' + element.index) as HTMLInputElement).value;
    //         // });
    //       }

    //       else if (this.ticket_model['tax_type'] == 'income_price') {
    //         cost = (document.getElementById('cost_' + element.index) as HTMLInputElement).value;

    //         if (price != '' && cost != '') {
    //           profit = ((Number(price) - Number(cost)) * Number(element.count)).toFixed(2);
    //           tax_amount = (Number(profit) * (Number(this.ticket_tax['tax_perc']) / 100)).toFixed(2);
    //           total_price = (Number(price) * Number(element.count)).toFixed(2);
    //           (document.getElementById('tax_' + element.index) as HTMLInputElement).value = tax_amount;
    //           (document.getElementById('total_' + element.index) as HTMLInputElement).value = (Number(total_price) + Number(tax_amount)).toFixed(2);
    //         }

    //         // this.flight_price.forEach(element => {
    //         //   price = (document.getElementById('price_' + element.index) as HTMLInputElement).value;

    //         //   this.ticket_model[element.index + '_tax_amount'] = (document.getElementById('tax_' + element.index) as HTMLInputElement).value;
    //         // });
    //       }

    //       this.ticket_model[element.index + '_tax_amount'] = (document.getElementById('tax_' + element.index) as HTMLInputElement).value;
    //       this.ticket_model[element.index + '_price'] = (document.getElementById('price_' + element.index) as HTMLInputElement).value;
    //       this.ticket_model[element.index + '_cost'] = (document.getElementById('cost_' + element.index) as HTMLInputElement).value;
    //       this.ticket_model[element.index + '_count'] = element.count;
    //     }

    //   });

    //   // let query = "SELECT * FROM `tax` WHERE `status` = '1' AND `acct_number` = '" + this.ticket_model['tax_no'] + "'";
    //   // let obj = { cmd: 'getList', query: query };

    //   // this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //   //   .subscribe(data => {
    //   //     this.applicationConstants.appComp.hideBusyCursor();
    //   //     let tax = data.data['list'][0];
    //   //     console.log(tax);

    //   //     if (data.data['list'].length > 0) {

    //   //       if (this.ticket_model['tax_type'] == 'all_price') {
    //   //         this.flight_price.forEach(element => {
    //   //           price = (document.getElementById('price_' + element.index) as HTMLInputElement).value;
    //   //           if (price != '') {
    //   //             total_price = (Number(price) * Number(element.count)).toFixed(2);
    //   //             tax_amount = (Number(total_price) * (Number(tax['tax_perc']) / 100)).toFixed(2);
    //   //             (document.getElementById('tax_' + element.index) as HTMLInputElement).value = tax_amount;
    //   //             (document.getElementById('total_' + element.index) as HTMLInputElement).value = (Number(total_price) + Number(tax_amount)).toFixed(2);
    //   //           }

    //   //           this.ticket_model[element.index + '_tax_amount'] = (document.getElementById('tax_' + element.index) as HTMLInputElement).value;
    //   //         }); 
    //   //       }

    //   //       else if (this.ticket_model['tax_type'] == 'part_price') {
    //   //         this.flight_price.forEach(element => {
    //   //           price = (document.getElementById('price_' + element.index) as HTMLInputElement).value;
    //   //           taxable_price = (document.getElementById('taxable_price_' + element.index) as HTMLInputElement).value;
    //   //           if (element.index == 'adult')
    //   //             this.adult_taxable = Number(taxable_price);
    //   //           else if (element.index == 'child')
    //   //             this.child_taxable = Number(taxable_price);
    //   //           else if (element.index == 'infant')
    //   //             this.infant_taxable = Number(taxable_price);
    //   //           total_price = '0';
    //   //           tax_amount = '0';

    //   //           if (price != '')
    //   //             total_price = (Number(price) * Number(element.count)).toFixed(2);
    //   //           if (taxable_price != '') {
    //   //             if (Number(taxable_price) > Number(total_price))
    //   //               taxable_price = total_price;
    //   //             tax_amount = (Number(taxable_price) * (Number(tax['tax_perc']) / 100)).toFixed(2);
    //   //           }
    //   //           (document.getElementById('tax_' + element.index) as HTMLInputElement).value = tax_amount;
    //   //           (document.getElementById('total_' + element.index) as HTMLInputElement).value = (Number(total_price) + Number(tax_amount)).toFixed(2);

    //   //           this.ticket_model[element.index + '_part_price'] = (document.getElementById('taxable_price_' + element.index) as HTMLInputElement).value;
    //   //           this.ticket_model[element.index + '_tax_amount'] = (document.getElementById('tax_' + element.index) as HTMLInputElement).value;
    //   //         });
    //   //       }

    //   //       else if (this.ticket_model['tax_type'] == 'income_price') {
    //   //         this.flight_price.forEach(element => {
    //   //           price = (document.getElementById('price_' + element.index) as HTMLInputElement).value;
    //   //           cost = (document.getElementById('cost_' + element.index) as HTMLInputElement).value;

    //   //           if (price != '' && cost != '') {
    //   //             profit = ((Number(price) - Number(cost)) * Number(element.count)).toFixed(2);
    //   //             tax_amount = (Number(profit) * (Number(tax['tax_perc']) / 100)).toFixed(2);
    //   //             total_price = (Number(price) * Number(element.count)).toFixed(2);
    //   //             (document.getElementById('tax_' + element.index) as HTMLInputElement).value = tax_amount;
    //   //             (document.getElementById('total_' + element.index) as HTMLInputElement).value = (Number(total_price) + Number(tax_amount)).toFixed(2);
    //   //           }

    //   //           this.ticket_model[element.index + '_tax_amount'] = (document.getElementById('tax_' + element.index) as HTMLInputElement).value;
    //   //         });
    //   //       }
    //   //     }
    //   //   });
    // }

    // else if (this.ticket_model['tax_type'] == 'no_tax' || (this.ticket_model['tax_type'] != 'no_tax' && this.ticket_model['tax_no'] == '')) {
    //   this.ticket_model['tax_no'] = '';
    //   let price;

    //   this.flight_price.forEach(element => {
    //     price = (document.getElementById('price_' + element.index) as HTMLInputElement).value;
    //     (document.getElementById('total_' + element.index) as HTMLInputElement).value = (Number(price) * Number(element.count)).toFixed(2);
    //     // (document.getElementById('taxable_price_' + row.index) as HTMLInputElement).value = '0';
    //     // (document.getElementById('tax_' + element.index) as HTMLInputElement).value = '0';
    //     this.ticket_model['adult_tax_amount'] = '0';
    //     this.ticket_model['child_tax_amount'] = '0';
    //     this.ticket_model['infant_tax_amount'] = '0';
    //     this.ticket_model['adult_part_price'] = '0';
    //     this.ticket_model['child_part_price'] = '0';
    //     this.ticket_model['infant_part_price'] = '0';

    //     this.ticket_model[element.index + '_price'] = (document.getElementById('price_' + element.index) as HTMLInputElement).value;
    //     this.ticket_model[element.index + '_cost'] = (document.getElementById('cost_' + element.index) as HTMLInputElement).value;
    //     this.ticket_model[element.index + '_count'] = element.count;
    //   });
    // }

    // this.ticket_model[row.index + '_price'] = (document.getElementById('price_' + row.index) as HTMLInputElement).value;
    // this.ticket_model[row.index + '_cost'] = (document.getElementById('cost_' + row.index) as HTMLInputElement).value;
    // this.ticket_model[row.index + '_count'] = row.count;
  }

  getBusPrice(field_id = null) {
    this.bus_model['bus_total'] = '0';
    this.bus_model['total_amount'] = '0';

    let total_seat = Number(this.bus_model['male_seat_count']) + Number(this.bus_model['female_seat_count']);
    let tax_amount = 0, taxable_price = 0, tax_perc = 0, totalToBeTaxed;
    
    if (this.bus_model['tax_type'] == 'no_tax') {
      this.bus_tax = {};
      this.bus_model['tax_no'] = '';
    }
    else if (this.bus_model['tax_no'] == '') 
      return;

    let calculateField = field_id == 'price_w_tax' ? 'PWT' : (field_id == 'seat_price'? 'P' : '');
    calculateField = field_id == 'taxable_with_tax' ? 'TWT' : (field_id == 'taxable_price'? 'TP': calculateField);
    let taxObj = this._calculatePriceTax(this.bus_tax['tax_perc'], this.bus_model['tax_type'], total_seat, this.bus_model['taxable_price'], this.bus_model['taxable_with_tax'], this.bus_model['seat_price'], this.bus_model['price_w_tax'], this.bus_model['seat_cost'], this.bus_model['discount'], calculateField);

    this.bus_model['tax'] = taxObj.taxAmount;
    this.bus_model['seat_price'] = taxObj.price;
    this.bus_model['price_w_tax'] = taxObj.priceWithTax;
    this.bus_model['taxable_price'] = taxObj.taxablePrice;
    this.bus_model['taxable_with_tax'] = taxObj.taxablePriceWithTax;
    this.bus_model['bus_total'] = (taxObj.price * Number(total_seat)).toFixed(2);
    this.bus_model['total_amount'] = ((Number(total_seat) * taxObj.priceWithTax) - Number(this.bus_model['discount'])).toFixed(2);

    return;  

    if (this.bus_model['tax_type'] != 'no_tax') {
     
      if (this.bus_model['tax_no'] != '') {

        if (field_id == 'male_seat_count' || field_id == 'female_seat_count') {

          this.bus_model['bus_total'] = (Number(this.bus_model['seat_price']) * total_seat).toFixed(2);
          this.bus_model['tax'] = (Number(this.bus_model['seat_tax_amount']) * total_seat).toFixed(2);
          this.bus_model['total_amount'] =  (Number(this.bus_model['price_w_tax']) * total_seat).toFixed(2);
        }
        else if ((field_id == null || field_id == 'price_w_tax' || field_id == 'seat_cost') && Number(this.bus_model['price_w_tax']) > 0) {

          if (this.bus_model['tax_type'] == 'all_price') {
            if (this.bus_tax['tax_perc'] != '0')
              this.bus_model['seat_price'] = (Number(this.bus_model['price_w_tax']) / (1 + (Number(this.bus_tax['tax_perc']) / 100))).toFixed(2);
            else
              this.bus_model['seat_price'] = (Number(this.bus_model['price_w_tax']) - Number(this.bus_tax['tax_amount'])).toFixed(2);
            
            tax_amount = Number(this.bus_model['price_w_tax']) - Number(this.bus_model['seat_price']);
          }
          else if (this.bus_model['tax_type'] == 'part_price') {
            this.bus_model['seat_price'] = (Number(this.bus_model['price_w_tax']) - Number(this.bus_model['taxable_with_tax']) + Number(this.bus_model['taxable_price'])).toFixed(2);
            tax_amount = Number(this.bus_model['taxable_with_tax']) - Number(this.bus_model['taxable_price']);
          }
          else if (this.bus_model['tax_type'] == 'income_price') {
            if (this.bus_tax['tax_perc'] != '0')
              taxable_price = (Number(this.bus_model['price_w_tax']) - Number(this.bus_model['seat_cost']))/ (1 + (Number(this.bus_tax['tax_perc']) / 100));
            else 
              taxable_price = Number(this.bus_model['price_w_tax']) - Number(this.bus_model['seat_cost']) - Number(this.bus_tax['tax_amount']);

            tax_amount = Number(this.bus_model['price_w_tax']) - (Number(this.bus_model['seat_cost']) + taxable_price);
            this.bus_model['seat_price'] = (Number(this.bus_model['price_w_tax']) - tax_amount).toFixed(2);
            this.bus_model['taxable_price'] = taxable_price.toFixed(2);
          } 

          this.bus_model['seat_tax_amount'] = tax_amount.toFixed(2);
          this.bus_model['bus_total'] = (Number(this.bus_model['seat_price']) * total_seat).toFixed(2);
          this.bus_model['tax'] = (tax_amount * total_seat).toFixed(2);
          this.bus_model['total_amount'] =  (Number(this.bus_model['price_w_tax']) * total_seat).toFixed(2);
        }
        else if ((field_id == null || field_id == 'seat_price') && Number(this.bus_model['seat_price']) > 0) {

          if (this.bus_model['tax_type'] == 'all_price') {
            if (this.bus_tax['tax_perc'] != '0')
              tax_amount = Number(this.bus_model['seat_price']) * (Number(this.bus_tax['tax_perc']) / 100);
            else
              tax_amount = Number(this.bus_tax['tax_amount']);
          }
          else if (this.bus_model['tax_type'] == 'part_price') 
            tax_amount = Number(this.bus_model['seat_tax_amount']);
          
          else if (this.bus_model['tax_type'] == 'income_price') {
            if (this.bus_tax['tax_perc'] != '0')
              tax_amount = (Number(this.bus_model['seat_price']) - Number(this.bus_model['seat_cost'])) * (Number(this.bus_tax['tax_perc']) / 100);
            else
              tax_amount = Number(this.bus_tax['tax_amount']);
          }

          this.bus_model['price_w_tax'] = (Number(this.bus_model['seat_price']) + tax_amount).toFixed(2);
          this.bus_model['bus_total'] = (Number(this.bus_model['seat_price']) * total_seat).toFixed(2);
          this.bus_model['tax'] = (tax_amount * total_seat).toFixed(2);
          this.bus_model['total_amount'] =  (Number(this.bus_model['price_w_tax']) * total_seat).toFixed(2);
        }
        else if ((field_id == null || field_id == 'taxable_with_tax') && Number(this.bus_model['taxable_with_tax']) > 0) {
          if (this.bus_tax['tax_perc'] != '0')
            taxable_price = Number(this.bus_model['taxable_with_tax']) / (1 + (Number(this.bus_tax['tax_perc']) / 100));
          else 
            taxable_price = Number(this.bus_model['taxable_with_tax']) - Number(this.bus_tax['tax_amount']);

          tax_amount = Number(this.bus_model['taxable_with_tax']) - taxable_price;
          
          this.bus_model['seat_tax_amount'] = tax_amount.toFixed(2);
          this.bus_model['tax'] = (tax_amount * total_seat).toFixed(2);
          this.bus_model['taxable_price'] = taxable_price.toFixed(2);

          if (Number(this.bus_model['price_w_tax']) > 0) 
            this.bus_model['seat_price'] = (Number(this.bus_model['price_w_tax']) - Number(this.bus_model['taxable_with_tax']) + Number(this.bus_model['taxable_price'])).toFixed(2);
          
          else if (Number(this.bus_model['seat_price']) > 0) 
            this.bus_model['price_w_tax'] = (Number(this.bus_model['seat_price']) + tax_amount).toFixed(2);
           
          this.bus_model['bus_total'] = (Number(this.bus_model['seat_price']) * total_seat).toFixed(2);
          this.bus_model['total_amount'] =  (Number(this.bus_model['price_w_tax']) * total_seat).toFixed(2);
        }
        else if ((field_id == null || field_id == 'taxable_price') && Number(this.bus_model['taxable_price']) > 0) {
          
          if (this.bus_tax['tax_perc'] != '0')
            tax_amount = Number(this.bus_model['taxable_price']) * (Number(this.bus_tax['tax_perc']) / 100);
          else 
            tax_amount = Number(this.bus_tax['tax_amount']);

          this.bus_model['taxable_with_tax'] = (Number(this.bus_model['taxable_price']) + tax_amount).toFixed(2);
          this.bus_model['seat_tax_amount'] = tax_amount.toFixed(2);
          this.bus_model['tax'] = (tax_amount * total_seat).toFixed(2);

          if (Number(this.bus_model['price_w_tax']) > 0) 
            this.bus_model['seat_price'] = (Number(this.bus_model['price_w_tax']) - Number(this.bus_model['taxable_with_tax']) + Number(this.bus_model['taxable_price'])).toFixed(2);
          
          else if (Number(this.bus_model['seat_price']) > 0) 
            this.bus_model['price_w_tax'] = (Number(this.bus_model['seat_price']) + tax_amount).toFixed(2);
           
          this.bus_model['bus_total'] = (Number(this.bus_model['seat_price']) * total_seat).toFixed(2);
          this.bus_model['total_amount'] =  (Number(this.bus_model['price_w_tax']) * total_seat).toFixed(2);
        }
        else {
          this.bus_model['seat_price'] = '0'; 
          this.bus_model['seat_tax_amount'] = '0';
          this.bus_model['tax'] = '0';
        }  
      }
    }
    else {
      this.bus_model['tax_no'] = '';
      this.bus_tax_detail = '';
      this.bus_tax = {};

      if (field_id == null || field_id == 'male_seat_count' || field_id == 'female_seat_count' || field_id == 'seat_price') {

        this.bus_model['bus_total'] = (Number(this.bus_model['seat_price']) * total_seat).toFixed(2);
        this.bus_model['total_amount'] =  (Number(this.bus_model['seat_price']) * total_seat).toFixed(2);
      }
      
      this.bus_model['taxable_price'] = '0';
      this.bus_model['price_w_tax'] = '0';
      this.bus_model['seat_tax_amount'] = '0';
      this.bus_model['tax'] = '0';
    }
  }

  getVisaPrice(field_id = null) {
    this.visa_model['visa_total'] = '0';
    this.visa_model['total_amount'] = '0';

    let visa_count = Number(this.visa_model['visa_count']);
    let tax_amount = 0, taxable_price = 0;

    if (this.add_visa_list.length == 0) 
      this.showVisaTax = (this.visa_model['tax_type'] != 'no_tax');
    else {
      let allNoTax = false;
      this.add_visa_list.forEach(element => {
        if (!allNoTax && element.tax_type != 'no_tax')
          allNoTax = false;
      });
      this.showVisaTax = !allNoTax;
    }

    if (this.visa_model['tax_type'] == 'no_tax') {
      this.visa_tax = {};
      this.visa_model['tax_no'] = '';
    }
    else if (this.visa_model['tax_no'] == '') 
      return;

    let calculateField = field_id == 'price_w_tax' ? 'PWT' : (field_id == 'visa_price'? 'P':'');
    calculateField = field_id == 'taxable_with_tax' ? 'TWT' : (field_id == 'taxable_price'? 'TP':calculateField);
    let taxObj = this._calculatePriceTax(this.visa_tax['tax_perc'], this.visa_model['tax_type'], visa_count, this.visa_model['taxable_price'], this.visa_model['taxable_with_tax'], this.visa_model['visa_price'], this.visa_model['price_w_tax'], this.visa_model['visa_cost'], this.visa_model['discount'], calculateField);
  
    this.visa_model['tax'] = taxObj.taxAmount;
    this.visa_model['visa_price'] = taxObj.price;
    this.visa_model['price_w_tax'] = taxObj.priceWithTax;
    this.visa_model['taxable_price'] = taxObj.taxablePrice;
    this.visa_model['taxable_with_tax'] = taxObj.taxablePriceWithTax;
    this.visa_model['visa_total'] = (taxObj.price * visa_count).toFixed(2);
    this.visa_model['total_amount'] = ((visa_count * taxObj.priceWithTax) - Number(this.visa_model['discount'])).toFixed(2);

    return;
    if (this.visa_model['tax_type'] != 'no_tax') {
     
      if (this.visa_model['tax_no'] != '') {

        if (field_id == 'visa_count') {

          this.visa_model['visa_total'] = (Number(this.visa_model['visa_price']) * visa_count).toFixed(2);
          this.visa_model['tax'] = (Number(this.visa_model['visa_tax_amount']) * visa_count).toFixed(2);
          this.visa_model['total_amount'] =  (Number(this.visa_model['price_w_tax']) * visa_count).toFixed(2);
        }
        else if ((field_id == null || field_id == 'price_w_tax' || field_id == 'visa_cost') && Number(this.visa_model['price_w_tax']) > 0) {

          if (this.visa_model['tax_type'] == 'all_price') {
            if (this.visa_tax['tax_perc'] != '0')
              this.visa_model['visa_price'] = (Number(this.visa_model['price_w_tax']) / (1 + (Number(this.visa_tax['tax_perc']) / 100))).toFixed(2);
            else
              this.visa_model['visa_price'] = (Number(this.visa_model['price_w_tax']) - Number(this.visa_tax['tax_amount'])).toFixed(2);
            
            tax_amount = Number(this.visa_model['price_w_tax']) - Number(this.visa_model['visa_price']);
          }
          else if (this.visa_model['tax_type'] == 'part_price') {
            this.visa_model['visa_price'] = (Number(this.visa_model['price_w_tax']) - Number(this.visa_model['taxable_with_tax']) + Number(this.visa_model['taxable_price'])).toFixed(2);
            tax_amount = Number(this.visa_model['taxable_with_tax']) - Number(this.visa_model['taxable_price']);
          }
          else if (this.visa_model['tax_type'] == 'income_price') {
            if (this.visa_tax['tax_perc'] != '0')
              taxable_price = (Number(this.visa_model['price_w_tax']) - Number(this.visa_model['visa_cost']))/ (1 + (Number(this.visa_tax['tax_perc']) / 100));
            else 
              taxable_price =Number(this.visa_model['price_w_tax']) - Number(this.visa_model['visa_cost']) - Number(this.visa_tax['tax_amount']);

            tax_amount = Number(this.visa_model['price_w_tax']) - (Number(this.visa_model['visa_cost']) + taxable_price);
            this.visa_model['visa_price'] = (Number(this.visa_model['price_w_tax']) - tax_amount).toFixed(2);
            this.visa_model['taxable_price'] = taxable_price.toFixed(2);
          } 

          this.visa_model['visa_tax_amount'] = tax_amount.toFixed(2);
          this.visa_model['visa_total'] = (Number(this.visa_model['visa_price']) * visa_count).toFixed(2);
          this.visa_model['tax'] = (tax_amount * visa_count).toFixed(2);
          this.visa_model['total_amount'] =  (Number(this.visa_model['price_w_tax']) * visa_count).toFixed(2);
        }
        else if ((field_id == null || field_id == 'visa_price') && Number(this.visa_model['visa_price']) > 0) {

          if (this.visa_model['tax_type'] == 'all_price') {
            if (this.visa_tax['tax_perc'] != '0')
              tax_amount = Number(this.visa_model['visa_price']) * (Number(this.visa_tax['tax_perc']) / 100);
            else
              tax_amount = Number(this.visa_tax['tax_amount']);
          }
          else if (this.visa_model['tax_type'] == 'part_price') 
            tax_amount = Number(this.visa_model['visa_tax_amount']);
          
          else if (this.visa_model['tax_type'] == 'income_price') {
            taxable_price = (Number(this.visa_model['visa_price']) - Number(this.visa_model['visa_cost']));

            if (this.visa_tax['tax_perc'] != '0')
              tax_amount = taxable_price * (Number(this.visa_tax['tax_perc']) / 100);
            else
              tax_amount = Number(this.visa_tax['tax_amount']);

            this.visa_model['taxable_price'] = taxable_price.toFixed(2);
          }

          this.visa_model['price_w_tax'] = (Number(this.visa_model['visa_price']) + tax_amount).toFixed(2);
          this.visa_model['visa_total'] = (Number(this.visa_model['visa_price']) * visa_count).toFixed(2);
          this.visa_model['tax'] = (tax_amount * visa_count).toFixed(2);
          this.visa_model['total_amount'] =  (Number(this.visa_model['price_w_tax']) * visa_count).toFixed(2);
        }
        else if ((field_id == null || field_id == 'taxable_with_tax') && Number(this.visa_model['taxable_with_tax']) > 0) {
          if (this.visa_tax['tax_perc'] != '0')
            taxable_price = Number(this.visa_model['taxable_with_tax']) / (1 + (Number(this.visa_tax['tax_perc']) / 100));
          else 
            taxable_price = Number(this.visa_model['taxable_with_tax']) - Number(this.visa_tax['tax_amount']);

          tax_amount = Number(this.visa_model['taxable_with_tax']) - taxable_price;
          
          this.visa_model['visa_tax_amount'] = tax_amount.toFixed(2);
          this.visa_model['tax'] = (tax_amount * visa_count).toFixed(2);
          this.visa_model['taxable_price'] = taxable_price.toFixed(2);

          if (Number(this.visa_model['price_w_tax']) > 0) 
            this.visa_model['visa_price'] = (Number(this.visa_model['price_w_tax']) - Number(this.visa_model['taxable_with_tax']) + Number(this.visa_model['taxable_price'])).toFixed(2);
          
          else if (Number(this.visa_model['visa_price']) > 0) 
            this.visa_model['price_w_tax'] = (Number(this.visa_model['visa_price']) + tax_amount).toFixed(2);
           
          this.visa_model['visa_total'] = (Number(this.visa_model['visa_price']) * visa_count).toFixed(2);
          this.visa_model['total_amount'] =  (Number(this.visa_model['price_w_tax']) * visa_count).toFixed(2);
        }
        else if ((field_id == null || field_id == 'taxable_price') && Number(this.visa_model['taxable_price']) > 0) {
          
          if (this.visa_tax['tax_perc'] != '0')
            tax_amount = Number(this.visa_model['taxable_price']) * (Number(this.visa_tax['tax_perc']) / 100);
          else 
            tax_amount = Number(this.visa_tax['tax_amount']);

          this.visa_model['taxable_with_tax'] = (Number(this.visa_model['taxable_price']) + tax_amount).toFixed(2);
          this.visa_model['visa_tax_amount'] = tax_amount.toFixed(2);
          this.visa_model['tax'] = (tax_amount * visa_count).toFixed(2);

          if (Number(this.visa_model['price_w_tax']) > 0) 
            this.visa_model['visa_price'] = (Number(this.visa_model['price_w_tax']) - Number(this.visa_model['taxable_with_tax']) + Number(this.visa_model['taxable_price'])).toFixed(2);
          
          else if (Number(this.visa_model['visa_price']) > 0) 
            this.visa_model['price_w_tax'] = (Number(this.visa_model['visa_price']) + tax_amount).toFixed(2);
           
          this.visa_model['visa_total'] = (Number(this.visa_model['visa_price']) * visa_count).toFixed(2);
          this.visa_model['total_amount'] =  (Number(this.visa_model['price_w_tax']) * visa_count).toFixed(2);
        }
        else {
          this.visa_model['visa_price'] = '0'; 
          this.visa_model['visa_tax_amount'] = '0';
        }  
      }
    }
    else {
      this.visa_model['tax_no'] = '';
      this.visa_tax_detail = '';
      this.visa_tax = {};

      if (field_id == null || field_id == 'visa_count' || field_id == 'visa_price') {

        this.visa_model['visa_total'] = (Number(this.visa_model['visa_price']) * visa_count).toFixed(2);
        this.visa_model['total_amount'] =  (Number(this.visa_model['visa_price']) * visa_count).toFixed(2);
      }

      this.visa_model['taxable_price'] = '0';
      this.visa_model['price_w_tax'] = '0';
      this.visa_model['visa_tax_amount'] = '0';
      this.visa_model['tax'] = '0';
    }
  }

  getHotelPrice(field_id = null) {
    this.hotel_model['hotel_total'] = '0';
    this.hotel_model['total_amount'] = '0';

    let room_count = Number(this.hotel_model['room_count']);
    let tax_amount = 0, taxable_price = 0;

    if (this.add_hotel_list.length == 0) 
      this.showRoomTax = (this.hotel_model['tax_type'] != 'no_tax');
    else {
      let allNoTax = true;
      this.add_hotel_list.forEach(element => {
        if (allNoTax && element.tax_type != 'no_tax')
          allNoTax = false;
      });
      this.showRoomTax = !allNoTax;
    }

    if (this.hotel_model['tax_type'] == 'no_tax') {
      this.hotel_tax = {};
      this.hotel_model['tax_no'] = '';
    }
    else if (this.hotel_model['tax_no'] == '') 
      return;
    
    let calculateField = field_id == 'price_w_tax' ? 'PWT' : (field_id == 'room_price'? 'P':'');
    calculateField = field_id == 'taxable_with_tax' ? 'TWT' : (field_id == 'taxable_price'? 'TP':calculateField);
    let taxObj = this._calculatePriceTax(this.hotel_tax['tax_perc'], this.hotel_model['tax_type'], room_count, this.hotel_model['taxable_price'], this.hotel_model['taxable_with_tax'], this.hotel_model['room_price'], this.hotel_model['price_w_tax'], this.hotel_model['room_cost'], this.hotel_model['discount'], calculateField);

    this.hotel_model['tax'] = taxObj.taxAmount;
    this.hotel_model['room_price'] = taxObj.price;
    this.hotel_model['price_w_tax'] = taxObj.priceWithTax;
    this.hotel_model['taxable_price'] = taxObj.taxablePrice;
    this.hotel_model['taxable_with_tax'] = taxObj.taxablePriceWithTax;
    this.hotel_model['hotel_total'] = (room_count * taxObj.price).toFixed(2);
    this.hotel_model['total_amount'] = ((room_count * taxObj.priceWithTax) - Number(this.hotel_model['discount'])).toFixed(2);

    return ;
    if (this.hotel_model['tax_type'] != 'no_tax') {
     
      if (this.hotel_model['tax_no'] != '') {

        if (field_id == 'room_count') {

          this.hotel_model['hotel_total'] = (Number(this.hotel_model['room_price']) * room_count).toFixed(2);
          this.hotel_model['tax'] = (Number(this.hotel_model['room_tax_amount']) * room_count).toFixed(2);
          this.hotel_model['total_amount'] =  (Number(this.hotel_model['price_w_tax']) * room_count).toFixed(2);
        }
        else if ((field_id == null || field_id == 'price_w_tax' || field_id == 'room_cost') && Number(this.hotel_model['price_w_tax']) > 0) {

          if (this.hotel_model['tax_type'] == 'all_price') {
            if (this.hotel_tax['tax_perc'] != '0')
              this.hotel_model['room_price'] = (Number(this.hotel_model['price_w_tax']) / (1 + (Number(this.hotel_tax['tax_perc']) / 100))).toFixed(2);
            else
              this.hotel_model['room_price'] = (Number(this.hotel_model['price_w_tax']) - Number(this.hotel_tax['tax_amount'])).toFixed(2);
            
            tax_amount = Number(this.hotel_model['price_w_tax']) - Number(this.hotel_model['room_price']);
          }
          else if (this.hotel_model['tax_type'] == 'part_price') {
            this.hotel_model['room_price'] = (Number(this.hotel_model['price_w_tax']) - Number(this.hotel_model['taxable_with_tax']) + Number(this.hotel_model['taxable_price'])).toFixed(2);
            tax_amount = Number(this.hotel_model['taxable_with_tax']) - Number(this.hotel_model['taxable_price']);
          }
          else if (this.hotel_model['tax_type'] == 'income_price') {
            if (this.hotel_tax['tax_perc'] != '0')
              taxable_price = (Number(this.hotel_model['price_w_tax']) - Number(this.hotel_model['room_cost']))/ (1 + (Number(this.hotel_tax['tax_perc']) / 100));
            else 
              taxable_price =Number(this.hotel_model['price_w_tax']) - Number(this.hotel_model['room_cost']) - Number(this.hotel_tax['tax_amount']);

            tax_amount = Number(this.hotel_model['price_w_tax']) - (Number(this.hotel_model['room_cost']) + taxable_price);
            this.hotel_model['room_price'] = (Number(this.hotel_model['price_w_tax']) - tax_amount).toFixed(2);
            this.hotel_model['taxable_price'] = taxable_price.toFixed(2);
          } 

          this.hotel_model['room_tax_amount'] = tax_amount.toFixed(2);
          this.hotel_model['hotel_total'] = (Number(this.hotel_model['room_price']) * room_count).toFixed(2);
          this.hotel_model['tax'] = (tax_amount * room_count).toFixed(2);
          this.hotel_model['total_amount'] =  (Number(this.hotel_model['price_w_tax']) * room_count).toFixed(2);
        }
        else if ((field_id == null || field_id == 'room_price') && Number(this.hotel_model['room_price']) > 0) {

          if (this.hotel_model['tax_type'] == 'all_price') {
            if (this.hotel_tax['tax_perc'] != '0')
              tax_amount = Number(this.hotel_model['room_price']) * (Number(this.hotel_tax['tax_perc']) / 100);
            else
              tax_amount = Number(this.hotel_tax['tax_amount']);
          }
          else if (this.hotel_model['tax_type'] == 'part_price') 
            tax_amount = Number(this.hotel_model['room_tax_amount']);
          
          else if (this.hotel_model['tax_type'] == 'income_price') {
            if (this.hotel_tax['tax_perc'] != '0')
              tax_amount = (Number(this.hotel_model['room_price']) - Number(this.hotel_model['room_cost'])) * (Number(this.hotel_tax['tax_perc']) / 100);
            else
              tax_amount = Number(this.hotel_tax['tax_amount']);
          }

          this.hotel_model['price_w_tax'] = (Number(this.hotel_model['room_price']) + tax_amount).toFixed(2);
          this.hotel_model['hotel_total'] = (Number(this.hotel_model['room_price']) * room_count).toFixed(2);
          this.hotel_model['tax'] = (tax_amount * room_count).toFixed(2);
          this.hotel_model['total_amount'] =  (Number(this.hotel_model['price_w_tax']) * room_count).toFixed(2);
        }
        else if ((field_id == null || field_id == 'taxable_with_tax') && Number(this.hotel_model['taxable_with_tax']) > 0) {
          if (this.hotel_tax['tax_perc'] != '0')
            taxable_price = Number(this.hotel_model['taxable_with_tax']) / (1 + (Number(this.hotel_tax['tax_perc']) / 100));
          else 
            taxable_price = Number(this.hotel_model['taxable_with_tax']) - Number(this.hotel_tax['tax_amount']);

          tax_amount = Number(this.hotel_model['taxable_with_tax']) - taxable_price;
          
          this.hotel_model['room_tax_amount'] = tax_amount.toFixed(2);
          this.hotel_model['tax'] = (tax_amount * room_count).toFixed(2);
          this.hotel_model['taxable_price'] = taxable_price.toFixed(2);

          if (Number(this.hotel_model['price_w_tax']) > 0) 
            this.hotel_model['room_price'] = (Number(this.hotel_model['price_w_tax']) - Number(this.hotel_model['taxable_with_tax']) + Number(this.hotel_model['taxable_price'])).toFixed(2);
          
          else if (Number(this.hotel_model['room_price']) > 0) 
            this.hotel_model['price_w_tax'] = (Number(this.hotel_model['room_price']) + tax_amount).toFixed(2);
           
          this.hotel_model['hotel_total'] = (Number(this.hotel_model['room_price']) * room_count).toFixed(2);
          this.hotel_model['total_amount'] =  (Number(this.hotel_model['price_w_tax']) * room_count).toFixed(2);
        }
        else if ((field_id == null || field_id == 'taxable_price') && Number(this.hotel_model['taxable_price']) > 0) {
          
          if (this.hotel_tax['tax_perc'] != '0')
            tax_amount = Number(this.hotel_model['taxable_price']) * (Number(this.hotel_tax['tax_perc']) / 100);
          else 
            tax_amount = Number(this.hotel_tax['tax_amount']);

          this.hotel_model['taxable_with_tax'] = (Number(this.hotel_model['taxable_price']) + tax_amount).toFixed(2);
          this.hotel_model['room_tax_amount'] = tax_amount.toFixed(2);
          this.hotel_model['tax'] = (tax_amount * room_count).toFixed(2);

          if (Number(this.hotel_model['price_w_tax']) > 0) 
            this.hotel_model['room_price'] = (Number(this.hotel_model['price_w_tax']) - Number(this.hotel_model['taxable_with_tax']) + Number(this.hotel_model['taxable_price'])).toFixed(2);
          
          else if (Number(this.hotel_model['room_price']) > 0) 
            this.hotel_model['price_w_tax'] = (Number(this.hotel_model['room_price']) + tax_amount).toFixed(2);
           
          this.hotel_model['hotel_total'] = (Number(this.hotel_model['room_price']) * room_count).toFixed(2);
          this.hotel_model['total_amount'] =  (Number(this.hotel_model['price_w_tax']) * room_count).toFixed(2);
        }
        else {
          this.hotel_model['room_price'] = '0'; 
          this.hotel_model['room_tax_amount'] = '0';
        }  
      }
    }
    else {
      this.hotel_model['tax_no'] = '';
      this.room_tax_detail = '';
      this.hotel_tax = {};

      if (field_id == null || field_id == 'room_count' || field_id == 'room_price') {

        this.hotel_model['hotel_total'] = (Number(this.hotel_model['room_price']) * room_count).toFixed(2);
        this.hotel_model['total_amount'] =  (Number(this.hotel_model['room_price']) * room_count).toFixed(2);
      }

      this.hotel_model['taxable_price'] = '0';
      this.hotel_model['price_w_tax'] = '0';
      this.hotel_model['room_tax_amount'] = '0';
      this.hotel_model['tax'] = '0';
    }
  }

  getExtPrice(field_id = null) {
    this.ext_model['tax_amount'] = '0';
    let discount = Number(this.ext_model['discount']);

    if (this.ext_model['tax_type'] == 'all_price') {
      if (this.ext_model['tax_no'] != '') {
        if ((field_id == null || field_id == 'ext_w_tax') && Number(this.ext_model['ext_w_tax']) > 0) {
          if (this.ext_tax['tax_perc'] > '0') 
            this.ext_model['ext_amount'] = (Number(this.ext_model['ext_w_tax']) / (1 + (Number(this.ext_tax['tax_perc']) / 100))).toFixed(2);
          else 
            this.ext_model['ext_amount'] = (Number(this.ext_model['ext_w_tax']) - Number(this.ext_tax['tax_amount'])).toFixed(2);

          this.ext_model['tax_amount'] = (Number(this.ext_model['ext_w_tax']) - Number(this.ext_model['ext_amount'])).toFixed(2);
        }
        else if ((field_id == null || field_id == 'ext_amount') && Number(this.ext_model['ext_amount']) > 0) {
          let tax_amount = 0;
          if (this.ext_tax['tax_perc'] > '0') 
            tax_amount = (Number(this.ext_model['ext_amount'])) * (Number(this.ext_tax['tax_perc']) / 100);
          else 
            tax_amount = Number(this.ext_tax['tax_amount']);

          this.ext_model['tax_amount'] = tax_amount.toFixed(2);
          this.ext_model['ext_w_tax'] = (Number(this.ext_model['ext_amount']) + tax_amount).toFixed(2);
        }
      }
    }
    else if (this.ext_model['tax_type'] == 'no_tax') {
      this.ext_model['tax_no'] = '';
      this.ext_tax_detail = '';
      this.ext_tax = {};

      this.ext_model['ext_w_tax'] = '0';
      // this.ext_model['ext_amount'] = '0';
    }
  }

  calculateVisaTotal() {
    let total_tax = 0, final_total = 0;
    let allNoTax = true;

    this.add_visa_list.forEach(element => {
      total_tax += Number(element.tax);
      final_total += Number(element.total_amount);

      if (allNoTax && element.tax_no != '') 
        allNoTax = false;
    });

    this.model['total_visa_tax'] = total_tax.toFixed(2);
    this.model['final_visa_total'] = final_total.toFixed(2);
    this.showVisaTax = !allNoTax;
  }

  calculateHotelTotal() {
    let total_tax = 0, final_total = 0;
    let allNoTax = true;

    this.add_hotel_list.forEach(element => {
      total_tax += Number(element.tax);
      final_total += Number(element.total_amount);

      if (allNoTax && element.tax_no != '') 
        allNoTax = false;
    });
    this.showRoomTax = !allNoTax;

    this.model['total_hotel_tax'] = total_tax.toFixed(2);
    this.model['final_hotel_total'] = final_total.toFixed(2);
  }

  // get_price(type) {
  //   // if (type == 'bus') {
      
  //   //   if (this.bus_model['tax_type'] != 'all_price')
      
  //   //   if (this.bus_model['tax_type'] == 'all_price' && this.bus_model['tax_no'] != '') {
  //   //     if (Number(this.bus_model['price_w_tax']) > 0) {
          
  //   //     }
    
  //   //     this.calculate_tax('bus');
  //   //   }
  //   // }


  //   if (type == 'visa') {
  //     this.visa_model['total_amount'] = '0';
  //     this.visa_model['tax'] = '0';

  //     if (this.visa_model['tax_type'] != 'no_tax' && this.visa_model['tax_no'] != '' && this.visa_model['tax_type'] == 'all_price') {
  //       if (this.visa_model['price_w_tax'] != '')
  //         this.visa_model['visa_price'] = (Number(this.visa_model['price_w_tax']) / (1 + (Number(this.visa_tax['tax_perc']) / 100))).toFixed(2);
  //       if (this.visa_model['visa_count'] != '')
  //         this.visa_model['visa_total'] = (Number(this.visa_model['visa_price']) * Number(this.visa_model['visa_count'])).toFixed(2);
  //       //this.calculate_visa_total();

  //     }
  //   }


  //   if (type == 'hotel') {
  //     this.hotel_model['total_amount'] = '0';
  //     this.hotel_model['tax'] = '0';

  //     if (this.hotel_model['tax_type'] != 'no_tax' && this.hotel_model['tax_no'] != '' && this.hotel_model['tax_type'] == 'all_price') {
  //       if (this.hotel_model['price_w_tax'] != '')
  //         this.hotel_model['room_price'] = (Number(this.hotel_model['price_w_tax']) / (1 + (Number(this.hotel_tax['tax_perc']) / 100))).toFixed(2);
  //       if (this.hotel_model['room_count'] != '')
  //         this.hotel_model['hotel_total'] = (Number(this.hotel_model['room_price']) * Number(this.hotel_model['room_count'])).toFixed(2);
  //       //this.calculate_room_total();
  //     }
  //   }
  // }

  // calculate_tax(type) {
  //   let total_tax, total_amount;

  //   if (type == 'bus') {
  //     if (this.bus_model['tax_type'] != 'no_tax' && this.bus_model['tax_no'] != '') {
  //       this.bus_model['total_amount'] = '0';
  //       this.bus_model['tax'] = '0';

  //       if (this.bus_model['tax_type'] == 'all_price') {
  //         // if (this.bus_model['price_w_tax'] != '') 
  //         //   this.bus_model['seat_price'] = (Number(this.bus_model['price_w_tax']) / (1 + (Number(this.bus_tax['tax_perc']) / 100))).toFixed(2);

  //         if (this.bus_model['bus_total'] != '') {
  //           this.bus_model['tax'] = (Number(this.bus_model['bus_total']) * (Number(this.bus_tax['tax_perc']) / 100)).toFixed(2);
  //           this.bus_model['total_amount'] = (Number(this.bus_model['bus_total']) + Number(this.bus_model['tax'])).toFixed(2);
  //           // this.bus_model['price_w_tax'] = (Number(this.bus_model['seat_price']) + Number(this.bus_model['seat_price']) * (Number(this.bus_tax['tax_perc']) / 100)).toFixed(2);
  //         }
  //       }

  //       else if (this.bus_model['tax_type'] == 'part_price') {
  //         if (this.bus_model['taxable_price'] != '') {
  //           if (Number(this.bus_model['taxable_price']) > Number(this.bus_model['bus_total']))
  //             this.bus_model['taxable_price'] = this.bus_model['bus_total'];
  //           this.bus_model['tax'] = (Number(this.bus_model['taxable_price']) * (Number(this.bus_tax['tax_perc']) / 100)).toFixed(2);
  //         }
  //         this.bus_model['total_amount'] = (Number(this.bus_model['bus_total']) + Number(this.bus_model['tax'])).toFixed(2);
  //       }

  //       else if (this.bus_model['tax_type'] == 'income_price') {
  //         if (this.bus_model['seat_price'] != '' && this.bus_model['seat_cost'] != '') {
  //           let profit = ((Number(this.bus_model['seat_price']) - Number(this.bus_model['seat_cost'])) * (Number(this.bus_model['male_seat_count'] + Number(this.bus_model['female_seat_count'])))).toFixed(2);
  //           // this.bus_model['taxable_price'] = Number(this.bus_model['taxable_price'] + Number(profit)).toFixed(2);
  //           this.bus_model['tax'] = (Number(profit) * (Number(this.bus_tax['tax_perc']) / 100)).toFixed(2);
  //           this.bus_model['total_amount'] = (Number(this.bus_model['bus_total']) + Number(this.bus_model['tax'])).toFixed(2);
  //         }
  //       }
  //     }
  //     else if (this.bus_model['tax_type'] == 'no_tax') {
  //       this.bus_model['tax'] = '';
  //       this.bus_model['tax_no'] = '';
  //       this.bus_model['taxable_price'] = '';
  //       this.bus_model['total_amount'] = '';
  //       this.bus_model['price_w_tax'] = '0';

  //     }
  //   }

  //   else if (type == 'visa') {
  //     if (this.visa_model['tax_type'] != 'no_tax' && this.visa_model['tax_no'] != '') {
  //       total_tax = 0, total_amount = 0;

  //       this.add_visa_list.forEach(element => {
  //         if (this.visa_model['tax_type'] == 'all_price') {
  //           if (element.visa_total != '') {
  //             element.visa_tax = (Number(element.visa_total) * (Number(this.visa_tax['tax_perc']) / 100)).toFixed(2);
  //             element.final_total = (Number(element.visa_total) + Number(element.visa_tax)).toFixed(2);

  //             total_tax += (Number(element.visa_total) * (Number(this.visa_tax['tax_perc']) / 100));
  //             total_amount += ((Number(element.visa_total) * (Number(this.visa_tax['tax_perc']) / 100)) + Number(element.visa_total));
  //             // this.visa_model['total_amount'] = (Number(this.visa_model['total_amount']) + Number(element.final_total)).toFixed(2);
  //             // this.visa_model['tax'] = (Number(this.visa_model['tax']) + Number(element.visa_tax)).toFixed(2);
  //           }
  //         }

  //         else if (this.visa_model['tax_type'] == 'part_price') {
  //           if (this.visa_model['taxable_price'] != '') {
  //             if (Number(this.visa_model['taxable_price']) > Number(element.visa_total))
  //               this.visa_model['taxable_price'] = element.visa_total;
  //             element.visa_tax = (Number(this.visa_model['taxable_price']) * Number(element.visa_count) * (Number(this.visa_tax['tax_perc']) / 100)).toFixed(2);
  //             element.final_total = (Number(element.visa_total) + Number(element.visa_tax)).toFixed(2);
  //           }

  //           total_tax += (Number(this.visa_model['taxable_price']) * Number(element.visa_count) * (Number(this.visa_tax['tax_perc']) / 100));
  //           total_amount += ((Number(this.visa_model['taxable_price']) * Number(element.visa_count) * (Number(this.visa_tax['tax_perc']) / 100)) + Number(element.visa_total));
  //           // this.visa_model['total_amount'] = (Number(this.visa_model['total_amount']) + Number(element.final_total)).toFixed(2);
  //           // this.visa_model['tax'] = (Number(this.visa_model['tax']) + Number(element.visa_tax)).toFixed(2);
  //         }

  //         else if (this.visa_model['tax_type'] == 'income_price') {
  //           if (element.visa_price != '' && element.visa_cost != '') {
  //             let profit = ((Number(element.visa_price) - Number(element.visa_cost)) * Number(element.visa_count)).toFixed(2);
  //             element.visa_tax = (Number(profit) * (Number(this.visa_tax['tax_perc']) / 100)).toFixed(2);
  //             element.final_total = (Number(element.visa_total) + Number(element.visa_tax)).toFixed(2);

  //             total_tax += (Number(profit) * (Number(this.visa_tax['tax_perc']) / 100));
  //             total_amount += ((Number(profit) * (Number(this.visa_tax['tax_perc']) / 100)) + Number(element.visa_total));
  //             // this.visa_model['total_amount'] = (Number(this.visa_model['total_amount']) + Number(element.final_total)).toFixed(2);
  //             // this.visa_model['tax'] = (Number(this.visa_model['tax']) + Number(element.visa_tax)).toFixed(2);
  //           }
  //         }
  //       });
  //       this.visa_model['total_amount'] = total_amount.toFixed(2);
  //       this.visa_model['tax'] = total_tax.toFixed(2);
  //     }
  //     else if (this.visa_model['tax_type'] == 'no_tax') {
  //       this.visa_model['tax'] = '';
  //       this.visa_model['tax_no'] = '';
  //       this.visa_model['taxable_price'] = '';
  //       this.visa_model['total_amount'] = '';
  //       this.add_visa_list.forEach(element => {
  //         element.visa_tax = '';
  //         element.final_total = element.visa_total;
  //         element.price_w_tax = '';
  //       });
  //     }
  //   }

  //   else if (type == 'hotel') {
  //     total_tax = 0, total_amount = 0;

  //     if (this.hotel_model['tax_type'] != 'no_tax' && this.hotel_model['tax_no'] != '') {

  //       this.add_hotel_list.forEach(element => {

  //         if (this.hotel_model['tax_type'] == 'all_price') {
  //           if (element.hotel_total != '') {
  //             console.log(element.hotel_total);
  //             console.log(this.hotel_tax['tax_perc']);

  //             element.room_tax = (Number(element.hotel_total) * (Number(this.hotel_tax['tax_perc']) / 100)).toFixed(2);
  //             element.final_total = (Number(element.hotel_total) + Number(element.room_tax)).toFixed(2);
  //             console.log(element.room_tax);
  //             console.log(element.final_total);
  //             total_tax += (Number(element.hotel_total) * (Number(this.hotel_tax['tax_perc']) / 100));
  //             total_amount += ((Number(element.hotel_total) * (Number(this.hotel_tax['tax_perc']) / 100)) + Number(element.hotel_total));

  //             // this.hotel_model['total_amount'] = (Number(this.hotel_model['total_amount']) + Number(element.final_total)).toFixed(2);
  //             // this.hotel_model['tax'] = (Number(this.hotel_model['tax']) + Number(element.room_tax)).toFixed(2);
  //           }
  //         }

  //         else if (this.hotel_model['tax_type'] == 'part_price') {
  //           if (this.hotel_model['taxable_price'] != '') {
  //             if (Number(this.hotel_model['taxable_price']) > Number(element.hotel_total))
  //               this.hotel_model['taxable_price'] = element.hotel_total;
  //             element.room_tax = (Number(this.hotel_model['taxable_price']) * Number(element.room_count) * (Number(this.hotel_tax['tax_perc']) / 100)).toFixed(2);
  //             element.final_total = (Number(element.hotel_total) + Number(element.room_tax)).toFixed(2);
  //           }

  //           total_tax += (Number(this.hotel_model['taxable_price']) * Number(element.room_count) * (Number(this.hotel_tax['tax_perc']) / 100));
  //           total_amount += ((Number(this.hotel_model['taxable_price']) * Number(element.room_count) * (Number(this.hotel_tax['tax_perc']) / 100)) + Number(element.hotel_total));

  //           // this.hotel_model['total_amount'] = (Number(this.hotel_model['total_amount']) + Number(element.final_total)).toFixed(2);
  //           // this.hotel_model['tax'] = (Number(this.hotel_model['tax']) + Number(element.room_tax)).toFixed(2);
  //         }

  //         else if (this.hotel_model['tax_type'] == 'income_price') {
  //           if (element.room_price != '' && element.room_cost != '') {
  //             let profit = ((Number(element.room_price) - Number(element.room_cost)) * Number(element.room_count)).toFixed(2);
  //             element.room_tax = (Number(profit) * (Number(this.hotel_tax['tax_perc']) / 100)).toFixed(2);
  //             element.final_total = (Number(element.hotel_total) + Number(element.room_tax)).toFixed(2);

  //             total_tax += (Number(profit) * (Number(this.hotel_tax['tax_perc']) / 100));
  //             total_amount += ((Number(profit) * (Number(this.hotel_tax['tax_perc']) / 100)) + Number(element.hotel_total));

  //             // this.hotel_model['total_amount'] = (Number(this.hotel_model['total_amount']) + Number(element.final_total)).toFixed(2);
  //             // this.hotel_model['tax'] = (Number(this.hotel_model['tax']) + Number(element.room_tax)).toFixed(2);
  //           }
  //         }

  //       });

  //       this.hotel_model['total_amount'] = total_amount.toFixed(2);
  //       this.hotel_model['tax'] = total_tax.toFixed(2);
  //       console.log(this.hotel_model['total_amount']);
  //       console.log(this.hotel_model['tax']);
  //     }
  //     else if (this.hotel_model['tax_type'] == 'no_tax') {
  //       this.hotel_model['tax'] = '0';
  //       this.hotel_model['tax_no'] = '0';
  //       this.hotel_model['taxable_price'] = '0';
  //       this.hotel_model['total_amount'] = '0';
  //       this.add_hotel_list.forEach(element => {
  //         element.room_tax = '0';
  //         element.final_total = element.hotel_total;
  //         element.price_w_tax = '0';
  //       });
  //     }
  //   }

  //   else if (type == 'ext') {

  //     if (this.ext_model['tax_type'] == 'all_price') {
  //       if (this.ext_model['ext_amount'] != '' && this.ext_model['tax_no'] != '') {
  //         if (this.ext_tax['tax_perc'] != '0')
  //           this.ext_model['ext_amount_no_tax'] = (Number(this.ext_model['ext_amount']) / (1 + (Number(this.ext_tax['tax_perc']) / 100))).toFixed(2);
  //         else
  //           this.ext_model['ext_amount_no_tax'] = (Number(this.ext_model['ext_amount']) - Number(this.ext_tax['tax_amount'])).toFixed(2); 

  //         this.ext_model['tax'] = ((Number(this.ext_model['ext_amount']) - (Number(this.ext_model['ext_amount_no_tax'])))).toFixed(2);
  //       }
  //     }
  //     else if (this.ext_model['tax_type'] == 'no_tax') {
  //       this.ext_model['tax'] = '';
  //       this.ext_model['tax_no'] = '';
  //       this.ext_model['total_amount'] = '';
  //     }

  //   }
  // }

  //-------********************** SVAE **********************-------//

  add() {
    this.saveClicked = true;

    if (this.invoice_model['customer_no'] == '' || this.invoice_model['customer_no'] == '0') {
      alert(this.Main_Traveler_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.model['chx_addDepend'] == '1' && Number(this.model['depend_count']) != this.add_depend_list.length) {
      alert(this.Depend_Num_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.model['trans_type'] == 'flight' && this.ticket_model['from_airport'] == '0') {
      alert(this.From_Airport_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.model['trans_type'] == 'flight' && this.ticket_model['to_airport'] == '0') {
      alert(this.To_Airport_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.model['trans_type'] == 'flight' && this.model['departure_date'] == undefined) {
      alert(this.Dep_Date_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.model['trans_type'] == 'flight' && this.ticket_model['ticket_type'] == 'return' && this.model['arrival_date'] == undefined) {
      alert(this.Ret_Date_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.model['trans_type'] == 'bus' && this.bus_model['bus_id'] == '0') {
      alert(this.Bus_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.model['trans_type'] == 'bus' && this.bus_model['from_city'] == '0') {
      alert(this.From_City_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.model['trans_type'] == 'bus' && this.bus_model['to_city'] == '0') {
      alert(this.To_City_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.model['trans_type'] == 'bus' && this.bus_model['to_city'] == '0') {
      alert(this.To_City_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.model['trans_type'] == 'bus' && this.model['bus_dep_date'] == undefined) {
      alert(this.Dep_Date_Msg);
      this.saveClicked = false;
      return;
    }

    // if (this.model['trans_type'] == 'bus' && this.model['bus_return_date'] == undefined) {
    //   alert(this.Ret_Date_Msg);
    //   return;
    // }

    if (this.model['trans_type'] == 'bus' && (Number(this.bus_model['male_seat_count']) + Number(this.bus_model['female_seat_count'])) <= 0) {
      alert(this.Seat_Count_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.model['trans_type'] == 'flight' && this.ticket_model['tax_no'] == '' && this.ticket_model['tax_type'] != 'no_tax') {
      alert(this.Tax_Msg + ' (' + this.Transportation + ')');
      this.saveClicked = false;
      return;
    }

    if (this.model['trans_type'] == 'bus' && this.bus_model['tax_no'] == '' && this.bus_model['tax_type'] != 'no_tax' && this.bus_model['bus_id'] != '0') {
      alert(this.Tax_Msg + ' (' + this.Transportation + ')');
      this.saveClicked = false;
      return;
    }

    if (this.visa_model['tax_no'] == '' && this.visa_model['tax_type'] != 'no_tax' && this.add_visa_list.length > 0) {
      alert(this.Tax_Msg + ' (' + this.Visas + ')');
      this.saveClicked = false;
      return;
    }

    if (this.hotel_model['tax_no'] == '' && this.hotel_model['tax_type'] != 'no_tax' && this.add_hotel_list.length > 0) {
      alert(this.Tax_Msg + ' (' + this.Residence + ')');
      this.saveClicked = false;
      return;
    }

    if (this.ext_model['tax_no'] == '' && this.ext_model['tax_type'] != 'no_tax' && this.ext_model['ext_amount'] != '') {
      alert(this.Tax_Msg + ' (' + this.Ext_Amount + ')');
      this.saveClicked = false;
      return;
    }


    let values = [];
    let obj;

    //------------------------ Invoice ------------------------//
    let invoice_date = this.model['invoice_date'].getFullYear() + "-" + (this.model['invoice_date'].getMonth() + 1) + "-" +
      this.model['invoice_date'].getDate() + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' +
      new Date().getSeconds();

    this.invoice_model['invoice_date'] = invoice_date;

    if (this.invoice_model['invoice_id'] == '0') {
      let invoice_uuid = uuidv4();
      this.invoice_model['invoice_uuid'] = invoice_uuid;

      this.invoice_model['deliver_date'] = this.invoice_model['invoice_date'];
      this.invoice_model['payment_date'] = this.invoice_model['invoice_date'];
    }

    this.invoice_model['payment_method'] = 'credit';
    this.invoice_model['sales_acct'] = this.revenue_acct_no;
    this.invoice_model['total'] = this.model['total_amount'];
    this.invoice_model['discount'] = this.model['total_discount'];
    this.invoice_model['tax'] = this.model['total_tax'];
    this.invoice_model['total_no_tax'] = this.model['no_tax_total'];

    // let all_taxable = true;
    // this.detail.forEach(element => {
    //   if (element.tax_no == '0')
    //     all_taxable = false;
    // });
    // if (all_taxable)
    //   this.invoice_model['tax_acct'] = this.detail['0']['tax_no'];

    if (Number(this.invoice_model['tax']) > 0) {
      this.invoice_model['calc_tax'] = '1';

      let first_tax_acct = this.detail[0]['tax_no'];
      let is_equal_tax = true;
      this.detail.forEach(element => {
        if (element.tax_no != first_tax_acct)
          is_equal_tax = false;
      });

      if (is_equal_tax)
        this.invoice_model['tax_acct'] = first_tax_acct;
    }
    values.push(this.invoice_model);

    //------------------------ Invoice Item ------------------------//

    let non_taxable_price;

    this.detail.forEach(element => {
      if (element.tax_type == 'all_price' || element.tax_type == 'no_tax') {
        values.push({
          'table_name': 'invoice_item', 'invoice_no': this.invoice_model['invoice_no'],
          'invoice_date': this.invoice_model['invoice_date'], 'sub_item_number': '0', 'sub_item_name': element.type,
          'price': element.price, 'unit_id': '0', 'count': element.count,
          'total_price': (Number(element.count) * Number(element.price)).toFixed(2),
          'tax_no': element.tax_no, 'invoice_item_id': '0', 'tax_amount': Number(element.tax),
          'type': element.item_type, 'flag': 'new', 'key': 'invoice_item_id',
          'discount': element.discount, 'stock_no': '0', 'store_id': this.invoice_model['store_id'],
          'primary_sub_item_number': '', 'primary_quantity': '0', 'comment': '',
          'revenue_acct_no': this.revenue_acct_no, 'cost': element.cost
        });
      }
      else {
        // add taxable price
        if (Number(element.taxable_price) > 0) {
          values.push({
            'table_name': 'invoice_item', 'invoice_no': this.invoice_model['invoice_no'],
            'invoice_date': this.invoice_model['invoice_date'], 'sub_item_number': '0', 
            'sub_item_name': 'رسوم ' + element.type,
            'price': element.taxable_price, 'unit_id': '0', 'count': element.count,
            'total_price': (Number(element.count) * Number(element.taxable_price)).toFixed(2),
            'tax_no': element.tax_no, 'invoice_item_id': '0', 'tax_amount': Number(element.tax),
            'type': element.item_type, 'flag': 'new', 'key': 'invoice_item_id',
            'discount': '0', 'stock_no': '0', 'store_id': this.invoice_model['store_id'],
            'primary_sub_item_number': '', 'primary_quantity': '0', 'comment': '',
            'revenue_acct_no': this.revenue_acct_no, 'cost': element.cost
          });
        }

        // add non taxable price
        non_taxable_price = Number(element.price) - Number(element.taxable_price);

        values.push({
          'table_name': 'invoice_item', 'invoice_no': this.invoice_model['invoice_no'],
          'invoice_date': this.invoice_model['invoice_date'], 'sub_item_number': '0', 
          'sub_item_name': element.type, 'price': non_taxable_price.toFixed(2), 'unit_id': '0', 
          'count': element.count, 'total_price': (Number(element.count) * non_taxable_price).toFixed(2),
          'tax_no': '', 'invoice_item_id': '0', 'tax_amount': '0', 'flag': 'new', 'key': 'invoice_item_id',
          'type': element.item_type, 'discount': element.discount, 'stock_no': '0', 
          'store_id': this.invoice_model['store_id'], 'primary_sub_item_number': '', 
          'primary_quantity': '0', 'comment': '', 'revenue_acct_no': this.revenue_acct_no, 
          'cost': element.cost
        });
      }
      
    });

    //------------------------ Payment Method ------------------------//

    values.push({
      'table_name': 'inv_payment_method', 'invoice_no': this.invoice_model['invoice_no'],
      'inv_payment_method_id': this.inv_payment_model['inv_payment_method_id'], 'flag': this.inv_payment_model['flag'],
      'key': 'inv_payment_method_id', 'payment_type_id': '2', 'acct_number': this.invoice_model['customer_no'],
      'amount': this.model['total_w_tax']
    });


    //------------------------ Ticket ------------------------//

    let departure_date = '';
    let arrival_date = '';

    if (this.model['trans_type'] == 'flight') {

      departure_date = (this.model['departure_date'].getFullYear() + '-' +
        (this.model['departure_date'].getMonth() + 1) + '-' + this.model['departure_date'].getDate());


      if (this.ticket_model['ticket_type'] == 'return')
        arrival_date = (this.model['arrival_date'].getFullYear() + '-' +
          (this.model['arrival_date'].getMonth() + 1) + '-' + this.model['arrival_date'].getDate());
      else 
        arrival_date = departure_date;

      values.push({
        'table_name': 'reg_on_ticket', 'reg_ticket_id': this.ticket_model['reg_ticket_id'], 'ticket_type': this.ticket_model['ticket_type'],
        'invoice_no': this.invoice_model['invoice_no'], 'depart_date': departure_date, 'return_date': arrival_date,
        'flag': this.ticket_model['flag'], 'key': 'reg_ticket_id', 'from_airport': this.ticket_model['from_airport'],
        'to_airport': this.ticket_model['to_airport'], 'airline_id': this.ticket_model['airline_id'], 'comment': this.ticket_model['comment'],
        'adult_count': this.adult_count, 'child_count': this.child_count, 'infant_count': this.infant_count,
        'adult_price': this.ticket_model['adult_price'], 'child_price': this.ticket_model['child_price'],
        'infant_price': this.ticket_model['infant_price'], 'adult_cost': this.ticket_model['adult_cost'],
        'child_cost': this.ticket_model['child_cost'], 'infant_cost': this.ticket_model['infant_cost'],
        'adult_discount': this.ticket_model['adult_discount'],
        'child_discount': this.ticket_model['child_discount'], 'infant_discount': this.ticket_model['infant_discount'],
        'tax_type': this.ticket_model['tax_type'], 'tax_no': this.ticket_model['tax_no'],
        'adult_tax_amount': this.ticket_model['adult_tax_amount'], 'child_tax_amount': this.ticket_model['child_tax_amount'],
        'infant_tax_amount': this.ticket_model['infant_tax_amount'], 'adult_part_price': this.ticket_model['adult_part_price'],
        'child_part_price': this.ticket_model['child_part_price'], 'infant_part_price': this.ticket_model['infant_part_price'],
        'adult_comment': this.ticket_model['adult_comment'], 'child_comment': this.ticket_model['child_comment'],
        'infant_comment': this.ticket_model['infant_comment']
      });
    }

    //------------------------ Bus ------------------------//

    else if (this.model['trans_type'] == 'bus') {

      departure_date = (this.model['bus_dep_date'].getFullYear() + '-' +
        (this.model['bus_dep_date'].getMonth() + 1) + '-' + this.model['bus_dep_date'].getDate());

      arrival_date = (this.model['bus_return_date'].getFullYear() + '-' +
        (this.model['bus_return_date'].getMonth() + 1) + '-' + this.model['bus_return_date'].getDate());

      values.push({
        'table_name': 'reg_on_bus', 'reg_bus_id': this.bus_model['reg_bus_id'], 'trip_bus_id': '0',
        'bus_id': this.bus_model['bus_id'], 'depart_date': departure_date, 'return_date': arrival_date,
        'flag': this.bus_model['flag'], 'key': 'reg_bus_id', 'from_city': this.bus_model['from_city'],
        'to_city': this.bus_model['to_city'], 'invoice_no': this.invoice_model['invoice_no'],
        'comment': this.bus_model['comment'], 'male_seat_count': this.bus_model['male_seat_count'],
        'female_seat_count': this.bus_model['female_seat_count'], 'addition_count': '0',
        'seat_price': this.bus_model['seat_price'], 'seat_cost': this.bus_model['seat_cost'], 
        'discount': this.bus_model['discount'], 'tax_type': this.bus_model['tax_type'], 
        'tax_no': this.bus_model['tax_no'], 'seat_tax_amount': this.bus_model['tax'], 
        'seat_part_price': this.bus_model['taxable_price']
      });
    }

    //------------------------ Trip Group ------------------------//

    this.traveler_list.forEach(element => {
      if (departure_date != '' && arrival_date != '') {
        values.push({
          'table_name': 'trip_group', 'group_id': element.group_id, 'invoice_no': this.invoice_model['invoice_no'],
          'head_id': this.main_trav_info['acct_number'], 'member_id': element.acct_number,
          'member_head_relation': element.relative_relation, 'is_active': '1', 'group_type': '',
          'trip_arrival_date': arrival_date, 'trip_depart_date': departure_date, 'member_age': element.age, 
          'eticket': '', 'ticket_status': '0', 'ticket_count': element.ticket_count, 'bed_count': '0',
          'price': Number(element.price), 'flag': element.flag, 'key': 'group_id', 
          'room_type_id': element.room_type_id, 'comment': element.comment
        });
      }
      else {
        values.push({
          'table_name': 'trip_group', 'group_id': element.group_id, 'invoice_no': this.invoice_model['invoice_no'],
          'head_id': this.main_trav_info['acct_number'], 'member_id': element.acct_number,
          'member_head_relation': element.relative_relation, 'is_active': '1', 'group_type': '',
          'member_age': element.age, 'eticket': '', 'ticket_status': '0', 'ticket_count': element.ticket_count, 
          'bed_count': '0', 'price': Number(element.price), 'flag': element.flag, 'key': 'group_id', 
          'room_type_id': element.room_type_id, 'comment': element.comment
        });
      }
    });

    //------------------------ Visa ------------------------//

    this.add_visa_list.forEach(element => {
      values.push({
        'table_name': 'reg_on_visa', 'reg_visa_id': element.reg_visa_id, 'invoice_no': this.invoice_model['invoice_no'],
        'visa_tax_amount': element.tax, 'country_id': element.country_id, 
        'visa_count': element.visa_count, 'visa_price': element.visa_price, 'visa_cost': element.visa_cost, 
        'discount': element.discount, 'tax_no': element.tax_no, 'tax_type': element.tax_type, 
        'flag': element.flag, 'key': 'reg_visa_id', 'comment': element.comment,
        'visa_part_price': element.taxable_price
      });
    });

    //------------------------ Hotel ------------------------//

    this.add_hotel_list.forEach(element => {
      values.push({
        'table_name': 'reg_on_hotel', 'reg_id': element.reg_id, 'invoice_no': this.invoice_model['invoice_no'],
        'city_id': element.city_id, 'hotel_id': element.hotel_id, 'checkin_date': element.checkin_date,
        'checkout_date': element.checkout_date, 'room_type_id': element.room_type_id,
        'count': element.room_count, 'flag': element.flag, 'key': 'reg_id', 'room_price': element.room_price,
        'room_cost': element.room_cost, 'discount': element.discount, 'tax_no': element.tax_no,
        'tax_type': element.tax_type, 'room_part_price': element.taxable_price,
        'room_tax_amount': element.tax, 'package': element.package, 
        'comment': element.comment
      });
    });

    //------------------------ Delete ------------------------//

    if (this.invoice_model['invoice_id'] != '0') {
      console.log(this.toDelete);
      this.toDelete.forEach(delElem => {
        if (delElem['table_name'] == 'invoice_item') {
          values.push({
            'table_name': delElem['table_name'], 'invoice_item_id': delElem.invoice_item_id,
            'key': 'invoice_item_id', 'flag': 'delete', 'invoice_no': this.invoice_model['invoice_no']
          });
        }
        else if (delElem['table_name'] == 'trip_group') {
          values.push({
            'table_name': delElem['table_name'], 'group_id': delElem.group_id,
            'key': 'group_id', 'flag': 'delete', 'invoice_no': this.invoice_model['invoice_no']
          });
        }
        else if (delElem['table_name'] == 'reg_on_hotel') {
          values.push({
            'table_name': delElem['table_name'], 'reg_id': delElem.reg_id,
            'key': 'reg_id', 'flag': 'delete', 'invoice_no': this.invoice_model['invoice_no']
          });
        }

        else if (delElem['table_name'] == 'reg_on_visa') {
          values.push({
            'table_name': delElem['table_name'], 'reg_visa_id': delElem.reg_visa_id,
            'key': 'reg_visa_id', 'flag': 'delete', 'invoice_no': this.invoice_model['invoice_no']
          });
        }

        else if (delElem['table_name'] == 'reg_on_ticket') {
          values.push({
            'table_name': delElem['table_name'], 'reg_ticket_id': delElem.reg_ticket_id,
            'key': 'reg_ticket_id', 'flag': 'delete', 'invoice_no': this.invoice_model['invoice_no']
          });
        }

        else if (delElem['table_name'] == 'reg_on_bus') {
          values.push({
            'table_name': delElem['table_name'], 'reg_bus_id': delElem.reg_bus_id,
            'key': 'reg_bus_id', 'flag': 'delete', 'invoice_no': this.invoice_model['invoice_no']
          });
        }

      });
    }


    //------------------------ Save ------------------------//

    console.log(values);

    if (this.invoice_model['invoice_id'] == '0') {
      let year = this.model['invoice_date'].getFullYear();
      this.invoice_model['year'] = String(year);

      let idWhere = " WHERE `year` = '" + year + "' AND `branch_id` = '" + 
        this.applicationConstants.user_branch_info.user_branch_id + "'";
      let prefix = this.applicationConstants.user_branch_info.user_branch_id + '-' + year + '-';

      obj = {
        cmd: 'add', values: values, pk: 'invoice_no', id: 'no', main_table: 'invoice',
        prefix: prefix, idWhere: idWhere
      };
    }
    else
      obj = { cmd: 'updateAdv', values: values };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        if (data.status['type'] == 'success') {

          if (this.invoice_model['invoice_id'] == '0') 
            this.invoice_model['invoice_no'] = data.status['msg'][0]['number'];

          // check if it is new invoice OR updated one and has no cash receipt OR 
          // updated one and has cash receipt and the invoice total has changed and 
          // there is cash receipt for this invoice, then link or fix the cash receipt
          if (this.model['has_cash_receipt'] == 0 || 
            (this.model['has_cash_receipt'] == 1 && this.model['old_total_amount'] != Number(this.model['total_w_tax']))) {

            obj = {
              cmd: 'updateCashReceipt', invoice_no: this.invoice_model['invoice_no'],
              user_name: this.applicationConstants.user_info['user_name']
            };

            this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();

                if (data.status['type'] == 'error')
                  alert(this.applicationConstants.user_lang == 'ar' ? data.status['msg'][0]['msg_ar'] : data.status['msg'][0]['msg_en']);
                
                alert(this.Success_Msg + this.Inv_No_Msg + this.invoice_model['invoice_no']);
                window.open(this.applicationConstants.contractPrint + "?invoice_no=" + this.invoice_model['invoice_no'] + 
                  "&lang=" + this.applicationConstants.user_lang, "_blank");
                this.router.navigate(['sub_menu/13/tour_invoice_list']);
                
              });
          }
          else {
            alert(this.Success_Msg + this.Inv_No_Msg + this.invoice_model['invoice_no']);
            window.open(this.applicationConstants.contractPrint + "?invoice_no=" + this.invoice_model['invoice_no'] + 
              "&lang=" + this.applicationConstants.user_lang, "_blank");
            this.router.navigate(['sub_menu/13/tour_invoice_list']);
          }
        }
        else {
          alert(this.Error_Msg);
          this.saveClicked = false;
        }
      });

  }

}
